(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('@keyframes react-loading-skeleton{to{transform:translate(100%)}}.react-loading-skeleton{--base-color: #ebebeb;--highlight-color: #f5f5f5;--animation-duration: 1.5s;--animation-direction: normal;--pseudo-element-display: block;background-color:var(--base-color);width:100%;border-radius:.25rem;display:inline-flex;line-height:1;position:relative;-webkit-user-select:none;user-select:none;overflow:hidden}.react-loading-skeleton:after{content:" ";display:var(--pseudo-element-display);position:absolute;top:0;left:0;right:0;height:100%;background-repeat:no-repeat;background-image:var( --custom-highlight-background, linear-gradient( 90deg, var(--base-color) 0%, var(--highlight-color) 50%, var(--base-color) 100% ) );transform:translate(-100%);animation-name:react-loading-skeleton;animation-direction:var(--animation-direction);animation-duration:var(--animation-duration);animation-timing-function:ease-in-out;animation-iteration-count:infinite}@media (prefers-reduced-motion){.react-loading-skeleton{--pseudo-element-display: none}}.react-loading-skeleton{cursor:progress}.webrms-skeleton-loader-wrapper--list{margin:0 .5rem;cursor:progress}.webrms-skeleton-loader-wrapper--list .skeleton-loader{background:#fff;margin-bottom:.5rem;border-radius:6px;padding:.5rem}.webrms-skeleton-loader-wrapper--list .skeleton-loader span:last-of-type .react-loading-skeleton{margin-bottom:0}.webrms-skeleton-loader-wrapper--list.has-circle .skeleton-loader{height:70px}.webrms-skeleton-loader-wrapper--list.has-circle .skeleton-loader>div{flex-direction:row!important}.webrms-skeleton-loader-wrapper--list.has-circle .skeleton-bars{flex:1;margin-left:.5rem}.webrms-skeleton-loader-wrapper--list.has-circle .skeleton-bars .react-loading-skeleton{margin-bottom:.5rem}.webrms-skeleton-loader-wrapper--list .react-loading-skeleton{border-radius:12px;margin-bottom:.65rem}.webrms-skeleton-loader-wrapper--list .react-loading-skeleton:nth-child(3n){margin-bottom:0}.webrms-skeleton-loader-wrapper--blocks{cursor:progress;display:flex;flex-wrap:wrap;justify-content:space-between;margin:0 1rem}.webrms-skeleton-loader-wrapper--blocks .react-loading-skeleton{margin-bottom:.2rem}.webrms-skeleton-loader-wrapper--blocks .skeleton-loader{border-radius:8px;padding:.5rem;width:23%;background:#fff;border:none;box-shadow:1px 2px 2px #1d1d1d2b;margin-bottom:1rem}@media only screen and (min-width: 673px){.webrms-skeleton-loader-wrapper--blocks .skeleton-loader{font-size:.7rem}}.webrms-skeleton-loader-wrapper--blocks .skeleton-loader span:last-of-type .react-loading-skeleton{margin-bottom:0}.webrms-skeleton-loader-wrapper--blocks.has-circle{justify-content:center}.webrms-skeleton-loader-wrapper--blocks.has-circle .skeleton-loader{display:flex;margin-right:1rem;margin-bottom:1rem;padding:.5rem;height:80px;width:260px;border-radius:12px}.webrms-skeleton-loader-wrapper--blocks.has-circle .skeleton-bars{flex:1;margin-left:.5rem}.webrms-skeleton-loader-wrapper--blocks.has-circle .skeleton-bars .react-loading-skeleton{margin-bottom:.5rem}.skeleton-loader-wrapper--simple-form{margin:0 .5rem;cursor:progress}.skeleton-loader-wrapper--simple-form .skeleton-loader{background:#fff;margin-bottom:.5rem;border-radius:4px;padding:.5rem}.skeleton-loader-wrapper--simple-form .skeleton-loader span:last-of-type .react-loading-skeleton{margin-bottom:0}.skeleton-loader-wrapper--simple-form .react-loading-skeleton{border-radius:12px;margin-bottom:.65rem}.skeleton-loader-wrapper--simple-form .react-loading-skeleton:nth-child(3n){margin-bottom:0}._releaseIcon_jr1n5_1{display:inline-flex;align-items:center;justify-content:center;padding:0 8px;min-width:60px;height:30px;border-radius:16px;background:#19a69a;color:#fff;letter-spacing:1px;text-align:center;text-transform:uppercase;font-weight:600;font-size:16px}._small_jr1n5_18{min-width:32px;height:16px;padding:0 2px;font-size:8px}._extraSmall_jr1n5_25{min-width:20px;height:10px;letter-spacing:.5px;font-size:6px;font-weight:500;padding:0}._blue_jr1n5_34{background:#1f8fe1}.tooltip-container{--tooltipBackground: #fff;--tooltipBorder: #c0c0c0;--tooltipColor: #000;background-color:var(--tooltipBackground);border-radius:3px;border:1px solid var(--tooltipBorder);box-shadow:0 2px 4px #0000002e;color:var(--tooltipColor);display:flex;flex-direction:column;padding:.4rem;transition:opacity .3s;z-index:9999}.tooltip-container[data-popper-interactive=false]{pointer-events:none}.tooltip-arrow{height:1rem;position:absolute;width:1rem;pointer-events:none}.tooltip-arrow:before{border-style:solid;content:"";display:block;height:0;margin:auto;width:0}.tooltip-arrow:after{border-style:solid;content:"";display:block;height:0;margin:auto;position:absolute;width:0}.tooltip-container[data-popper-placement*=bottom] .tooltip-arrow{left:0;margin-top:-.4rem;top:0}.tooltip-container[data-popper-placement*=bottom] .tooltip-arrow:before{border-color:transparent transparent var(--tooltipBorder) transparent;border-width:0 .5rem .4rem .5rem;position:absolute;top:-1px}.tooltip-container[data-popper-placement*=bottom] .tooltip-arrow:after{border-color:transparent transparent var(--tooltipBackground) transparent;border-width:0 .5rem .4rem .5rem}.tooltip-container[data-popper-placement*=top] .tooltip-arrow{bottom:0;left:0;margin-bottom:-1rem}.tooltip-container[data-popper-placement*=top] .tooltip-arrow:before{border-color:var(--tooltipBorder) transparent transparent transparent;border-width:.4rem .5rem 0 .5rem;position:absolute;top:1px}.tooltip-container[data-popper-placement*=top] .tooltip-arrow:after{border-color:var(--tooltipBackground) transparent transparent transparent;border-width:.4rem .5rem 0 .5rem}.tooltip-container[data-popper-placement*=right] .tooltip-arrow{left:0;margin-left:-.7rem}.tooltip-container[data-popper-placement*=right] .tooltip-arrow:before{border-color:transparent var(--tooltipBorder) transparent transparent;border-width:.5rem .4rem .5rem 0}.tooltip-container[data-popper-placement*=right] .tooltip-arrow:after{border-color:transparent var(--tooltipBackground) transparent transparent;border-width:.5rem .4rem .5rem 0;left:6px;top:0}.tooltip-container[data-popper-placement*=left] .tooltip-arrow{margin-right:-.7rem;right:0}.tooltip-container[data-popper-placement*=left] .tooltip-arrow:before{border-color:transparent transparent transparent var(--tooltipBorder);border-width:.5rem 0 .5rem .4em}.tooltip-container[data-popper-placement*=left] .tooltip-arrow:after{border-color:transparent transparent transparent var(--tooltipBackground);border-width:.5rem 0 .5rem .4em;left:3px;top:0}.umaiReactModalPortal .ReactModal__Overlay{font-family:-apple-system,BlinkMacSystemFont,SF Display,Segoe UI,Roboto,Helvetica,Arial,sans-serif;background-color:#00000059!important;z-index:10000;opacity:0;transition:opacity .3s ease-out}.umaiReactModalPortal .ReactModal__Overlay--after-open{opacity:1}.umaiReactModalPortal .ReactModal__Overlay--before-open{opacity:0}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content{padding:0!important;border-radius:1rem!important;box-shadow:0 2px 4px 2px #0000002f;max-height:95vh;left:50%!important;border:none!important;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;will-change:transform,opacity;opacity:0;transform:translate(-50%,calc(-50% + 30px))!important;transition:transform .25s cubic-bezier(.34,1.4,.64,1),opacity .25s cubic-bezier(.34,1.4,.64,1)!important}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content--after-open{opacity:1;transform:translate(-50%,-50%)!important}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content--before-close{opacity:0;transform:translate(-50%,calc(-50% + 30px))!important}@media only screen and (max-width: 672px){.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content{left:50%!important;width:95%}}@media (prefers-reduced-motion: reduce){.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .ReactModal__Content{transform:translate(-50%,-50%)!important;transition:opacity .2s ease-out!important}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .ReactModal__Content--after-open,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .ReactModal__Content--before-close{transform:translate(-50%,-50%)!important}}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .popup-header{display:flex}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup{all:unset;position:sticky;top:10px;z-index:3;width:35px;height:35px;cursor:pointer;display:flex;justify-content:center;align-items:center}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back:focus-visible,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup:focus-visible{outline:1px solid #1f8fe1}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back:hover,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup:hover{background-color:#0000000d;transform:scale(1.05)}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back:active,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup:active{transform:scale(.95)}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back:disabled,.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup:disabled{opacity:.6;cursor:not-allowed;transform:none}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .close-popup{left:calc(100% - 45px)}.umaiReactModalPortal .ReactModal__Overlay .ReactModal__Content .go-back{right:calc(100% - 45px)}.umaiReactModalPortal .ReactModal__Content{top:50%;left:50%;right:auto;bottom:auto;margin-right:-50%;border-radius:16px}.umaiReactModalPortal .ReactModal__Content *,.umaiReactModalPortal .ReactModal__Content *:before,.umaiReactModalPortal .ReactModal__Content *:after{box-sizing:border-box}._container_smntf_1{display:flex;align-items:center}._container_smntf_1 ._textLabel_smntf_5{flex:1;white-space:nowrap;margin:0 .5rem 0 0;margin-bottom:0;color:#000;font-size:pxToRem(14);cursor:pointer}._toggle_smntf_15{flex:1}._toggle_smntf_15 ._toggleLabel_smntf_18{display:block;margin:0;cursor:pointer}._toggle_smntf_15 ._checkboxInput_smntf_23{margin:0;opacity:0;width:0;height:0;-webkit-user-select:none;user-select:none}._toggle_smntf_15 ._checkboxInput_smntf_23:focus-visible{box-shadow:0 0 0 1px #1f8fe1}._toggle_smntf_15 ._checkboxInput_smntf_23:not(:checked)+._lever_smntf_33{background-color:#e9e9ea}._toggle_smntf_15 ._checkboxInput_smntf_23:checked+._lever_smntf_33{background-color:#19a69a}._toggle_smntf_15 ._checkboxInput_smntf_23:checked+._lever_smntf_33:after{background-color:#fff;left:calc(50% - 4px)}._toggle_smntf_15 ._checkboxInput_smntf_23[disabled]+._lever_smntf_33{cursor:not-allowed;opacity:.4;background-color:#d9d9d9}._toggle_smntf_15 ._lever_smntf_33{content:"";display:inline-block;position:relative;width:51px;height:31px;background-color:#fff;border-radius:50px;transition:background-color .3s ease;vertical-align:middle;margin:0;cursor:pointer;-webkit-user-select:none;user-select:none}._toggle_smntf_15 ._lever_smntf_33:after{content:"";position:absolute;left:2px;top:2px;display:inline-block;width:27px;height:27px;border-radius:50%;transition:left .3s ease,background-color .3s ease,box-shadow .1s ease,transform .1s ease;background-color:#fff;box-shadow:0 3px 8px #00000026}._toggle_smntf_15 ._lever_smntf_33._focused_smntf_76{box-shadow:0 0 0 1px #ffffffb3,0 0 0 2px #1f8fe1}._toggle_smntf_15._isSmall_smntf_79 ._lever_smntf_33{width:40px;height:24px}._toggle_smntf_15._isSmall_smntf_79 ._lever_smntf_33:after{left:1px;top:1px;width:22px;height:22px}._toggle_smntf_15._isSmall_smntf_79 ._checkboxInput_smntf_23:checked+._lever_smntf_33:after{left:calc(50% - 3px)}._checkbox_148ma_1{position:relative;height:24px;width:24px;display:block!important;margin-bottom:0!important}._checkbox_148ma_1._static_148ma_8{pointer-events:none}._checkbox_148ma_1>svg{position:absolute;top:7px;left:5px;cursor:pointer}._checkbox_148ma_1 ._disabledCheckMark_148ma_17{cursor:default}._checkbox_148ma_1>input{margin:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:24px;width:24px;border-radius:24px;background-color:#fff;outline:0!important;cursor:pointer;transition:background-color .2s ease-out}._checkbox_148ma_1>input:checked{border:0;background-color:#19a69a}._checkbox_148ma_1>input:disabled{border:0;background-color:#c7c7cd;cursor:default}._checkbox_148ma_1 ._hasGreyBackground_148ma_40:checked{background-color:#c7c7cd}._checkbox_148ma_1 ._hasBorder_148ma_43{border:1px solid #c7c7cd}._checkboxMenu_d20zh_1{position:relative;display:inline-block}._checkboxMenu_d20zh_1 ._button_d20zh_5{position:relative;padding:.375rem 1.875rem .375rem .625rem;border:0;background:#f4f4f4;box-shadow:0 1px 1px #0000004a;border-radius:4px;font-size:1rem;line-height:1.1875rem;color:#000;cursor:pointer;background-repeat:no-repeat;background-position:right 10px top 50%}._checkboxMenu_d20zh_1 ._button_d20zh_5:focus-visible{outline:1px solid #1f8fe1}._checkboxMenu_d20zh_1 ._button_d20zh_5:active{top:unset;box-shadow:0 1px 1px #0000004a}._checkboxMenu_d20zh_1 ._button_d20zh_5:disabled{cursor:default}._checkboxMenu_d20zh_1 ._arrowIcon_d20zh_29{position:absolute;right:10px;top:12px}._checkboxMenu_d20zh_1 ._popup_d20zh_34{padding:0 20px}._checkboxMenu_d20zh_1 ._option_d20zh_37{min-height:3.0625rem;min-width:7.5rem;border:0;border-bottom:1px solid #d9d9d9;background:transparent;border-radius:0;box-shadow:none;transition:none;font-size:1rem;line-height:1.1875rem;text-align:left;cursor:pointer;padding:.75rem 0;display:grid;grid-auto-flow:column;align-items:center;justify-content:space-between;white-space:pre-line;word-break:break-word;outline:none}._checkboxMenu_d20zh_1 ._option_d20zh_37:hover,._checkboxMenu_d20zh_1 ._option_d20zh_37:focus-visible{outline:none;color:#19a69a}._checkboxMenu_d20zh_1 ._option_d20zh_37 label{margin-left:.9375rem}._checkboxMenu_d20zh_1 ._option_d20zh_37 svg{vertical-align:text-top}._checkboxMenu_d20zh_1 ._option_d20zh_37:last-of-type{border-bottom:0}._checkboxButtonGroup_jb8kc_1 ._buttonList_jb8kc_1{margin:.9375rem 0;padding:0;list-style:none;display:flex;flex-wrap:wrap;column-gap:1rem;row-gap:.5rem}._checkboxButtonGroup_jb8kc_1 ._checkboxButton_jb8kc_1{padding:.625rem .75rem;background:#fff;border-radius:8px;box-shadow:0 3px 6px #0000004a;font-size:1rem;line-height:1.1875rem;display:flex;align-items:center;border:0;outline:none!important;cursor:pointer}._checkboxButtonGroup_jb8kc_1 ._checkboxButton_jb8kc_1>*:first-child{margin-right:.4375rem}._cropper_dydpj_1{padding:.625rem}._cropper_dydpj_1 img{max-width:100%}._cropControls_dydpj_8{padding:10px 5px;display:flex;justify-content:space-around;align-items:center;gap:.625rem;flex-flow:row wrap;background-color:#f4f4f4;border-radius:.5rem}._cropControls_dydpj_8>*{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;gap:.625rem;margin-bottom:.625rem;font-size:.875rem;font-weight:400;line-height:1.0625rem}._cropControls_dydpj_8 label{font-size:.875rem;font-weight:400;color:#000;line-height:1.0625rem}._cropControls_dydpj_8 input[type=range]{width:6.25rem;border-radius:.25rem;accent-color:#19a69a;box-shadow:3px 3px 4px #00000040,-2px -2px 3px #ffffff4d}._cropControls_dydpj_8 input[type=range]:hover{box-shadow:2px 2px 3px #00000040,-1px -1px 2px #ffffff4d}._cropControls_dydpj_8 ._toggle_dydpj_44{border-radius:1rem}._cropControls_dydpj_8 ._toggle_dydpj_44 span{background:linear-gradient(-45deg,#00000038,#ffffff40);box-shadow:3px 3px 4px #00000040,-2px -2px 3px #ffffff4d}._cropControls_dydpj_8 ._toggle_dydpj_44 span:hover{box-shadow:1px 1px 2px #00000040,-1px -1px 2px #ffffff4d}._cropControls_dydpj_8 input[type=number]{width:8.125rem;height:2.1875rem;padding:.375rem 1.875rem .375rem .625rem;border:0;background:#f4f4f4;box-shadow:0 1px 1px #0000004a;border-radius:.25rem;font-size:1rem!important;line-height:1.1875rem!important;color:#000;background-repeat:no-repeat;background-position:right 10px top 50%;text-align:right;width:3.75rem;padding:0 .3125rem;text-align:center;background:linear-gradient(135deg,#00000003,#ffffffe6);box-shadow:inset 1px 1px 2px #00000040,inset -1px -1px 2px #ffffff4d}._cropControls_dydpj_8 input[type=number]:focus-visible{outline:1px solid #1f8fe1}._cropControls_dydpj_8 input[type=number]._hasError_dydpj_77{outline:2px solid #e65359}._cropControls_dydpj_8 input[type=number]:disabled{cursor:not-allowed}._cropControls_dydpj_8 input[type=number]:hover{box-shadow:inset 0 0 1px #00000040,inset 0 0 1px #ffffff4d}._cropControlButtons_dydpj_87{display:flex;justify-content:center;gap:10px}._cropControlButtons_dydpj_87 button{border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;background-color:#19a69a;border:1px solid #19a69a;color:#fff;border-radius:.5rem;box-shadow:0 2px 4px #00000029;height:36px;padding:.3125rem .625rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;box-shadow:3px 3px 4px #00000040,-2px -2px 3px #ffffff4d}._cropControlButtons_dydpj_87 button:hover{background-color:#169085;color:#fff;box-shadow:1px 1px 2px #00000040,-1px -1px 2px #ffffff4d}._cropControlButtons_dydpj_87 button:focus{outline:none}._cropControlButtons_dydpj_87 button:focus-visible{outline:1px solid #1f8fe1}._cropControlButtons_dydpj_87 button:disabled{cursor:not-allowed;box-shadow:none;background-color:#d9d9d9;border-color:#d9d9d9}._cropControlButtons_dydpj_87 button:disabled:hover{box-shadow:none;background-color:#d9d9d9}._previewCanvas_dydpj_144{margin-top:.9375rem}._previewCanvas_dydpj_144 canvas{border-radius:.5rem;border:1px solid #c7c7cd;object-fit:contain;box-shadow:1px 1px 6px #00000080}@keyframes marching-ants{0%{background-position:0 0,0 100%,0 0,100% 0}to{background-position:20px 0,-20px 100%,0 -20px,100% 20px}}:root{--rc-drag-handle-size: 12px;--rc-drag-handle-mobile-size: 24px;--rc-drag-handle-bg-colour: rgba(0, 0, 0, .2);--rc-drag-bar-size: 6px;--rc-border-color: rgba(255, 255, 255, .7);--rc-focus-color: #0088ff}.ReactCrop{position:relative;display:inline-block;cursor:crosshair;max-width:100%}.ReactCrop *,.ReactCrop *:before,.ReactCrop *:after{box-sizing:border-box}.ReactCrop--disabled,.ReactCrop--locked{cursor:inherit}.ReactCrop__child-wrapper{overflow:hidden;max-height:inherit}.ReactCrop__child-wrapper>img,.ReactCrop__child-wrapper>video{display:block;max-width:100%;max-height:inherit}.ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper>img,.ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper>video{touch-action:none}.ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection{touch-action:none}.ReactCrop__crop-mask{position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}.ReactCrop__crop-selection{position:absolute;top:0;left:0;transform:translateZ(0);cursor:move}.ReactCrop--disabled .ReactCrop__crop-selection{cursor:inherit}.ReactCrop--circular-crop .ReactCrop__crop-selection{border-radius:50%}.ReactCrop--circular-crop .ReactCrop__crop-selection:after{pointer-events:none;content:"";position:absolute;top:-1px;right:-1px;bottom:-1px;left:-1px;border:1px solid var(--rc-border-color);opacity:.3}.ReactCrop--no-animate .ReactCrop__crop-selection{outline:1px dashed white}.ReactCrop__crop-selection:not(.ReactCrop--no-animate .ReactCrop__crop-selection){animation:marching-ants 1s;background-image:linear-gradient(to right,#fff 50%,#444 50%),linear-gradient(to right,#fff 50%,#444 50%),linear-gradient(to bottom,#fff 50%,#444 50%),linear-gradient(to bottom,#fff 50%,#444 50%);background-size:10px 1px,10px 1px,1px 10px,1px 10px;background-position:0 0,0 100%,0 0,100% 0;background-repeat:repeat-x,repeat-x,repeat-y,repeat-y;color:#fff;animation-play-state:running;animation-timing-function:linear;animation-iteration-count:infinite}.ReactCrop__crop-selection:focus{outline:2px solid var(--rc-focus-color);outline-offset:-1px}.ReactCrop--invisible-crop .ReactCrop__crop-mask,.ReactCrop--invisible-crop .ReactCrop__crop-selection{display:none}.ReactCrop__rule-of-thirds-vt:before,.ReactCrop__rule-of-thirds-vt:after,.ReactCrop__rule-of-thirds-hz:before,.ReactCrop__rule-of-thirds-hz:after{content:"";display:block;position:absolute;background-color:#fff6}.ReactCrop__rule-of-thirds-vt:before,.ReactCrop__rule-of-thirds-vt:after{width:1px;height:100%}.ReactCrop__rule-of-thirds-vt:before{left:33.3333333333%}.ReactCrop__rule-of-thirds-vt:after{left:66.6666666667%}.ReactCrop__rule-of-thirds-hz:before,.ReactCrop__rule-of-thirds-hz:after{width:100%;height:1px}.ReactCrop__rule-of-thirds-hz:before{top:33.3333333333%}.ReactCrop__rule-of-thirds-hz:after{top:66.6666666667%}.ReactCrop__drag-handle{position:absolute;width:var(--rc-drag-handle-size);height:var(--rc-drag-handle-size);background-color:var(--rc-drag-handle-bg-colour);border:1px solid var(--rc-border-color)}.ReactCrop__drag-handle:focus{background:var(--rc-focus-color)}.ReactCrop .ord-nw{top:0;left:0;transform:translate(-50%,-50%);cursor:nw-resize}.ReactCrop .ord-n{top:0;left:50%;transform:translate(-50%,-50%);cursor:n-resize}.ReactCrop .ord-ne{top:0;right:0;transform:translate(50%,-50%);cursor:ne-resize}.ReactCrop .ord-e{top:50%;right:0;transform:translate(50%,-50%);cursor:e-resize}.ReactCrop .ord-se{bottom:0;right:0;transform:translate(50%,50%);cursor:se-resize}.ReactCrop .ord-s{bottom:0;left:50%;transform:translate(-50%,50%);cursor:s-resize}.ReactCrop .ord-sw{bottom:0;left:0;transform:translate(-50%,50%);cursor:sw-resize}.ReactCrop .ord-w{top:50%;left:0;transform:translate(-50%,-50%);cursor:w-resize}.ReactCrop__disabled .ReactCrop__drag-handle{cursor:inherit}.ReactCrop__drag-bar{position:absolute}.ReactCrop__drag-bar.ord-n{top:0;left:0;width:100%;height:var(--rc-drag-bar-size);transform:translateY(-50%)}.ReactCrop__drag-bar.ord-e{right:0;top:0;width:var(--rc-drag-bar-size);height:100%;transform:translate(50%)}.ReactCrop__drag-bar.ord-s{bottom:0;left:0;width:100%;height:var(--rc-drag-bar-size);transform:translateY(50%)}.ReactCrop__drag-bar.ord-w{top:0;left:0;width:var(--rc-drag-bar-size);height:100%;transform:translate(-50%)}.ReactCrop--new-crop .ReactCrop__drag-bar,.ReactCrop--new-crop .ReactCrop__drag-handle,.ReactCrop--fixed-aspect .ReactCrop__drag-bar,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w{display:none}@media (pointer: coarse){.ReactCrop .ord-n,.ReactCrop .ord-e,.ReactCrop .ord-s,.ReactCrop .ord-w{display:none}.ReactCrop__drag-handle{width:var(--rc-drag-handle-mobile-size);height:var(--rc-drag-handle-mobile-size)}}._closeButton_1th4j_2{position:absolute!important}._modal_1th4j_6{display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#fff;padding:2.4375rem 4.6875rem;border-radius:1rem;width:540px}@media (max-width: 672px){._modal_1th4j_6{width:100%;padding:1.25rem 2.5rem}}._modal_1th4j_6 ._header_1th4j_22{font-weight:400;color:#19a69a;margin:0;margin-bottom:1rem}._modal_1th4j_6 ._title_1th4j_28{color:#000;font-size:1.125rem;font-weight:500;text-align:center;line-height:1.3125rem;margin:0;margin-bottom:1.5rem}._modal_1th4j_6 ._description_1th4j_37{color:#5d6572;font-size:.875rem;line-height:1.0625rem;font-weight:400;margin:0;margin-bottom:1.5rem}._modal_1th4j_6 ._subtitle_1th4j_45{color:#19a69a;font-size:1rem;font-weight:500;line-height:1.1875rem;text-align:center;margin:0}._proIcon_1apzh_1{display:inline-flex;align-items:center;justify-content:center;padding:0 .1875rem;background:linear-gradient(#fff,#fff) padding-box,linear-gradient(to right,#42047e,#2a2baa,#1250d5) border-box;border-radius:.25rem;border:1px solid transparent}._proIcon_1apzh_1 ._labelText_1apzh_10{font-weight:400;font-size:.75rem;line-height:.9375rem;color:#2a2baa;background:linear-gradient(to right,#42047e,#2a2baa,#1250d5);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #1f8fe1;--toastify-color-success: #19a69a;--toastify-color-warning: #e5ab39;--toastify-color-error: #eb6464;--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-toast-background: #fff;--toastify-toast-min-height: 40px;--toastify-toast-max-height: 800px;--toastify-font-family: sans-serif;--toastify-z-index: 999999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient( to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55 );--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-toast-width: 95%}@media only screen and (min-width: 1025px){:root{--toastify-toast-width: 60%}}.Toastify__toast{font-size:15px;font-weight:600}@media only screen and (min-width: 673px){.Toastify__toast{border-radius:8px}}.reload-after-online{border-radius:8px;background-color:#fff;color:#000;width:85px;height:30px;border:0;margin-left:10px}')),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import * as L from "react";
import x, { memo as Sc, useState as xe, useLayoutEffect as hr, useEffect as he, useRef as ue, useMemo as kt, createContext as Ba, useContext as ut, PureComponent as kf, createRef as Ei, forwardRef as Pf, useSyncExternalStore as Mf, isValidElement as tn, cloneElement as Ha, useReducer as Ac, createElement as Ca, useDebugValue as kc, useCallback as Pc } from "react";
import W from "prop-types";
import * as Wa from "react-dom";
import Mc, { unstable_batchedUpdates as Df } from "react-dom";
const Lf = x.createContext({}), Dc = !0;
function If({ baseColor: e, highlightColor: t, width: r, height: n, borderRadius: o, circle: a, direction: i, duration: s, enableAnimation: l = Dc, customHighlightBackground: c }) {
  const u = {};
  return i === "rtl" && (u["--animation-direction"] = "reverse"), typeof s == "number" && (u["--animation-duration"] = `${s}s`), l || (u["--pseudo-element-display"] = "none"), (typeof r == "string" || typeof r == "number") && (u.width = r), (typeof n == "string" || typeof n == "number") && (u.height = n), (typeof o == "string" || typeof o == "number") && (u.borderRadius = o), a && (u.borderRadius = "50%"), typeof e < "u" && (u["--base-color"] = e), typeof t < "u" && (u["--highlight-color"] = t), typeof c == "string" && (u["--custom-highlight-background"] = c), u;
}
function pe({ count: e = 1, wrapper: t, className: r, containerClassName: n, containerTestId: o, circle: a = !1, style: i, ...s }) {
  var l, c, u;
  const d = x.useContext(Lf), p = { ...s };
  for (const [O, _] of Object.entries(s))
    typeof _ > "u" && delete p[O];
  const f = {
    ...d,
    ...p,
    circle: a
  }, m = {
    ...i,
    ...If(f)
  };
  let h = "react-loading-skeleton";
  r && (h += ` ${r}`);
  const y = (l = f.inline) !== null && l !== void 0 ? l : !1, b = [], w = Math.ceil(e);
  for (let O = 0; O < w; O++) {
    let _ = m;
    if (w > e && O === w - 1) {
      const A = (c = _.width) !== null && c !== void 0 ? c : "100%", P = e % 1, N = typeof A == "number" ? A * P : `calc(${A} * ${P})`;
      _ = { ..._, width: N };
    }
    const S = x.createElement("span", { className: h, style: _, key: O }, "‌");
    y ? b.push(S) : b.push(x.createElement(
      x.Fragment,
      { key: O },
      S,
      x.createElement("br", null)
    ));
  }
  return x.createElement("span", { className: n, "data-testid": o, "aria-live": "polite", "aria-busy": (u = f.enableAnimation) !== null && u !== void 0 ? u : Dc }, t ? b.map((O, _) => x.createElement(t, { key: _ }, O)) : b);
}
var Ar = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ft(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Nf(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var _n = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ci;
function qf() {
  return Ci || (Ci = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var a = "", i = 0; i < arguments.length; i++) {
          var s = arguments[i];
          s && (a = o(a, n(s)));
        }
        return a;
      }
      function n(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return r.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var i = "";
        for (var s in a)
          t.call(a, s) && a[s] && (i = o(i, s));
        return i;
      }
      function o(a, i) {
        return i ? a ? a + " " + i : a + i : a;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(_n)), _n.exports;
}
var jf = qf();
const fe = /* @__PURE__ */ Ft(jf), Lc = ({ lines: e = 10, circle: t = !1 }) => {
  const r = () => Array.from(Array(e).keys()).map((o, a) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ x.createElement("div", { className: "skeleton-loader", key: `loader-${a}` }, t ? /* @__PURE__ */ x.createElement("div", { style: { display: "flex", flexDirection: "column" } }, /* @__PURE__ */ x.createElement(pe, { count: 1, height: 40, width: 40, circle: !0 }), /* @__PURE__ */ x.createElement("div", { className: "skeleton-bars" }, /* @__PURE__ */ x.createElement(pe, { width: "45%" }), /* @__PURE__ */ x.createElement(pe, { width: "60%" }))) : /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(pe, { width: "45%" }), /* @__PURE__ */ x.createElement(pe, { width: "75%" }), /* @__PURE__ */ x.createElement(pe, { width: "60%" })))
  ));
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: fe("webrms-skeleton-loader-wrapper--list", { "has-circle": t }),
      "data-testid": "skeleton-loader"
    },
    r()
  );
};
Lc.propTypes = {
  lines: W.number,
  circle: W.bool
};
const Ic = ({
  blockStyles: e = { height: "65px" },
  circle: t = !1,
  numBlocks: r = 21,
  lines: n = ["45%", "75%", "60%"],
  className: o
}) => /* @__PURE__ */ x.createElement(
  "div",
  {
    className: fe("webrms-skeleton-loader-wrapper--blocks", o, {
      "has-circle": t
    })
  },
  [...Array(r)].map((a, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ x.createElement("div", { className: "skeleton-loader", style: e, key: `loader-${i}` }, t ? /* @__PURE__ */ x.createElement(
      pe,
      {
        className: "skeleton-circle",
        circle: !0,
        style: { display: "flex" },
        height: "50px",
        width: "50px"
      }
    ) : null, /* @__PURE__ */ x.createElement("div", { className: "skeleton-bars" }, n.map((s, l) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ x.createElement(pe, { width: s, key: `${s}-${l}` })
    ))))
  ))
);
Ic.propTypes = {
  blockStyles: W.object,
  circle: W.bool,
  numBlocks: W.number,
  lines: W.arrayOf(W.string),
  className: W.string
};
const Ff = () => {
  const e = () => Array.from(Array(4).keys()).map((r, n) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ x.createElement("div", { className: "skeleton-loader", key: `loader-${n}` }, /* @__PURE__ */ x.createElement(pe, { width: "45%" }), /* @__PURE__ */ x.createElement(pe, { width: "75%" }), /* @__PURE__ */ x.createElement(pe, { width: "60%" }))
  ));
  return /* @__PURE__ */ x.createElement("div", { className: "skeleton-loader-wrapper--simple-form" }, /* @__PURE__ */ x.createElement("div", { className: "skeleton-loader" }, /* @__PURE__ */ x.createElement(pe, { width: "45%" }), /* @__PURE__ */ x.createElement(pe, { width: "75%" }), /* @__PURE__ */ x.createElement(pe, { width: "60%" }), /* @__PURE__ */ x.createElement(pe, { width: "60%" })), e());
}, Cb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blocks: Ic,
  List: Lc,
  SimpleForm: Ff,
  Skeleton: pe
}, Symbol.toStringTag, { value: "Module" })), $f = "_releaseIcon_jr1n5_1", Bf = "_small_jr1n5_18", Hf = "_extraSmall_jr1n5_25", Wf = "_blue_jr1n5_34", kr = {
  releaseIcon: $f,
  small: Bf,
  extraSmall: Hf,
  blue: Wf
}, Uf = ({ label: e = "BETA", small: t, extraSmall: r, blue: n }) => /* @__PURE__ */ x.createElement(
  "span",
  {
    className: fe(kr.releaseIcon, {
      [kr.small]: t,
      [kr.extraSmall]: r,
      [kr.blue]: n
    })
  },
  e
);
Uf.propTypes = {
  label: W.string,
  small: W.bool,
  extraSmall: W.bool,
  blue: W.bool
};
function Vf(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function Ve() {
  return Ve = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ve.apply(this, arguments);
}
var xi = function(t) {
  return t.reduce(function(r, n) {
    var o = n[0], a = n[1];
    return r[o] = a, r;
  }, {});
}, Ti = typeof window < "u" && window.document && window.document.createElement ? L.useLayoutEffect : L.useEffect, be = "top", Pe = "bottom", Me = "right", we = "left", Ua = "auto", vr = [be, Pe, Me, we], Mt = "start", ir = "end", Yf = "clippingParents", Nc = "viewport", Gt = "popper", zf = "reference", Oi = /* @__PURE__ */ vr.reduce(function(e, t) {
  return e.concat([t + "-" + Mt, t + "-" + ir]);
}, []), qc = /* @__PURE__ */ [].concat(vr, [Ua]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Mt, t + "-" + ir]);
}, []), Kf = "beforeRead", Gf = "read", Xf = "afterRead", Jf = "beforeMain", Zf = "main", Qf = "afterMain", ed = "beforeWrite", td = "write", rd = "afterWrite", nd = [Kf, Gf, Xf, Jf, Zf, Qf, ed, td, rd];
function Be(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Te(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ht(e) {
  var t = Te(e).Element;
  return e instanceof t || e instanceof Element;
}
function ke(e) {
  var t = Te(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Va(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Te(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function od(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, a = t.elements[r];
    !ke(a) || !Be(a) || (Object.assign(a.style, n), Object.keys(o).forEach(function(i) {
      var s = o[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function ad(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], a = t.attributes[n] || {}, i = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = i.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !ke(o) || !Be(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const id = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: od,
  effect: ad,
  requires: ["computeStyles"]
};
function Fe(e) {
  return e.split("-")[0];
}
var ft = Math.max, Ur = Math.min, Dt = Math.round;
function xa() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function jc() {
  return !/^((?!chrome|android).)*safari/i.test(xa());
}
function Lt(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, a = 1;
  t && ke(e) && (o = e.offsetWidth > 0 && Dt(n.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && Dt(n.height) / e.offsetHeight || 1);
  var i = ht(e) ? Te(e) : window, s = i.visualViewport, l = !jc() && r, c = (n.left + (l && s ? s.offsetLeft : 0)) / o, u = (n.top + (l && s ? s.offsetTop : 0)) / a, d = n.width / o, p = n.height / a;
  return {
    width: d,
    height: p,
    top: u,
    right: c + d,
    bottom: u + p,
    left: c,
    x: c,
    y: u
  };
}
function Ya(e) {
  var t = Lt(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Fc(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Va(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Ge(e) {
  return Te(e).getComputedStyle(e);
}
function sd(e) {
  return ["table", "td", "th"].indexOf(Be(e)) >= 0;
}
function it(e) {
  return ((ht(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function rn(e) {
  return Be(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Va(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    it(e)
  );
}
function Ri(e) {
  return !ke(e) || // https://github.com/popperjs/popper-core/issues/837
  Ge(e).position === "fixed" ? null : e.offsetParent;
}
function ld(e) {
  var t = /firefox/i.test(xa()), r = /Trident/i.test(xa());
  if (r && ke(e)) {
    var n = Ge(e);
    if (n.position === "fixed")
      return null;
  }
  var o = rn(e);
  for (Va(o) && (o = o.host); ke(o) && ["html", "body"].indexOf(Be(o)) < 0; ) {
    var a = Ge(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function mr(e) {
  for (var t = Te(e), r = Ri(e); r && sd(r) && Ge(r).position === "static"; )
    r = Ri(r);
  return r && (Be(r) === "html" || Be(r) === "body" && Ge(r).position === "static") ? t : r || ld(e) || t;
}
function za(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function nr(e, t, r) {
  return ft(e, Ur(t, r));
}
function cd(e, t, r) {
  var n = nr(e, t, r);
  return n > r ? r : n;
}
function $c() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Bc(e) {
  return Object.assign({}, $c(), e);
}
function Hc(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var ud = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Bc(typeof t != "number" ? t : Hc(t, vr));
};
function fd(e) {
  var t, r = e.state, n = e.name, o = e.options, a = r.elements.arrow, i = r.modifiersData.popperOffsets, s = Fe(r.placement), l = za(s), c = [we, Me].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!a || !i)) {
    var d = ud(o.padding, r), p = Ya(a), f = l === "y" ? be : we, m = l === "y" ? Pe : Me, h = r.rects.reference[u] + r.rects.reference[l] - i[l] - r.rects.popper[u], y = i[l] - r.rects.reference[l], b = mr(a), w = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, O = h / 2 - y / 2, _ = d[f], S = w - p[u] - d[m], A = w / 2 - p[u] / 2 + O, P = nr(_, A, S), N = l;
    r.modifiersData[n] = (t = {}, t[N] = P, t.centerOffset = P - A, t);
  }
}
function dd(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Fc(t.elements.popper, o) && (t.elements.arrow = o));
}
const pd = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: fd,
  effect: dd,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function It(e) {
  return e.split("-")[1];
}
var hd = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function vd(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Dt(r * o) / o || 0,
    y: Dt(n * o) / o || 0
  };
}
function Si(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, p = i.x, f = p === void 0 ? 0 : p, m = i.y, h = m === void 0 ? 0 : m, y = typeof u == "function" ? u({
    x: f,
    y: h
  }) : {
    x: f,
    y: h
  };
  f = y.x, h = y.y;
  var b = i.hasOwnProperty("x"), w = i.hasOwnProperty("y"), O = we, _ = be, S = window;
  if (c) {
    var A = mr(r), P = "clientHeight", N = "clientWidth";
    if (A === Te(r) && (A = it(r), Ge(A).position !== "static" && s === "absolute" && (P = "scrollHeight", N = "scrollWidth")), A = A, o === be || (o === we || o === Me) && a === ir) {
      _ = Pe;
      var j = d && A === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[P]
      );
      h -= j - n.height, h *= l ? 1 : -1;
    }
    if (o === we || (o === be || o === Pe) && a === ir) {
      O = Me;
      var F = d && A === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[N]
      );
      f -= F - n.width, f *= l ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: s
  }, c && hd), I = u === !0 ? vd({
    x: f,
    y: h
  }, Te(r)) : {
    x: f,
    y: h
  };
  if (f = I.x, h = I.y, l) {
    var D;
    return Object.assign({}, M, (D = {}, D[_] = w ? "0" : "", D[O] = b ? "0" : "", D.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + h + "px)" : "translate3d(" + f + "px, " + h + "px, 0)", D));
  }
  return Object.assign({}, M, (t = {}, t[_] = w ? h + "px" : "", t[O] = b ? f + "px" : "", t.transform = "", t));
}
function md(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, a = r.adaptive, i = a === void 0 ? !0 : a, s = r.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: Fe(t.placement),
    variation: It(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Si(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Si(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const gd = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: md,
  data: {}
};
var Pr = {
  passive: !0
};
function yd(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, a = o === void 0 ? !0 : o, i = n.resize, s = i === void 0 ? !0 : i, l = Te(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && c.forEach(function(u) {
    u.addEventListener("scroll", r.update, Pr);
  }), s && l.addEventListener("resize", r.update, Pr), function() {
    a && c.forEach(function(u) {
      u.removeEventListener("scroll", r.update, Pr);
    }), s && l.removeEventListener("resize", r.update, Pr);
  };
}
const bd = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: yd,
  data: {}
};
var wd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Fr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return wd[t];
  });
}
var _d = {
  start: "end",
  end: "start"
};
function Ai(e) {
  return e.replace(/start|end/g, function(t) {
    return _d[t];
  });
}
function Ka(e) {
  var t = Te(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Ga(e) {
  return Lt(it(e)).left + Ka(e).scrollLeft;
}
function Ed(e, t) {
  var r = Te(e), n = it(e), o = r.visualViewport, a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    var c = jc();
    (c || !c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s + Ga(e),
    y: l
  };
}
function Cd(e) {
  var t, r = it(e), n = Ka(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = ft(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = ft(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -n.scrollLeft + Ga(e), l = -n.scrollTop;
  return Ge(o || r).direction === "rtl" && (s += ft(r.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function Xa(e) {
  var t = Ge(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function Wc(e) {
  return ["html", "body", "#document"].indexOf(Be(e)) >= 0 ? e.ownerDocument.body : ke(e) && Xa(e) ? e : Wc(rn(e));
}
function or(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Wc(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Te(n), i = o ? [a].concat(a.visualViewport || [], Xa(n) ? n : []) : n, s = t.concat(i);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(or(rn(i)))
  );
}
function Ta(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function xd(e, t) {
  var r = Lt(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function ki(e, t, r) {
  return t === Nc ? Ta(Ed(e, r)) : ht(t) ? xd(t, r) : Ta(Cd(it(e)));
}
function Td(e) {
  var t = or(rn(e)), r = ["absolute", "fixed"].indexOf(Ge(e).position) >= 0, n = r && ke(e) ? mr(e) : e;
  return ht(n) ? t.filter(function(o) {
    return ht(o) && Fc(o, n) && Be(o) !== "body";
  }) : [];
}
function Od(e, t, r, n) {
  var o = t === "clippingParents" ? Td(e) : [].concat(t), a = [].concat(o, [r]), i = a[0], s = a.reduce(function(l, c) {
    var u = ki(e, c, n);
    return l.top = ft(u.top, l.top), l.right = Ur(u.right, l.right), l.bottom = Ur(u.bottom, l.bottom), l.left = ft(u.left, l.left), l;
  }, ki(e, i, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Uc(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? Fe(n) : null, a = n ? It(n) : null, i = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (o) {
    case be:
      l = {
        x: i,
        y: t.y - r.height
      };
      break;
    case Pe:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case Me:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case we:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = o ? za(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (a) {
      case Mt:
        l[c] = l[c] - (t[u] / 2 - r[u] / 2);
        break;
      case ir:
        l[c] = l[c] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return l;
}
function sr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, a = r.strategy, i = a === void 0 ? e.strategy : a, s = r.boundary, l = s === void 0 ? Yf : s, c = r.rootBoundary, u = c === void 0 ? Nc : c, d = r.elementContext, p = d === void 0 ? Gt : d, f = r.altBoundary, m = f === void 0 ? !1 : f, h = r.padding, y = h === void 0 ? 0 : h, b = Bc(typeof y != "number" ? y : Hc(y, vr)), w = p === Gt ? zf : Gt, O = e.rects.popper, _ = e.elements[m ? w : p], S = Od(ht(_) ? _ : _.contextElement || it(e.elements.popper), l, u, i), A = Lt(e.elements.reference), P = Uc({
    reference: A,
    element: O,
    placement: o
  }), N = Ta(Object.assign({}, O, P)), j = p === Gt ? N : A, F = {
    top: S.top - j.top + b.top,
    bottom: j.bottom - S.bottom + b.bottom,
    left: S.left - j.left + b.left,
    right: j.right - S.right + b.right
  }, M = e.modifiersData.offset;
  if (p === Gt && M) {
    var I = M[o];
    Object.keys(F).forEach(function(D) {
      var T = [Me, Pe].indexOf(D) >= 0 ? 1 : -1, R = [be, Pe].indexOf(D) >= 0 ? "y" : "x";
      F[D] += I[R] * T;
    });
  }
  return F;
}
function Rd(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, a = r.rootBoundary, i = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, c = l === void 0 ? qc : l, u = It(n), d = u ? s ? Oi : Oi.filter(function(m) {
    return It(m) === u;
  }) : vr, p = d.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  p.length === 0 && (p = d);
  var f = p.reduce(function(m, h) {
    return m[h] = sr(e, {
      placement: h,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[Fe(h)], m;
  }, {});
  return Object.keys(f).sort(function(m, h) {
    return f[m] - f[h];
  });
}
function Sd(e) {
  if (Fe(e) === Ua)
    return [];
  var t = Fr(e);
  return [Ai(e), t, Ai(t)];
}
function Ad(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, a = o === void 0 ? !0 : o, i = r.altAxis, s = i === void 0 ? !0 : i, l = r.fallbackPlacements, c = r.padding, u = r.boundary, d = r.rootBoundary, p = r.altBoundary, f = r.flipVariations, m = f === void 0 ? !0 : f, h = r.allowedAutoPlacements, y = t.options.placement, b = Fe(y), w = b === y, O = l || (w || !m ? [Fr(y)] : Sd(y)), _ = [y].concat(O).reduce(function(z, Q) {
      return z.concat(Fe(Q) === Ua ? Rd(t, {
        placement: Q,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: h
      }) : Q);
    }, []), S = t.rects.reference, A = t.rects.popper, P = /* @__PURE__ */ new Map(), N = !0, j = _[0], F = 0; F < _.length; F++) {
      var M = _[F], I = Fe(M), D = It(M) === Mt, T = [be, Pe].indexOf(I) >= 0, R = T ? "width" : "height", g = sr(t, {
        placement: M,
        boundary: u,
        rootBoundary: d,
        altBoundary: p,
        padding: c
      }), v = T ? D ? Me : we : D ? Pe : be;
      S[R] > A[R] && (v = Fr(v));
      var E = Fr(v), k = [];
      if (a && k.push(g[I] <= 0), s && k.push(g[v] <= 0, g[E] <= 0), k.every(function(z) {
        return z;
      })) {
        j = M, N = !1;
        break;
      }
      P.set(M, k);
    }
    if (N)
      for (var q = m ? 3 : 1, H = function(Q) {
        var re = _.find(function(ne) {
          var K = P.get(ne);
          if (K)
            return K.slice(0, Q).every(function(ae) {
              return ae;
            });
        });
        if (re)
          return j = re, "break";
      }, V = q; V > 0; V--) {
        var J = H(V);
        if (J === "break") break;
      }
    t.placement !== j && (t.modifiersData[n]._skip = !0, t.placement = j, t.reset = !0);
  }
}
const kd = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Ad,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Pi(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Mi(e) {
  return [be, Me, Pe, we].some(function(t) {
    return e[t] >= 0;
  });
}
function Pd(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, i = sr(t, {
    elementContext: "reference"
  }), s = sr(t, {
    altBoundary: !0
  }), l = Pi(i, n), c = Pi(s, o, a), u = Mi(l), d = Mi(c);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const Md = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Pd
};
function Dd(e, t, r) {
  var n = Fe(e), o = [we, be].indexOf(n) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * o, [we, Me].indexOf(n) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function Ld(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, a = o === void 0 ? [0, 0] : o, i = qc.reduce(function(u, d) {
    return u[d] = Dd(d, t.rects, a), u;
  }, {}), s = i[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[n] = i;
}
const Id = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ld
};
function Nd(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Uc({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const qd = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Nd,
  data: {}
};
function jd(e) {
  return e === "x" ? "y" : "x";
}
function Fd(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, a = o === void 0 ? !0 : o, i = r.altAxis, s = i === void 0 ? !1 : i, l = r.boundary, c = r.rootBoundary, u = r.altBoundary, d = r.padding, p = r.tether, f = p === void 0 ? !0 : p, m = r.tetherOffset, h = m === void 0 ? 0 : m, y = sr(t, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), b = Fe(t.placement), w = It(t.placement), O = !w, _ = za(b), S = jd(_), A = t.modifiersData.popperOffsets, P = t.rects.reference, N = t.rects.popper, j = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, F = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, I = {
    x: 0,
    y: 0
  };
  if (A) {
    if (a) {
      var D, T = _ === "y" ? be : we, R = _ === "y" ? Pe : Me, g = _ === "y" ? "height" : "width", v = A[_], E = v + y[T], k = v - y[R], q = f ? -N[g] / 2 : 0, H = w === Mt ? P[g] : N[g], V = w === Mt ? -N[g] : -P[g], J = t.elements.arrow, z = f && J ? Ya(J) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : $c(), re = Q[T], ne = Q[R], K = nr(0, P[g], z[g]), ae = O ? P[g] / 2 - q - K - re - F.mainAxis : H - K - re - F.mainAxis, de = O ? -P[g] / 2 + q + K + ne + F.mainAxis : V + K + ne + F.mainAxis, ve = t.elements.arrow && mr(t.elements.arrow), Ce = ve ? _ === "y" ? ve.clientTop || 0 : ve.clientLeft || 0 : 0, yt = (D = M == null ? void 0 : M[_]) != null ? D : 0, Wt = v + ae - yt - Ce, Ze = v + de - yt, Qe = nr(f ? Ur(E, Wt) : E, v, f ? ft(k, Ze) : k);
      A[_] = Qe, I[_] = Qe - v;
    }
    if (s) {
      var Ut, Or = _ === "x" ? be : we, bt = _ === "x" ? Pe : Me, Ue = A[S], wt = S === "y" ? "height" : "width", _t = Ue + y[Or], Rr = Ue - y[bt], Vt = [be, we].indexOf(b) !== -1, Yt = (Ut = M == null ? void 0 : M[S]) != null ? Ut : 0, zt = Vt ? _t : Ue - P[wt] - N[wt] - Yt + F.altAxis, Kt = Vt ? Ue + P[wt] + N[wt] - Yt - F.altAxis : Rr, Sr = f && Vt ? cd(zt, Ue, Kt) : nr(f ? zt : _t, Ue, f ? Kt : Rr);
      A[S] = Sr, I[S] = Sr - Ue;
    }
    t.modifiersData[n] = I;
  }
}
const $d = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Fd,
  requiresIfExists: ["offset"]
};
function Bd(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Hd(e) {
  return e === Te(e) || !ke(e) ? Ka(e) : Bd(e);
}
function Wd(e) {
  var t = e.getBoundingClientRect(), r = Dt(t.width) / e.offsetWidth || 1, n = Dt(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Ud(e, t, r) {
  r === void 0 && (r = !1);
  var n = ke(t), o = ke(t) && Wd(t), a = it(t), i = Lt(e, o, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Be(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Xa(a)) && (s = Hd(t)), ke(t) ? (l = Lt(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = Ga(a))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function Vd(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    r.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && o(l);
      }
    }), n.push(a);
  }
  return e.forEach(function(a) {
    r.has(a.name) || o(a);
  }), n;
}
function Yd(e) {
  var t = Vd(e);
  return nd.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function zd(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Kd(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Di = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Li() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Gd(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, a = o === void 0 ? Di : o;
  return function(s, l, c) {
    c === void 0 && (c = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Di, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, f = {
      state: u,
      setOptions: function(b) {
        var w = typeof b == "function" ? b(u.options) : b;
        h(), u.options = Object.assign({}, a, u.options, w), u.scrollParents = {
          reference: ht(s) ? or(s) : s.contextElement ? or(s.contextElement) : [],
          popper: or(l)
        };
        var O = Yd(Kd([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = O.filter(function(_) {
          return _.enabled;
        }), m(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var b = u.elements, w = b.reference, O = b.popper;
          if (Li(w, O)) {
            u.rects = {
              reference: Ud(w, mr(O), u.options.strategy === "fixed"),
              popper: Ya(O)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(F) {
              return u.modifiersData[F.name] = Object.assign({}, F.data);
            });
            for (var _ = 0; _ < u.orderedModifiers.length; _++) {
              if (u.reset === !0) {
                u.reset = !1, _ = -1;
                continue;
              }
              var S = u.orderedModifiers[_], A = S.fn, P = S.options, N = P === void 0 ? {} : P, j = S.name;
              typeof A == "function" && (u = A({
                state: u,
                options: N,
                name: j,
                instance: f
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: zd(function() {
        return new Promise(function(y) {
          f.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        h(), p = !0;
      }
    };
    if (!Li(s, l))
      return f;
    f.setOptions(c).then(function(y) {
      !p && c.onFirstUpdate && c.onFirstUpdate(y);
    });
    function m() {
      u.orderedModifiers.forEach(function(y) {
        var b = y.name, w = y.options, O = w === void 0 ? {} : w, _ = y.effect;
        if (typeof _ == "function") {
          var S = _({
            state: u,
            name: b,
            instance: f,
            options: O
          }), A = function() {
          };
          d.push(S || A);
        }
      });
    }
    function h() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return f;
  };
}
var Xd = [bd, qd, gd, id, Id, kd, $d, pd, Md], Jd = /* @__PURE__ */ Gd({
  defaultModifiers: Xd
}), En, Ii;
function Zd() {
  if (Ii) return En;
  Ii = 1;
  var e = typeof Element < "u", t = typeof Map == "function", r = typeof Set == "function", n = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function o(a, i) {
    if (a === i) return !0;
    if (a && i && typeof a == "object" && typeof i == "object") {
      if (a.constructor !== i.constructor) return !1;
      var s, l, c;
      if (Array.isArray(a)) {
        if (s = a.length, s != i.length) return !1;
        for (l = s; l-- !== 0; )
          if (!o(a[l], i[l])) return !1;
        return !0;
      }
      var u;
      if (t && a instanceof Map && i instanceof Map) {
        if (a.size !== i.size) return !1;
        for (u = a.entries(); !(l = u.next()).done; )
          if (!i.has(l.value[0])) return !1;
        for (u = a.entries(); !(l = u.next()).done; )
          if (!o(l.value[1], i.get(l.value[0]))) return !1;
        return !0;
      }
      if (r && a instanceof Set && i instanceof Set) {
        if (a.size !== i.size) return !1;
        for (u = a.entries(); !(l = u.next()).done; )
          if (!i.has(l.value[0])) return !1;
        return !0;
      }
      if (n && ArrayBuffer.isView(a) && ArrayBuffer.isView(i)) {
        if (s = a.length, s != i.length) return !1;
        for (l = s; l-- !== 0; )
          if (a[l] !== i[l]) return !1;
        return !0;
      }
      if (a.constructor === RegExp) return a.source === i.source && a.flags === i.flags;
      if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf == "function" && typeof i.valueOf == "function") return a.valueOf() === i.valueOf();
      if (a.toString !== Object.prototype.toString && typeof a.toString == "function" && typeof i.toString == "function") return a.toString() === i.toString();
      if (c = Object.keys(a), s = c.length, s !== Object.keys(i).length) return !1;
      for (l = s; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(i, c[l])) return !1;
      if (e && a instanceof Element) return !1;
      for (l = s; l-- !== 0; )
        if (!((c[l] === "_owner" || c[l] === "__v" || c[l] === "__o") && a.$$typeof) && !o(a[c[l]], i[c[l]]))
          return !1;
      return !0;
    }
    return a !== a && i !== i;
  }
  return En = function(i, s) {
    try {
      return o(i, s);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, En;
}
var Qd = Zd();
const ep = /* @__PURE__ */ Ft(Qd);
var tp = [], rp = function(t, r, n) {
  n === void 0 && (n = {});
  var o = L.useRef(null), a = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || tp
  }, i = L.useState({
    styles: {
      popper: {
        position: a.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = i[0], l = i[1], c = L.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(f) {
        var m = f.state, h = Object.keys(m.elements);
        Wa.flushSync(function() {
          l({
            styles: xi(h.map(function(y) {
              return [y, m.styles[y] || {}];
            })),
            attributes: xi(h.map(function(y) {
              return [y, m.attributes[y]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), u = L.useMemo(function() {
    var p = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement,
      strategy: a.strategy,
      modifiers: [].concat(a.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return ep(o.current, p) ? o.current || p : (o.current = p, p);
  }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, c]), d = L.useRef();
  return Ti(function() {
    d.current && d.current.setOptions(u);
  }, [u]), Ti(function() {
    if (!(t == null || r == null)) {
      var p = n.createPopper || Jd, f = p(t, r, u);
      return d.current = f, function() {
        f.destroy(), d.current = null;
      };
    }
  }, [t, r, n.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
}, Cn, Ni;
function np() {
  if (Ni) return Cn;
  Ni = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(o, a) {
      var i = arguments.length;
      a = new Array(i > 1 ? i - 1 : 0);
      for (var s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      var l = 0, c = "Warning: " + o.replace(/%s/g, function() {
        return a[l++];
      });
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
    t = function(n, o, a) {
      var i = arguments.length;
      a = new Array(i > 2 ? i - 2 : 0);
      for (var s = 2; s < i; s++)
        a[s - 2] = arguments[s];
      if (o === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [o].concat(a));
    };
  }
  return Cn = t, Cn;
}
function Vc(e) {
  var t = L.useRef(e);
  return t.current = e, L.useCallback(function() {
    return t.current;
  }, []);
}
var op = function() {
};
function ap(e) {
  var t = e.initial, r = e.value, n = e.onChange, o = n === void 0 ? op : n;
  if (t === void 0 && r === void 0)
    throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
  var a = L.useState(t), i = a[0], s = a[1], l = Vc(i), c = L.useCallback(function(d) {
    var p = l(), f = typeof d == "function" ? d(p) : d;
    typeof f.persist == "function" && f.persist(), s(f), typeof o == "function" && o(f);
  }, [l, o]), u = r !== void 0;
  return [u ? r : i, u ? o : c];
}
function Yc(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), function() {
    return {
      width: 0,
      height: 0,
      top: t,
      right: e,
      bottom: t,
      left: e,
      x: 0,
      y: 0,
      toJSON: function() {
        return null;
      }
    };
  };
}
var ip = ["styles", "attributes"], qi = {
  getBoundingClientRect: Yc()
}, ji = {
  closeOnOutsideClick: !0,
  closeOnTriggerHidden: !1,
  defaultVisible: !1,
  delayHide: 0,
  delayShow: 0,
  followCursor: !1,
  interactive: !1,
  mutationObserverOptions: {
    attributes: !0,
    childList: !0,
    subtree: !0
  },
  offset: [0, 6],
  trigger: "hover"
};
function sp(e, t) {
  var r, n, o;
  e === void 0 && (e = {}), t === void 0 && (t = {});
  var a = Object.keys(ji).reduce(function(R, g) {
    var v;
    return Ve({}, R, (v = {}, v[g] = R[g] !== void 0 ? R[g] : ji[g], v));
  }, e), i = L.useMemo(
    function() {
      return [{
        name: "offset",
        options: {
          offset: a.offset
        }
      }];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Array.isArray(a.offset) ? a.offset : []
  ), s = Ve({}, t, {
    placement: t.placement || a.placement,
    modifiers: t.modifiers || i
  }), l = L.useState(null), c = l[0], u = l[1], d = L.useState(null), p = d[0], f = d[1], m = ap({
    initial: a.defaultVisible,
    value: a.visible,
    onChange: a.onVisibleChange
  }), h = m[0], y = m[1], b = L.useRef();
  L.useEffect(function() {
    return function() {
      return clearTimeout(b.current);
    };
  }, []);
  var w = rp(a.followCursor ? qi : c, p, s), O = w.styles, _ = w.attributes, S = Vf(w, ip), A = S.update, P = Vc({
    visible: h,
    triggerRef: c,
    tooltipRef: p,
    finalConfig: a
  }), N = L.useCallback(
    function(R) {
      return Array.isArray(a.trigger) ? a.trigger.includes(R) : a.trigger === R;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Array.isArray(a.trigger) ? a.trigger : [a.trigger]
  ), j = L.useCallback(function() {
    clearTimeout(b.current), b.current = window.setTimeout(function() {
      return y(!1);
    }, a.delayHide);
  }, [a.delayHide, y]), F = L.useCallback(function() {
    clearTimeout(b.current), b.current = window.setTimeout(function() {
      return y(!0);
    }, a.delayShow);
  }, [a.delayShow, y]), M = L.useCallback(function() {
    P().visible ? j() : F();
  }, [P, j, F]);
  L.useEffect(function() {
    if (P().finalConfig.closeOnOutsideClick) {
      var R = function(v) {
        var E, k = P(), q = k.tooltipRef, H = k.triggerRef, V = (v.composedPath == null || (E = v.composedPath()) == null ? void 0 : E[0]) || v.target;
        V instanceof Node && q != null && H != null && !q.contains(V) && !H.contains(V) && j();
      };
      return document.addEventListener("mousedown", R), function() {
        return document.removeEventListener("mousedown", R);
      };
    }
  }, [P, j]), L.useEffect(function() {
    if (!(c == null || !N("click")))
      return c.addEventListener("click", M), function() {
        return c.removeEventListener("click", M);
      };
  }, [c, N, M]), L.useEffect(function() {
    if (!(c == null || !N("double-click")))
      return c.addEventListener("dblclick", M), function() {
        return c.removeEventListener("dblclick", M);
      };
  }, [c, N, M]), L.useEffect(function() {
    if (!(c == null || !N("right-click"))) {
      var R = function(v) {
        v.preventDefault(), M();
      };
      return c.addEventListener("contextmenu", R), function() {
        return c.removeEventListener("contextmenu", R);
      };
    }
  }, [c, N, M]), L.useEffect(function() {
    if (!(c == null || !N("focus")))
      return c.addEventListener("focus", F), c.addEventListener("blur", j), function() {
        c.removeEventListener("focus", F), c.removeEventListener("blur", j);
      };
  }, [c, N, F, j]), L.useEffect(function() {
    if (!(c == null || !N("hover")))
      return c.addEventListener("mouseenter", F), c.addEventListener("mouseleave", j), function() {
        c.removeEventListener("mouseenter", F), c.removeEventListener("mouseleave", j);
      };
  }, [c, N, F, j]), L.useEffect(function() {
    if (!(p == null || !N("hover") || !P().finalConfig.interactive))
      return p.addEventListener("mouseenter", F), p.addEventListener("mouseleave", j), function() {
        p.removeEventListener("mouseenter", F), p.removeEventListener("mouseleave", j);
      };
  }, [p, N, F, j, P]);
  var I = S == null || (r = S.state) == null || (n = r.modifiersData) == null || (o = n.hide) == null ? void 0 : o.isReferenceHidden;
  L.useEffect(function() {
    a.closeOnTriggerHidden && I && j();
  }, [a.closeOnTriggerHidden, j, I]), L.useEffect(function() {
    if (!a.followCursor || c == null) return;
    function R(g) {
      var v = g.clientX, E = g.clientY;
      qi.getBoundingClientRect = Yc(v, E), A == null || A();
    }
    return c.addEventListener("mousemove", R), function() {
      return c.removeEventListener("mousemove", R);
    };
  }, [a.followCursor, c, A]), L.useEffect(function() {
    if (!(p == null || A == null || a.mutationObserverOptions == null)) {
      var R = new MutationObserver(A);
      return R.observe(p, a.mutationObserverOptions), function() {
        return R.disconnect();
      };
    }
  }, [a.mutationObserverOptions, p, A]);
  var D = function(g) {
    return g === void 0 && (g = {}), Ve({}, g, {
      style: Ve({}, g.style, O.popper)
    }, _.popper, {
      "data-popper-interactive": a.interactive
    });
  }, T = function(g) {
    return g === void 0 && (g = {}), Ve({}, g, _.arrow, {
      style: Ve({}, g.style, O.arrow),
      "data-popper-arrow": !0
    });
  };
  return Ve({
    getArrowProps: T,
    getTooltipProps: D,
    setTooltipRef: f,
    setTriggerRef: u,
    tooltipRef: p,
    triggerRef: c,
    visible: h
  }, S);
}
const zc = ({
  triggerComponent: e,
  children: t,
  trigger: r = ["hover"],
  placement: n = "bottom",
  arrowStyles: o = {},
  controlledVisible: a = !1,
  setControlledVisible: i,
  zIndex: s = 1,
  triggerAriaLabel: l,
  className: c,
  triggerStyle: u = {},
  triggerClassName: d,
  mountOnContainer: p,
  popperOptions: f = {},
  disabled: m,
  ...h
}) => {
  const { getArrowProps: y, getTooltipProps: b, setTooltipRef: w, setTriggerRef: O, visible: _ } = sp(
    {
      trigger: r,
      placement: n,
      ...i && {
        visible: a,
        onVisibleChange: i
      },
      ...h
    },
    f
  ), S = () => {
    const A = () => /* @__PURE__ */ x.createElement(
      "div",
      {
        ref: w,
        ...b({
          className: fe("tooltip-container", c),
          style: {
            background: "#ffffff",
            padding: "0",
            boxShadow: "2px 2px 6px 4px #00000029",
            borderRadius: "8px",
            "--tooltipBorder": "transparent",
            zIndex: s
          }
        })
      },
      t,
      /* @__PURE__ */ x.createElement("div", { ...y({ className: "tooltip-arrow", style: o }) })
    );
    return p ? Mc.createPortal(A(), p) : A();
  };
  return m ? e : /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(
    "div",
    {
      ref: O,
      className: d,
      style: u,
      "aria-label": l
    },
    e
  ), _ && S());
};
zc.propTypes = {
  triggerComponent: W.node.isRequired,
  children: W.node.isRequired,
  trigger: W.oneOfType([W.string, W.array]),
  placement: W.string,
  arrowStyles: W.object,
  controlledVisible: W.bool,
  setControlledVisible: W.func,
  zIndex: W.number,
  triggerStyle: W.object,
  className: W.string,
  triggerClassName: W.string,
  mountOnContainer: W.instanceOf(Element),
  popperOptions: W.object,
  disabled: W.bool
};
const xb = Sc(zc);
var Mr = { exports: {} }, et = {}, Dr = { exports: {} }, Se = {}, Lr = { exports: {} }, Fi;
function Kc() {
  return Fi || (Fi = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    /*!
     * Adapted from jQuery UI core
     *
     * http://jqueryui.com
     *
     * Copyright 2014 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * http://api.jqueryui.com/category/ui-core/
     */
    var r = "none", n = "contents", o = /^(input|select|textarea|button|object|iframe)$/;
    function a(d, p) {
      return p.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
      d.scrollWidth <= 0 && d.scrollHeight <= 0;
    }
    function i(d) {
      var p = d.offsetWidth <= 0 && d.offsetHeight <= 0;
      if (p && !d.innerHTML) return !0;
      try {
        var f = window.getComputedStyle(d), m = f.getPropertyValue("display");
        return p ? m !== n && a(d, f) : m === r;
      } catch {
        return console.warn("Failed to inspect element style"), !1;
      }
    }
    function s(d) {
      for (var p = d, f = d.getRootNode && d.getRootNode(); p && p !== document.body; ) {
        if (f && p === f && (p = f.host.parentNode), i(p)) return !1;
        p = p.parentNode;
      }
      return !0;
    }
    function l(d, p) {
      var f = d.nodeName.toLowerCase(), m = o.test(f) && !d.disabled || f === "a" && d.href || p;
      return m && s(d);
    }
    function c(d) {
      var p = d.getAttribute("tabindex");
      p === null && (p = void 0);
      var f = isNaN(p);
      return (f || p >= 0) && l(d, !f);
    }
    function u(d) {
      var p = [].slice.call(d.querySelectorAll("*"), 0).reduce(function(f, m) {
        return f.concat(m.shadowRoot ? u(m.shadowRoot) : [m]);
      }, []);
      return p.filter(c);
    }
    e.exports = t.default;
  }(Lr, Lr.exports)), Lr.exports;
}
var $i;
function lp() {
  if ($i) return Se;
  $i = 1, Object.defineProperty(Se, "__esModule", {
    value: !0
  }), Se.resetState = i, Se.log = s, Se.handleBlur = l, Se.handleFocus = c, Se.markForFocusLater = u, Se.returnFocus = d, Se.popWithoutFocus = p, Se.setupScopedFocus = f, Se.teardownScopedFocus = m;
  var e = Kc(), t = r(e);
  function r(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var n = [], o = null, a = !1;
  function i() {
    n = [];
  }
  function s() {
    process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), n.forEach(function(h) {
      var y = h || {};
      console.log(y.nodeName, y.className, y.id);
    }), console.log("end focusManager ----------"));
  }
  function l() {
    a = !0;
  }
  function c() {
    if (a) {
      if (a = !1, !o)
        return;
      setTimeout(function() {
        if (!o.contains(document.activeElement)) {
          var h = (0, t.default)(o)[0] || o;
          h.focus();
        }
      }, 0);
    }
  }
  function u() {
    n.push(document.activeElement);
  }
  function d() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, y = null;
    try {
      n.length !== 0 && (y = n.pop(), y.focus({ preventScroll: h }));
      return;
    } catch {
      console.warn(["You tried to return focus to", y, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function p() {
    n.length > 0 && n.pop();
  }
  function f(h) {
    o = h, window.addEventListener ? (window.addEventListener("blur", l, !1), document.addEventListener("focus", c, !0)) : (window.attachEvent("onBlur", l), document.attachEvent("onFocus", c));
  }
  function m() {
    o = null, window.addEventListener ? (window.removeEventListener("blur", l), document.removeEventListener("focus", c)) : (window.detachEvent("onBlur", l), document.detachEvent("onFocus", c));
  }
  return Se;
}
var Ir = { exports: {} }, Bi;
function cp() {
  return Bi || (Bi = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = Kc(), n = o(r);
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function a() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return s.activeElement.shadowRoot ? a(s.activeElement.shadowRoot) : s.activeElement;
    }
    function i(s, l) {
      var c = (0, n.default)(s);
      if (!c.length) {
        l.preventDefault();
        return;
      }
      var u = void 0, d = l.shiftKey, p = c[0], f = c[c.length - 1], m = a();
      if (s === m) {
        if (!d) return;
        u = f;
      }
      if (f === m && !d && (u = p), p === m && d && (u = f), u) {
        l.preventDefault(), u.focus();
        return;
      }
      var h = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), y = h != null && h[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (y) {
        var b = c.indexOf(m);
        if (b > -1 && (b += d ? -1 : 1), u = c[b], typeof u > "u") {
          l.preventDefault(), u = d ? f : p, u.focus();
          return;
        }
        l.preventDefault(), u.focus();
      }
    }
    e.exports = t.default;
  }(Ir, Ir.exports)), Ir.exports;
}
var De = {}, qe = {}, xn = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var Hi;
function up() {
  return Hi || (Hi = 1, function(e) {
    (function() {
      var t = !!(typeof window < "u" && window.document && window.document.createElement), r = {
        canUseDOM: t,
        canUseWorkers: typeof Worker < "u",
        canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
        canUseViewport: t && !!window.screen
      };
      e.exports ? e.exports = r : window.ExecutionEnvironment = r;
    })();
  }(xn)), xn.exports;
}
var Wi;
function Ja() {
  if (Wi) return qe;
  Wi = 1, Object.defineProperty(qe, "__esModule", {
    value: !0
  }), qe.canUseDOM = qe.SafeNodeList = qe.SafeHTMLCollection = void 0;
  var e = up(), t = r(e);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var n = t.default, o = n.canUseDOM ? window.HTMLElement : {};
  return qe.SafeHTMLCollection = n.canUseDOM ? window.HTMLCollection : {}, qe.SafeNodeList = n.canUseDOM ? window.NodeList : {}, qe.canUseDOM = n.canUseDOM, qe.default = o, qe;
}
var Ui;
function Gc() {
  if (Ui) return De;
  Ui = 1, Object.defineProperty(De, "__esModule", {
    value: !0
  }), De.resetState = a, De.log = i, De.assertNodeList = s, De.setElement = l, De.validateElement = c, De.hide = u, De.show = d, De.documentNotReadyOrSSRTesting = p;
  var e = np(), t = n(e), r = Ja();
  function n(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var o = null;
  function a() {
    o && (o.removeAttribute ? o.removeAttribute("aria-hidden") : o.length != null ? o.forEach(function(f) {
      return f.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(o).forEach(function(f) {
      return f.removeAttribute("aria-hidden");
    })), o = null;
  }
  function i() {
    if (process.env.NODE_ENV !== "production") {
      var f = o || {};
      console.log("ariaAppHider ----------"), console.log(f.nodeName, f.className, f.id), console.log("end ariaAppHider ----------");
    }
  }
  function s(f, m) {
    if (!f || !f.length)
      throw new Error("react-modal: No elements were found for selector " + m + ".");
  }
  function l(f) {
    var m = f;
    if (typeof m == "string" && r.canUseDOM) {
      var h = document.querySelectorAll(m);
      s(h, m), m = h;
    }
    return o = m || o, o;
  }
  function c(f) {
    var m = f || o;
    return m ? Array.isArray(m) || m instanceof HTMLCollection || m instanceof NodeList ? m : [m] : ((0, t.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }
  function u(f) {
    var m = !0, h = !1, y = void 0;
    try {
      for (var b = c(f)[Symbol.iterator](), w; !(m = (w = b.next()).done); m = !0) {
        var O = w.value;
        O.setAttribute("aria-hidden", "true");
      }
    } catch (_) {
      h = !0, y = _;
    } finally {
      try {
        !m && b.return && b.return();
      } finally {
        if (h)
          throw y;
      }
    }
  }
  function d(f) {
    var m = !0, h = !1, y = void 0;
    try {
      for (var b = c(f)[Symbol.iterator](), w; !(m = (w = b.next()).done); m = !0) {
        var O = w.value;
        O.removeAttribute("aria-hidden");
      }
    } catch (_) {
      h = !0, y = _;
    } finally {
      try {
        !m && b.return && b.return();
      } finally {
        if (h)
          throw y;
      }
    }
  }
  function p() {
    o = null;
  }
  return De;
}
var lt = {}, Vi;
function fp() {
  if (Vi) return lt;
  Vi = 1, Object.defineProperty(lt, "__esModule", {
    value: !0
  }), lt.resetState = n, lt.log = o;
  var e = {}, t = {};
  function r(c, u) {
    c.classList.remove(u);
  }
  function n() {
    var c = document.getElementsByTagName("html")[0];
    for (var u in e)
      r(c, e[u]);
    var d = document.body;
    for (var p in t)
      r(d, t[p]);
    e = {}, t = {};
  }
  function o() {
    if (process.env.NODE_ENV !== "production") {
      var c = document.getElementsByTagName("html")[0].className, u = `Show tracked classes:

`;
      u += "<html /> (" + c + `):
  `;
      for (var d in e)
        u += "  " + d + " " + e[d] + `
  `;
      c = document.body.className, u += `

doc.body (` + c + `):
  `;
      for (var p in t)
        u += "  " + p + " " + t[p] + `
  `;
      u += `
`, console.log(u);
    }
  }
  var a = function(u, d) {
    return u[d] || (u[d] = 0), u[d] += 1, d;
  }, i = function(u, d) {
    return u[d] && (u[d] -= 1), d;
  }, s = function(u, d, p) {
    p.forEach(function(f) {
      a(d, f), u.add(f);
    });
  }, l = function(u, d, p) {
    p.forEach(function(f) {
      i(d, f), d[f] === 0 && u.remove(f);
    });
  };
  return lt.add = function(u, d) {
    return s(u.classList, u.nodeName.toLowerCase() == "html" ? e : t, d.split(" "));
  }, lt.remove = function(u, d) {
    return l(u.classList, u.nodeName.toLowerCase() == "html" ? e : t, d.split(" "));
  }, lt;
}
var xt = {}, Yi;
function Xc() {
  if (Yi) return xt;
  Yi = 1, Object.defineProperty(xt, "__esModule", {
    value: !0
  }), xt.log = n, xt.resetState = o;
  function e(a, i) {
    if (!(a instanceof i))
      throw new TypeError("Cannot call a class as a function");
  }
  var t = function a() {
    var i = this;
    e(this, a), this.register = function(s) {
      if (i.openInstances.indexOf(s) !== -1) {
        process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
        return;
      }
      i.openInstances.push(s), i.emit("register");
    }, this.deregister = function(s) {
      var l = i.openInstances.indexOf(s);
      if (l === -1) {
        process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + s + " as it was never registered");
        return;
      }
      i.openInstances.splice(l, 1), i.emit("deregister");
    }, this.subscribe = function(s) {
      i.subscribers.push(s);
    }, this.emit = function(s) {
      i.subscribers.forEach(function(l) {
        return l(
          s,
          // shallow copy to avoid accidental mutation
          i.openInstances.slice()
        );
      });
    }, this.openInstances = [], this.subscribers = [];
  }, r = new t();
  function n() {
    console.log("portalOpenInstances ----------"), console.log(r.openInstances.length), r.openInstances.forEach(function(a) {
      return console.log(a);
    }), console.log("end portalOpenInstances ----------");
  }
  function o() {
    r = new t();
  }
  return xt.default = r, xt;
}
var Xt = {}, zi;
function dp() {
  if (zi) return Xt;
  zi = 1, Object.defineProperty(Xt, "__esModule", {
    value: !0
  }), Xt.resetState = i, Xt.log = s;
  var e = Xc(), t = r(e);
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var n = void 0, o = void 0, a = [];
  function i() {
    for (var u = [n, o], d = 0; d < u.length; d++) {
      var p = u[d];
      p && p.parentNode && p.parentNode.removeChild(p);
    }
    n = o = null, a = [];
  }
  function s() {
    console.log("bodyTrap ----------"), console.log(a.length);
    for (var u = [n, o], d = 0; d < u.length; d++) {
      var p = u[d], f = p || {};
      console.log(f.nodeName, f.className, f.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function l() {
    if (a.length === 0) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
      return;
    }
    a[a.length - 1].focusContent();
  }
  function c(u, d) {
    !n && !o && (n = document.createElement("div"), n.setAttribute("data-react-modal-body-trap", ""), n.style.position = "absolute", n.style.opacity = "0", n.setAttribute("tabindex", "0"), n.addEventListener("focus", l), o = n.cloneNode(), o.addEventListener("focus", l)), a = d, a.length > 0 ? (document.body.firstChild !== n && document.body.insertBefore(n, document.body.firstChild), document.body.lastChild !== o && document.body.appendChild(o)) : (n.parentElement && n.parentElement.removeChild(n), o.parentElement && o.parentElement.removeChild(o));
  }
  return t.default.subscribe(c), Xt;
}
var Ki;
function pp() {
  return Ki || (Ki = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = Object.assign || function(T) {
      for (var R = 1; R < arguments.length; R++) {
        var g = arguments[R];
        for (var v in g)
          Object.prototype.hasOwnProperty.call(g, v) && (T[v] = g[v]);
      }
      return T;
    }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
      return typeof T;
    } : function(T) {
      return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
    }, o = /* @__PURE__ */ function() {
      function T(R, g) {
        for (var v = 0; v < g.length; v++) {
          var E = g[v];
          E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(R, E.key, E);
        }
      }
      return function(R, g, v) {
        return g && T(R.prototype, g), v && T(R, v), R;
      };
    }(), a = x, i = W, s = S(i), l = lp(), c = _(l), u = cp(), d = S(u), p = Gc(), f = _(p), m = fp(), h = _(m), y = Ja(), b = S(y), w = Xc(), O = S(w);
    dp();
    function _(T) {
      if (T && T.__esModule)
        return T;
      var R = {};
      if (T != null)
        for (var g in T)
          Object.prototype.hasOwnProperty.call(T, g) && (R[g] = T[g]);
      return R.default = T, R;
    }
    function S(T) {
      return T && T.__esModule ? T : { default: T };
    }
    function A(T, R) {
      if (!(T instanceof R))
        throw new TypeError("Cannot call a class as a function");
    }
    function P(T, R) {
      if (!T)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return R && (typeof R == "object" || typeof R == "function") ? R : T;
    }
    function N(T, R) {
      if (typeof R != "function" && R !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof R);
      T.prototype = Object.create(R && R.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), R && (Object.setPrototypeOf ? Object.setPrototypeOf(T, R) : T.__proto__ = R);
    }
    var j = {
      overlay: "ReactModal__Overlay",
      content: "ReactModal__Content"
    }, F = function(R) {
      return R.code === "Tab" || R.keyCode === 9;
    }, M = function(R) {
      return R.code === "Escape" || R.keyCode === 27;
    }, I = 0, D = function(T) {
      N(R, T);
      function R(g) {
        A(this, R);
        var v = P(this, (R.__proto__ || Object.getPrototypeOf(R)).call(this, g));
        return v.setOverlayRef = function(E) {
          v.overlay = E, v.props.overlayRef && v.props.overlayRef(E);
        }, v.setContentRef = function(E) {
          v.content = E, v.props.contentRef && v.props.contentRef(E);
        }, v.afterClose = function() {
          var E = v.props, k = E.appElement, q = E.ariaHideApp, H = E.htmlOpenClassName, V = E.bodyOpenClassName, J = E.parentSelector, z = J && J().ownerDocument || document;
          V && h.remove(z.body, V), H && h.remove(z.getElementsByTagName("html")[0], H), q && I > 0 && (I -= 1, I === 0 && f.show(k)), v.props.shouldFocusAfterRender && (v.props.shouldReturnFocusAfterClose ? (c.returnFocus(v.props.preventScroll), c.teardownScopedFocus()) : c.popWithoutFocus()), v.props.onAfterClose && v.props.onAfterClose(), O.default.deregister(v);
        }, v.open = function() {
          v.beforeOpen(), v.state.afterOpen && v.state.beforeClose ? (clearTimeout(v.closeTimer), v.setState({ beforeClose: !1 })) : (v.props.shouldFocusAfterRender && (c.setupScopedFocus(v.node), c.markForFocusLater()), v.setState({ isOpen: !0 }, function() {
            v.openAnimationFrame = requestAnimationFrame(function() {
              v.setState({ afterOpen: !0 }), v.props.isOpen && v.props.onAfterOpen && v.props.onAfterOpen({
                overlayEl: v.overlay,
                contentEl: v.content
              });
            });
          }));
        }, v.close = function() {
          v.props.closeTimeoutMS > 0 ? v.closeWithTimeout() : v.closeWithoutTimeout();
        }, v.focusContent = function() {
          return v.content && !v.contentHasFocus() && v.content.focus({ preventScroll: !0 });
        }, v.closeWithTimeout = function() {
          var E = Date.now() + v.props.closeTimeoutMS;
          v.setState({ beforeClose: !0, closesAt: E }, function() {
            v.closeTimer = setTimeout(v.closeWithoutTimeout, v.state.closesAt - Date.now());
          });
        }, v.closeWithoutTimeout = function() {
          v.setState({
            beforeClose: !1,
            isOpen: !1,
            afterOpen: !1,
            closesAt: null
          }, v.afterClose);
        }, v.handleKeyDown = function(E) {
          F(E) && (0, d.default)(v.content, E), v.props.shouldCloseOnEsc && M(E) && (E.stopPropagation(), v.requestClose(E));
        }, v.handleOverlayOnClick = function(E) {
          v.shouldClose === null && (v.shouldClose = !0), v.shouldClose && v.props.shouldCloseOnOverlayClick && (v.ownerHandlesClose() ? v.requestClose(E) : v.focusContent()), v.shouldClose = null;
        }, v.handleContentOnMouseUp = function() {
          v.shouldClose = !1;
        }, v.handleOverlayOnMouseDown = function(E) {
          !v.props.shouldCloseOnOverlayClick && E.target == v.overlay && E.preventDefault();
        }, v.handleContentOnClick = function() {
          v.shouldClose = !1;
        }, v.handleContentOnMouseDown = function() {
          v.shouldClose = !1;
        }, v.requestClose = function(E) {
          return v.ownerHandlesClose() && v.props.onRequestClose(E);
        }, v.ownerHandlesClose = function() {
          return v.props.onRequestClose;
        }, v.shouldBeClosed = function() {
          return !v.state.isOpen && !v.state.beforeClose;
        }, v.contentHasFocus = function() {
          return document.activeElement === v.content || v.content.contains(document.activeElement);
        }, v.buildClassName = function(E, k) {
          var q = (typeof k > "u" ? "undefined" : n(k)) === "object" ? k : {
            base: j[E],
            afterOpen: j[E] + "--after-open",
            beforeClose: j[E] + "--before-close"
          }, H = q.base;
          return v.state.afterOpen && (H = H + " " + q.afterOpen), v.state.beforeClose && (H = H + " " + q.beforeClose), typeof k == "string" && k ? H + " " + k : H;
        }, v.attributesFromObject = function(E, k) {
          return Object.keys(k).reduce(function(q, H) {
            return q[E + "-" + H] = k[H], q;
          }, {});
        }, v.state = {
          afterOpen: !1,
          beforeClose: !1
        }, v.shouldClose = null, v.moveFromContentToOverlay = null, v;
      }
      return o(R, [{
        key: "componentDidMount",
        value: function() {
          this.props.isOpen && this.open();
        }
      }, {
        key: "componentDidUpdate",
        value: function(v, E) {
          process.env.NODE_ENV !== "production" && (v.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), v.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !v.isOpen ? this.open() : !this.props.isOpen && v.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !E.isOpen && this.focusContent();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
        }
      }, {
        key: "beforeOpen",
        value: function() {
          var v = this.props, E = v.appElement, k = v.ariaHideApp, q = v.htmlOpenClassName, H = v.bodyOpenClassName, V = v.parentSelector, J = V && V().ownerDocument || document;
          H && h.add(J.body, H), q && h.add(J.getElementsByTagName("html")[0], q), k && (I += 1, f.hide(E)), O.default.register(this);
        }
        // Don't steal focus from inner elements
      }, {
        key: "render",
        value: function() {
          var v = this.props, E = v.id, k = v.className, q = v.overlayClassName, H = v.defaultStyles, V = v.children, J = k ? {} : H.content, z = q ? {} : H.overlay;
          if (this.shouldBeClosed())
            return null;
          var Q = {
            ref: this.setOverlayRef,
            className: this.buildClassName("overlay", q),
            style: r({}, z, this.props.style.overlay),
            onClick: this.handleOverlayOnClick,
            onMouseDown: this.handleOverlayOnMouseDown
          }, re = r({
            id: E,
            ref: this.setContentRef,
            style: r({}, J, this.props.style.content),
            className: this.buildClassName("content", k),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }), ne = this.props.contentElement(re, V);
          return this.props.overlayElement(Q, ne);
        }
      }]), R;
    }(a.Component);
    D.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    }, D.propTypes = {
      isOpen: s.default.bool.isRequired,
      defaultStyles: s.default.shape({
        content: s.default.object,
        overlay: s.default.object
      }),
      style: s.default.shape({
        content: s.default.object,
        overlay: s.default.object
      }),
      className: s.default.oneOfType([s.default.string, s.default.object]),
      overlayClassName: s.default.oneOfType([s.default.string, s.default.object]),
      parentSelector: s.default.func,
      bodyOpenClassName: s.default.string,
      htmlOpenClassName: s.default.string,
      ariaHideApp: s.default.bool,
      appElement: s.default.oneOfType([s.default.instanceOf(b.default), s.default.instanceOf(y.SafeHTMLCollection), s.default.instanceOf(y.SafeNodeList), s.default.arrayOf(s.default.instanceOf(b.default))]),
      onAfterOpen: s.default.func,
      onAfterClose: s.default.func,
      onRequestClose: s.default.func,
      closeTimeoutMS: s.default.number,
      shouldFocusAfterRender: s.default.bool,
      shouldCloseOnOverlayClick: s.default.bool,
      shouldReturnFocusAfterClose: s.default.bool,
      preventScroll: s.default.bool,
      role: s.default.string,
      contentLabel: s.default.string,
      aria: s.default.object,
      data: s.default.object,
      children: s.default.node,
      shouldCloseOnEsc: s.default.bool,
      overlayRef: s.default.func,
      contentRef: s.default.func,
      id: s.default.string,
      overlayElement: s.default.func,
      contentElement: s.default.func,
      testId: s.default.string
    }, t.default = D, e.exports = t.default;
  }(Dr, Dr.exports)), Dr.exports;
}
function Jc() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Zc(e) {
  function t(r) {
    var n = this.constructor.getDerivedStateFromProps(e, r);
    return n ?? null;
  }
  this.setState(t.bind(this));
}
function Qc(e, t) {
  try {
    var r = this.props, n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      n
    );
  } finally {
    this.props = r, this.state = n;
  }
}
Jc.__suppressDeprecationWarning = !0;
Zc.__suppressDeprecationWarning = !0;
Qc.__suppressDeprecationWarning = !0;
function hp(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var r = null, n = null, o = null;
  if (typeof t.componentWillMount == "function" ? r = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? o = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (o = "UNSAFE_componentWillUpdate"), r !== null || n !== null || o !== null) {
    var a = e.displayName || e.name, i = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + a + " uses " + i + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (n !== null ? `
  ` + n : "") + (o !== null ? `
  ` + o : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = Jc, t.componentWillReceiveProps = Zc), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Qc;
    var s = t.componentDidUpdate;
    t.componentDidUpdate = function(c, u, d) {
      var p = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : d;
      s.call(this, c, u, p);
    };
  }
  return e;
}
const vp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: hp
}, Symbol.toStringTag, { value: "Module" })), mp = /* @__PURE__ */ Nf(vp);
var Gi;
function gp() {
  if (Gi) return et;
  Gi = 1, Object.defineProperty(et, "__esModule", {
    value: !0
  }), et.bodyOpenClassName = et.portalClassName = void 0;
  var e = Object.assign || function(M) {
    for (var I = 1; I < arguments.length; I++) {
      var D = arguments[I];
      for (var T in D)
        Object.prototype.hasOwnProperty.call(D, T) && (M[T] = D[T]);
    }
    return M;
  }, t = /* @__PURE__ */ function() {
    function M(I, D) {
      for (var T = 0; T < D.length; T++) {
        var R = D[T];
        R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(I, R.key, R);
      }
    }
    return function(I, D, T) {
      return D && M(I.prototype, D), T && M(I, T), I;
    };
  }(), r = x, n = y(r), o = Mc, a = y(o), i = W, s = y(i), l = pp(), c = y(l), u = Gc(), d = h(u), p = Ja(), f = y(p), m = mp;
  function h(M) {
    if (M && M.__esModule)
      return M;
    var I = {};
    if (M != null)
      for (var D in M)
        Object.prototype.hasOwnProperty.call(M, D) && (I[D] = M[D]);
    return I.default = M, I;
  }
  function y(M) {
    return M && M.__esModule ? M : { default: M };
  }
  function b(M, I) {
    if (!(M instanceof I))
      throw new TypeError("Cannot call a class as a function");
  }
  function w(M, I) {
    if (!M)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return I && (typeof I == "object" || typeof I == "function") ? I : M;
  }
  function O(M, I) {
    if (typeof I != "function" && I !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof I);
    M.prototype = Object.create(I && I.prototype, { constructor: { value: M, enumerable: !1, writable: !0, configurable: !0 } }), I && (Object.setPrototypeOf ? Object.setPrototypeOf(M, I) : M.__proto__ = I);
  }
  var _ = et.portalClassName = "ReactModalPortal", S = et.bodyOpenClassName = "ReactModal__Body--open", A = p.canUseDOM && a.default.createPortal !== void 0, P = function(I) {
    return document.createElement(I);
  }, N = function() {
    return A ? a.default.createPortal : a.default.unstable_renderSubtreeIntoContainer;
  };
  function j(M) {
    return M();
  }
  var F = function(M) {
    O(I, M);
    function I() {
      var D, T, R, g;
      b(this, I);
      for (var v = arguments.length, E = Array(v), k = 0; k < v; k++)
        E[k] = arguments[k];
      return g = (T = (R = w(this, (D = I.__proto__ || Object.getPrototypeOf(I)).call.apply(D, [this].concat(E))), R), R.removePortal = function() {
        !A && a.default.unmountComponentAtNode(R.node);
        var q = j(R.props.parentSelector);
        q && q.contains(R.node) ? q.removeChild(R.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }, R.portalRef = function(q) {
        R.portal = q;
      }, R.renderPortal = function(q) {
        var H = N(), V = H(R, n.default.createElement(c.default, e({ defaultStyles: I.defaultStyles }, q)), R.node);
        R.portalRef(V);
      }, T), w(R, g);
    }
    return t(I, [{
      key: "componentDidMount",
      value: function() {
        if (p.canUseDOM) {
          A || (this.node = P("div")), this.node.className = this.props.portalClassName;
          var T = j(this.props.parentSelector);
          T.appendChild(this.node), !A && this.renderPortal(this.props);
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(T) {
        var R = j(T.parentSelector), g = j(this.props.parentSelector);
        return { prevParent: R, nextParent: g };
      }
    }, {
      key: "componentDidUpdate",
      value: function(T, R, g) {
        if (p.canUseDOM) {
          var v = this.props, E = v.isOpen, k = v.portalClassName;
          T.portalClassName !== k && (this.node.className = k);
          var q = g.prevParent, H = g.nextParent;
          H !== q && (q.removeChild(this.node), H.appendChild(this.node)), !(!T.isOpen && !E) && !A && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        if (!(!p.canUseDOM || !this.node || !this.portal)) {
          var T = this.portal.state, R = Date.now(), g = T.isOpen && this.props.closeTimeoutMS && (T.closesAt || R + this.props.closeTimeoutMS);
          g ? (T.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, g - R)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function() {
        if (!p.canUseDOM || !A)
          return null;
        !this.node && A && (this.node = P("div"));
        var T = N();
        return T(n.default.createElement(c.default, e({
          ref: this.portalRef,
          defaultStyles: I.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function(T) {
        d.setElement(T);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]), I;
  }(r.Component);
  return F.propTypes = {
    isOpen: s.default.bool.isRequired,
    style: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    portalClassName: s.default.string,
    bodyOpenClassName: s.default.string,
    htmlOpenClassName: s.default.string,
    className: s.default.oneOfType([s.default.string, s.default.shape({
      base: s.default.string.isRequired,
      afterOpen: s.default.string.isRequired,
      beforeClose: s.default.string.isRequired
    })]),
    overlayClassName: s.default.oneOfType([s.default.string, s.default.shape({
      base: s.default.string.isRequired,
      afterOpen: s.default.string.isRequired,
      beforeClose: s.default.string.isRequired
    })]),
    appElement: s.default.oneOfType([s.default.instanceOf(f.default), s.default.instanceOf(p.SafeHTMLCollection), s.default.instanceOf(p.SafeNodeList), s.default.arrayOf(s.default.instanceOf(f.default))]),
    onAfterOpen: s.default.func,
    onRequestClose: s.default.func,
    closeTimeoutMS: s.default.number,
    ariaHideApp: s.default.bool,
    shouldFocusAfterRender: s.default.bool,
    shouldCloseOnOverlayClick: s.default.bool,
    shouldReturnFocusAfterClose: s.default.bool,
    preventScroll: s.default.bool,
    parentSelector: s.default.func,
    aria: s.default.object,
    data: s.default.object,
    role: s.default.string,
    contentLabel: s.default.string,
    shouldCloseOnEsc: s.default.bool,
    overlayRef: s.default.func,
    contentRef: s.default.func,
    id: s.default.string,
    overlayElement: s.default.func,
    contentElement: s.default.func
  }, F.defaultProps = {
    isOpen: !1,
    portalClassName: _,
    bodyOpenClassName: S,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    preventScroll: !1,
    parentSelector: function() {
      return document.body;
    },
    overlayElement: function(I, D) {
      return n.default.createElement(
        "div",
        I,
        D
      );
    },
    contentElement: function(I, D) {
      return n.default.createElement(
        "div",
        I,
        D
      );
    }
  }, F.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, m.polyfill)(F), process.env.NODE_ENV !== "production" && (F.setCreateHTMLElement = function(M) {
    return P = M;
  }), et.default = F, et;
}
var Xi;
function yp() {
  return Xi || (Xi = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = gp(), n = o(r);
    function o(a) {
      return a && a.__esModule ? a : { default: a };
    }
    t.default = n.default, e.exports = t.default;
  }(Mr, Mr.exports)), Mr.exports;
}
var bp = yp();
const eu = /* @__PURE__ */ Ft(bp);
function tu({ width: e = "20", height: t = "20" }) {
  return /* @__PURE__ */ x.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: t,
      viewBox: "0 0 20 20",
      fill: "none"
    },
    /* @__PURE__ */ x.createElement("title", null, "close"),
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M11.3581 9.99438L19.7221 1.62844C19.897 1.44718 19.9937 1.20446 19.9915 0.952527C19.9893 0.700598 19.8883 0.459615 19.7103 0.281468C19.5322 0.10332 19.2914 0.0022562 19.0396 3.73198e-05C18.7878 -0.00218156 18.5452 0.0946219 18.364 0.269604L10 8.63835L1.63876 0.269604C1.4576 0.0946219 1.21501 -0.00218156 0.963225 3.73198e-05C0.711438 0.0022562 0.470591 0.10332 0.292543 0.281468C0.114495 0.459615 0.0134882 0.700598 0.0112706 0.952527C0.00905292 1.20446 0.105802 1.44718 0.280686 1.62844L8.64473 9.99718L0.280686 18.3631C0.100966 18.5429 0 18.7868 0 19.0411C0 19.2954 0.100966 19.5393 0.280686 19.7192C0.460406 19.899 0.704159 20 0.958322 20C1.21248 20 1.45624 19.899 1.63596 19.7192L10 11.3532L18.364 19.7192C18.5438 19.899 18.7875 20 19.0417 20C19.2958 20 19.5396 19.899 19.7193 19.7192C19.899 19.5393 20 19.2954 20 19.0411C20 18.7868 19.899 18.5429 19.7193 18.3631L11.3581 9.99438Z",
        fill: "black"
      }
    )
  );
}
tu.propTypes = {
  width: W.string,
  height: W.string
};
function ru({ width: e = "24", height: t = "24" }) {
  return /* @__PURE__ */ x.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ x.createElement("title", null, "back"),
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M8.5249 5.32687C8.59101 5.26133 8.66955 5.20934 8.75603 5.17386C8.84251 5.13838 8.93523 5.12012 9.02886 5.12012C9.1225 5.12012 9.21521 5.13838 9.30169 5.17386C9.38817 5.20934 9.46671 5.26133 9.53282 5.32687C9.59791 5.39076 9.64957 5.46674 9.68483 5.55045C9.72008 5.63415 9.73823 5.72392 9.73823 5.81459C9.73823 5.90525 9.72008 5.99502 9.68483 6.07872C9.64957 6.16243 9.59791 6.23841 9.53282 6.30231L4.42297 11.2998H21.2842C21.4714 11.2972 21.6519 11.3682 21.7861 11.4971C21.9203 11.626 21.9973 11.8023 22 11.9872C21.9983 12.1736 21.9222 12.3518 21.7881 12.4829C21.654 12.614 21.4729 12.6874 21.2842 12.687H4.42297L9.53282 17.6742C9.66547 17.8063 9.73958 17.985 9.73886 18.1711C9.73815 18.3572 9.66265 18.5354 9.529 18.6665C9.39534 18.7976 9.21446 18.8708 9.02616 18.8701C8.83785 18.8694 8.65755 18.7948 8.5249 18.6627L2.20541 12.4829C2.14031 12.419 2.08865 12.343 2.0534 12.2593C2.01815 12.1756 2 12.0858 2 11.9951C2 11.9045 2.01815 11.8147 2.0534 11.731C2.08865 11.6473 2.14031 11.5713 2.20541 11.5074L8.5249 5.32687Z",
        fill: "black",
        stroke: "black",
        strokeWidth: "0.5"
      }
    )
  );
}
ru.propTypes = {
  width: W.string,
  height: W.string
};
const wp = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%"
  }
};
eu.setAppElement("body");
const nu = ({
  children: e,
  modalIsOpen: t = !1,
  onRequestClose: r = () => {
  },
  onHideClose: n,
  onNavigateBack: o = () => {
  },
  onAfterClose: a = () => {
  },
  hideClose: i = !1,
  hideBackButton: s = !0,
  shouldCloseOnEsc: l = !0,
  shouldCloseOnOverlayClick: c = !0,
  customClasses: u = "",
  closeButtonClassName: d = "",
  headerClassName: p = "",
  disabledCloseButton: f = !1,
  titleCloseButton: m = "",
  style: h = {},
  ...y
}) => /* @__PURE__ */ x.createElement(
  eu,
  {
    isOpen: t,
    onRequestClose: r,
    onAfterClose: a,
    style: { ...wp, ...h },
    portalClassName: fe(u, "umaiReactModalPortal"),
    shouldCloseOnEsc: l,
    shouldCloseOnOverlayClick: c,
    ...y
  },
  /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("header", { className: fe("popup-header", p) }, s ? null : /* @__PURE__ */ x.createElement("button", { type: "button", onClick: o, className: "go-back", "aria-label": "go back" }, /* @__PURE__ */ x.createElement(ru, null)), !i && r ? /* @__PURE__ */ x.createElement(
    "button",
    {
      type: "button",
      onClick: n || r,
      className: fe("close-popup", d),
      "aria-label": "Close",
      "data-testid": "close-react-modal",
      disabled: f,
      title: m
    },
    /* @__PURE__ */ x.createElement(tu, null)
  ) : null), e)
);
nu.propTypes = {
  children: W.node.isRequired,
  modalIsOpen: W.bool.isRequired,
  onRequestClose: W.func,
  hideClose: W.bool,
  hideBackButton: W.bool,
  customClasses: W.string,
  onHideClose: W.func,
  onNavigateBack: W.func,
  onAfterClose: W.func,
  shouldCloseOnEsc: W.bool,
  shouldCloseOnOverlayClick: W.bool,
  style: W.object,
  closeButtonClassName: W.string
};
const Tb = (e) => (t) => (r) => /* @__PURE__ */ x.createElement(e, null, /* @__PURE__ */ x.createElement(t, { ...r })), _p = "_container_smntf_1", Ep = "_textLabel_smntf_5", Cp = "_toggle_smntf_15", xp = "_toggleLabel_smntf_18", Tp = "_checkboxInput_smntf_23", Op = "_lever_smntf_33", Rp = "_focused_smntf_76", Sp = "_isSmall_smntf_79", tt = {
  container: _p,
  textLabel: Ep,
  toggle: Cp,
  toggleLabel: xp,
  checkboxInput: Tp,
  lever: Op,
  focused: Rp,
  isSmall: Sp
}, ou = ({
  id: e,
  name: t,
  onChange: r,
  checked: n,
  label: o,
  className: a = "",
  ariaLabel: i,
  isSmall: s = !1,
  ...l
}) => {
  const [c, u] = xe(!1), d = e || t, p = (f) => {
    f.stopPropagation(), f.target.blur(), r(!n, f);
  };
  return /* @__PURE__ */ x.createElement("div", { className: fe(tt.container, a) }, o ? /* @__PURE__ */ x.createElement("label", { htmlFor: d, className: tt.textLabel }, o) : null, /* @__PURE__ */ x.createElement("div", { className: fe(tt.toggle, { [tt.isSmall]: s }) }, /* @__PURE__ */ x.createElement("label", { htmlFor: d, className: tt.toggleLabel }, /* @__PURE__ */ x.createElement(
    "input",
    {
      type: "checkbox",
      className: tt.checkboxInput,
      id: d,
      name: t,
      "aria-label": i,
      checked: n,
      onChange: p,
      onClick: (f) => f.stopPropagation(),
      onFocus: () => u(!0),
      onBlur: () => u(!1),
      ...l
    }
  ), /* @__PURE__ */ x.createElement("span", { className: fe(tt.lever, { [tt.focused]: c }) }))));
};
ou.propTypes = {
  name: W.string.isRequired,
  label: W.string,
  onChange: W.func.isRequired,
  checked: W.bool.isRequired,
  className: W.string,
  disabled: W.bool,
  ariaLabel: W.string,
  isSmall: W.bool
};
const Ji = Sc(ou);
function Ap({ className: e, color: t = "#fff" }) {
  return /* @__PURE__ */ x.createElement("svg", { className: e, height: "10", viewBox: "0 0 14 10", width: "14" }, /* @__PURE__ */ x.createElement(
    "path",
    {
      d: "m286.248-121.209a.5.5 0 0 0 .313.11.5.5 0 0 0 .373-.169l8-9a.5.5 0 0 0 -.041-.706.5.5 0 0 0 -.708.042l-7.683 8.645-4.629-3.7a.5.5 0 0 0 -.7.078.5.5 0 0 0 .078.7z",
      fill: t,
      fillRule: "evenodd",
      transform: "translate(-281.06 131.1)"
    }
  ));
}
const kp = "_checkbox_148ma_1", Pp = "_disabledCheckMark_148ma_17", Mp = "_hasGreyBackground_148ma_40", Dp = "_hasBorder_148ma_43", Jt = {
  checkbox: kp,
  static: "_static_148ma_8",
  disabledCheckMark: Pp,
  hasGreyBackground: Mp,
  hasBorder: Dp
}, Za = ({
  id: e,
  checked: t = !1,
  className: r,
  checkInputClassName: n,
  isBorderVisible: o = !0,
  onChange: a = () => {
  },
  isStatic: i = !1,
  disabled: s,
  ariaLabel: l,
  hasGreyBackground: c = !1,
  name: u
}) => /* @__PURE__ */ x.createElement(
  "label",
  {
    className: fe(Jt.checkbox, r, {
      [Jt.static]: i
    }),
    htmlFor: e
  },
  t ? /* @__PURE__ */ x.createElement(Ap, { className: fe({ [Jt.disabledCheckMark]: s }) }) : null,
  /* @__PURE__ */ x.createElement(
    "input",
    {
      className: fe(n, {
        [Jt.hasBorder]: o,
        [Jt.hasGreyBackground]: c
      }),
      id: e,
      type: "checkbox",
      checked: t,
      ...!i && { onChange: a },
      disabled: s,
      "aria-label": l,
      name: u,
      readOnly: !0
    }
  )
);
Za.propTypes = {
  id: W.string,
  checked: W.bool,
  onChange: W.func,
  className: W.string,
  isBorderVisible: W.bool,
  isStatic: W.bool,
  ariaLabel: W.string,
  hasGreyBackground: W.bool,
  name: W.string,
  disabled: W.bool
};
function Lp({ className: e, color: t = "#fff" }) {
  return /* @__PURE__ */ x.createElement("svg", { width: 11, height: 8, fill: "none", className: e }, /* @__PURE__ */ x.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.701 2.179L6.021 6.86a.736.736 0 01-1.041 0L.299 2.18a.736.736 0 011.04-1.04L5.5 5.299l4.161-4.16a.736.736 0 111.04 1.04z",
      fill: t
    }
  ));
}
function nn() {
  return typeof window < "u";
}
function $t(e) {
  return au(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function _e(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function He(e) {
  var t;
  return (t = (au(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function au(e) {
  return nn() ? e instanceof Node || e instanceof _e(e).Node : !1;
}
function te(e) {
  return nn() ? e instanceof Element || e instanceof _e(e).Element : !1;
}
function Ee(e) {
  return nn() ? e instanceof HTMLElement || e instanceof _e(e).HTMLElement : !1;
}
function Oa(e) {
  return !nn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof _e(e).ShadowRoot;
}
function gr(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Oe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function Ip(e) {
  return ["table", "td", "th"].includes($t(e));
}
function on(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Qa(e) {
  const t = an(), r = te(e) ? Oe(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Np(e) {
  let t = Xe(e);
  for (; Ee(t) && !ze(t); ) {
    if (Qa(t))
      return t;
    if (on(t))
      return null;
    t = Xe(t);
  }
  return null;
}
function an() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ze(e) {
  return ["html", "body", "#document"].includes($t(e));
}
function Oe(e) {
  return _e(e).getComputedStyle(e);
}
function sn(e) {
  return te(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Xe(e) {
  if ($t(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Oa(e) && e.host || // Fallback.
    He(e)
  );
  return Oa(t) ? t.host : t;
}
function iu(e) {
  const t = Xe(e);
  return ze(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ee(t) && gr(t) ? t : iu(t);
}
function at(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = iu(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = _e(o);
  if (a) {
    const s = Ra(i);
    return t.concat(i, i.visualViewport || [], gr(o) ? o : [], s && r ? at(s) : []);
  }
  return t.concat(o, at(o, [], r));
}
function Ra(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Sa(e) {
  let t = e.activeElement;
  for (; ((r = t) == null || (r = r.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var r;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function Ke(e, t) {
  if (!e || !t)
    return !1;
  const r = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Oa(r)) {
    let n = t;
    for (; n; ) {
      if (e === n)
        return !0;
      n = n.parentNode || n.host;
    }
  }
  return !1;
}
function su() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function lu() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: r,
      version: n
    } = t;
    return r + "/" + n;
  }).join(" ") : navigator.userAgent;
}
function qp(e) {
  return Fp() ? !1 : !Zi() && e.width === 0 && e.height === 0 || Zi() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function cu() {
  return /apple/i.test(navigator.vendor);
}
function Zi() {
  const e = /android/i;
  return e.test(su()) || e.test(lu());
}
function jp() {
  return su().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Fp() {
  return lu().includes("jsdom/");
}
function lr(e, t) {
  const r = ["mouse", "pen"];
  return t || r.push("", void 0), r.includes(e);
}
function $p(e) {
  return "nativeEvent" in e;
}
function Bp(e) {
  return e.matches("html,body");
}
function ot(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Tn(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const r = e;
  return r.target != null && t.contains(r.target);
}
function ct(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Hp = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function uu(e) {
  return Ee(e) && e.matches(Hp);
}
const Nt = Math.min, dt = Math.max, Vr = Math.round, Nr = Math.floor, $e = (e) => ({
  x: e,
  y: e
}), Wp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Up = {
  start: "end",
  end: "start"
};
function Aa(e, t, r) {
  return dt(e, Nt(t, r));
}
function yr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vt(e) {
  return e.split("-")[0];
}
function br(e) {
  return e.split("-")[1];
}
function fu(e) {
  return e === "x" ? "y" : "x";
}
function ei(e) {
  return e === "y" ? "height" : "width";
}
function qt(e) {
  return ["top", "bottom"].includes(vt(e)) ? "y" : "x";
}
function ti(e) {
  return fu(qt(e));
}
function Vp(e, t, r) {
  r === void 0 && (r = !1);
  const n = br(e), o = ti(e), a = ei(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Yr(i)), [i, Yr(i)];
}
function Yp(e) {
  const t = Yr(e);
  return [ka(e), t, ka(t)];
}
function ka(e) {
  return e.replace(/start|end/g, (t) => Up[t]);
}
function zp(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function Kp(e, t, r, n) {
  const o = br(e);
  let a = zp(vt(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(ka)))), a;
}
function Yr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Wp[t]);
}
function Gp(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function du(e) {
  return typeof e != "number" ? Gp(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function zr(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
var qr = { exports: {} }, Zt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qi;
function Xp() {
  if (Qi) return Zt;
  Qi = 1;
  var e = x, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, p = null, f = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (f = l.ref);
    for (u in l) n.call(l, u) && !a.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: f, props: d, _owner: o.current };
  }
  return Zt.Fragment = r, Zt.jsx = i, Zt.jsxs = i, Zt;
}
var Qt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var es;
function Jp() {
  return es || (es = 1, process.env.NODE_ENV !== "production" && function() {
    var e = x, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m = Symbol.iterator, h = "@@iterator";
    function y(C) {
      if (C === null || typeof C != "object")
        return null;
      var $ = m && C[m] || C[h];
      return typeof $ == "function" ? $ : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(C) {
      {
        for (var $ = arguments.length, U = new Array($ > 1 ? $ - 1 : 0), Y = 1; Y < $; Y++)
          U[Y - 1] = arguments[Y];
        O("error", C, U);
      }
    }
    function O(C, $, U) {
      {
        var Y = b.ReactDebugCurrentFrame, ee = Y.getStackAddendum();
        ee !== "" && ($ += "%s", U = U.concat([ee]));
        var oe = U.map(function(Z) {
          return String(Z);
        });
        oe.unshift("Warning: " + $), Function.prototype.apply.call(console[C], console, oe);
      }
    }
    var _ = !1, S = !1, A = !1, P = !1, N = !1, j;
    j = Symbol.for("react.module.reference");
    function F(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === n || C === a || N || C === o || C === c || C === u || P || C === f || _ || S || A || typeof C == "object" && C !== null && (C.$$typeof === p || C.$$typeof === d || C.$$typeof === i || C.$$typeof === s || C.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === j || C.getModuleId !== void 0));
    }
    function M(C, $, U) {
      var Y = C.displayName;
      if (Y)
        return Y;
      var ee = $.displayName || $.name || "";
      return ee !== "" ? U + "(" + ee + ")" : U;
    }
    function I(C) {
      return C.displayName || "Context";
    }
    function D(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case s:
            var $ = C;
            return I($) + ".Consumer";
          case i:
            var U = C;
            return I(U._context) + ".Provider";
          case l:
            return M(C, C.render, "ForwardRef");
          case d:
            var Y = C.displayName || null;
            return Y !== null ? Y : D(C.type) || "Memo";
          case p: {
            var ee = C, oe = ee._payload, Z = ee._init;
            try {
              return D(Z(oe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, R = 0, g, v, E, k, q, H, V;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function z() {
      {
        if (R === 0) {
          g = console.log, v = console.info, E = console.warn, k = console.error, q = console.group, H = console.groupCollapsed, V = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        R++;
      }
    }
    function Q() {
      {
        if (R--, R === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, C, {
              value: g
            }),
            info: T({}, C, {
              value: v
            }),
            warn: T({}, C, {
              value: E
            }),
            error: T({}, C, {
              value: k
            }),
            group: T({}, C, {
              value: q
            }),
            groupCollapsed: T({}, C, {
              value: H
            }),
            groupEnd: T({}, C, {
              value: V
            })
          });
        }
        R < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = b.ReactCurrentDispatcher, ne;
    function K(C, $, U) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (ee) {
            var Y = ee.stack.trim().match(/\n( *(at )?)/);
            ne = Y && Y[1] || "";
          }
        return `
` + ne + C;
      }
    }
    var ae = !1, de;
    {
      var ve = typeof WeakMap == "function" ? WeakMap : Map;
      de = new ve();
    }
    function Ce(C, $) {
      if (!C || ae)
        return "";
      {
        var U = de.get(C);
        if (U !== void 0)
          return U;
      }
      var Y;
      ae = !0;
      var ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var oe;
      oe = re.current, re.current = null, z();
      try {
        if ($) {
          var Z = function() {
            throw Error();
          };
          if (Object.defineProperty(Z.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Z, []);
            } catch (ye) {
              Y = ye;
            }
            Reflect.construct(C, [], Z);
          } else {
            try {
              Z.call();
            } catch (ye) {
              Y = ye;
            }
            C.call(Z.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ye) {
            Y = ye;
          }
          C();
        }
      } catch (ye) {
        if (ye && Y && typeof ye.stack == "string") {
          for (var X = ye.stack.split(`
`), me = Y.stack.split(`
`), ie = X.length - 1, le = me.length - 1; ie >= 1 && le >= 0 && X[ie] !== me[le]; )
            le--;
          for (; ie >= 1 && le >= 0; ie--, le--)
            if (X[ie] !== me[le]) {
              if (ie !== 1 || le !== 1)
                do
                  if (ie--, le--, le < 0 || X[ie] !== me[le]) {
                    var Re = `
` + X[ie].replace(" at new ", " at ");
                    return C.displayName && Re.includes("<anonymous>") && (Re = Re.replace("<anonymous>", C.displayName)), typeof C == "function" && de.set(C, Re), Re;
                  }
                while (ie >= 1 && le >= 0);
              break;
            }
        }
      } finally {
        ae = !1, re.current = oe, Q(), Error.prepareStackTrace = ee;
      }
      var Ct = C ? C.displayName || C.name : "", st = Ct ? K(Ct) : "";
      return typeof C == "function" && de.set(C, st), st;
    }
    function yt(C, $, U) {
      return Ce(C, !1);
    }
    function Wt(C) {
      var $ = C.prototype;
      return !!($ && $.isReactComponent);
    }
    function Ze(C, $, U) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return Ce(C, Wt(C));
      if (typeof C == "string")
        return K(C);
      switch (C) {
        case c:
          return K("Suspense");
        case u:
          return K("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case l:
            return yt(C.render);
          case d:
            return Ze(C.type, $, U);
          case p: {
            var Y = C, ee = Y._payload, oe = Y._init;
            try {
              return Ze(oe(ee), $, U);
            } catch {
            }
          }
        }
      return "";
    }
    var Qe = Object.prototype.hasOwnProperty, Ut = {}, Or = b.ReactDebugCurrentFrame;
    function bt(C) {
      if (C) {
        var $ = C._owner, U = Ze(C.type, C._source, $ ? $.type : null);
        Or.setExtraStackFrame(U);
      } else
        Or.setExtraStackFrame(null);
    }
    function Ue(C, $, U, Y, ee) {
      {
        var oe = Function.call.bind(Qe);
        for (var Z in C)
          if (oe(C, Z)) {
            var X = void 0;
            try {
              if (typeof C[Z] != "function") {
                var me = Error((Y || "React class") + ": " + U + " type `" + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[Z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw me.name = "Invariant Violation", me;
              }
              X = C[Z]($, Z, Y, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ie) {
              X = ie;
            }
            X && !(X instanceof Error) && (bt(ee), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", U, Z, typeof X), bt(null)), X instanceof Error && !(X.message in Ut) && (Ut[X.message] = !0, bt(ee), w("Failed %s type: %s", U, X.message), bt(null));
          }
      }
    }
    var wt = Array.isArray;
    function _t(C) {
      return wt(C);
    }
    function Rr(C) {
      {
        var $ = typeof Symbol == "function" && Symbol.toStringTag, U = $ && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return U;
      }
    }
    function Vt(C) {
      try {
        return Yt(C), !1;
      } catch {
        return !0;
      }
    }
    function Yt(C) {
      return "" + C;
    }
    function zt(C) {
      if (Vt(C))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rr(C)), Yt(C);
    }
    var Kt = b.ReactCurrentOwner, Sr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pi, hi;
    function pf(C) {
      if (Qe.call(C, "ref")) {
        var $ = Object.getOwnPropertyDescriptor(C, "ref").get;
        if ($ && $.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function hf(C) {
      if (Qe.call(C, "key")) {
        var $ = Object.getOwnPropertyDescriptor(C, "key").get;
        if ($ && $.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function vf(C, $) {
      typeof C.ref == "string" && Kt.current;
    }
    function mf(C, $) {
      {
        var U = function() {
          pi || (pi = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
        };
        U.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: U,
          configurable: !0
        });
      }
    }
    function gf(C, $) {
      {
        var U = function() {
          hi || (hi = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
        };
        U.isReactWarning = !0, Object.defineProperty(C, "ref", {
          get: U,
          configurable: !0
        });
      }
    }
    var yf = function(C, $, U, Y, ee, oe, Z) {
      var X = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: C,
        key: $,
        ref: U,
        props: Z,
        // Record the component responsible for creating this element.
        _owner: oe
      };
      return X._store = {}, Object.defineProperty(X._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(X, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(X, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ee
      }), Object.freeze && (Object.freeze(X.props), Object.freeze(X)), X;
    };
    function bf(C, $, U, Y, ee) {
      {
        var oe, Z = {}, X = null, me = null;
        U !== void 0 && (zt(U), X = "" + U), hf($) && (zt($.key), X = "" + $.key), pf($) && (me = $.ref, vf($, ee));
        for (oe in $)
          Qe.call($, oe) && !Sr.hasOwnProperty(oe) && (Z[oe] = $[oe]);
        if (C && C.defaultProps) {
          var ie = C.defaultProps;
          for (oe in ie)
            Z[oe] === void 0 && (Z[oe] = ie[oe]);
        }
        if (X || me) {
          var le = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
          X && mf(Z, le), me && gf(Z, le);
        }
        return yf(C, X, me, ee, Y, Kt.current, Z);
      }
    }
    var gn = b.ReactCurrentOwner, vi = b.ReactDebugCurrentFrame;
    function Et(C) {
      if (C) {
        var $ = C._owner, U = Ze(C.type, C._source, $ ? $.type : null);
        vi.setExtraStackFrame(U);
      } else
        vi.setExtraStackFrame(null);
    }
    var yn;
    yn = !1;
    function bn(C) {
      return typeof C == "object" && C !== null && C.$$typeof === t;
    }
    function mi() {
      {
        if (gn.current) {
          var C = D(gn.current.type);
          if (C)
            return `

Check the render method of \`` + C + "`.";
        }
        return "";
      }
    }
    function wf(C) {
      return "";
    }
    var gi = {};
    function _f(C) {
      {
        var $ = mi();
        if (!$) {
          var U = typeof C == "string" ? C : C.displayName || C.name;
          U && ($ = `

Check the top-level render call using <` + U + ">.");
        }
        return $;
      }
    }
    function yi(C, $) {
      {
        if (!C._store || C._store.validated || C.key != null)
          return;
        C._store.validated = !0;
        var U = _f($);
        if (gi[U])
          return;
        gi[U] = !0;
        var Y = "";
        C && C._owner && C._owner !== gn.current && (Y = " It was passed a child from " + D(C._owner.type) + "."), Et(C), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, Y), Et(null);
      }
    }
    function bi(C, $) {
      {
        if (typeof C != "object")
          return;
        if (_t(C))
          for (var U = 0; U < C.length; U++) {
            var Y = C[U];
            bn(Y) && yi(Y, $);
          }
        else if (bn(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var ee = y(C);
          if (typeof ee == "function" && ee !== C.entries)
            for (var oe = ee.call(C), Z; !(Z = oe.next()).done; )
              bn(Z.value) && yi(Z.value, $);
        }
      }
    }
    function Ef(C) {
      {
        var $ = C.type;
        if ($ == null || typeof $ == "string")
          return;
        var U;
        if (typeof $ == "function")
          U = $.propTypes;
        else if (typeof $ == "object" && ($.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $.$$typeof === d))
          U = $.propTypes;
        else
          return;
        if (U) {
          var Y = D($);
          Ue(U, C.props, "prop", Y, C);
        } else if ($.PropTypes !== void 0 && !yn) {
          yn = !0;
          var ee = D($);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ee || "Unknown");
        }
        typeof $.getDefaultProps == "function" && !$.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Cf(C) {
      {
        for (var $ = Object.keys(C.props), U = 0; U < $.length; U++) {
          var Y = $[U];
          if (Y !== "children" && Y !== "key") {
            Et(C), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), Et(null);
            break;
          }
        }
        C.ref !== null && (Et(C), w("Invalid attribute `ref` supplied to `React.Fragment`."), Et(null));
      }
    }
    var wi = {};
    function _i(C, $, U, Y, ee, oe) {
      {
        var Z = F(C);
        if (!Z) {
          var X = "";
          (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (X += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var me = wf();
          me ? X += me : X += mi();
          var ie;
          C === null ? ie = "null" : _t(C) ? ie = "array" : C !== void 0 && C.$$typeof === t ? (ie = "<" + (D(C.type) || "Unknown") + " />", X = " Did you accidentally export a JSX literal instead of a component?") : ie = typeof C, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ie, X);
        }
        var le = bf(C, $, U, ee, oe);
        if (le == null)
          return le;
        if (Z) {
          var Re = $.children;
          if (Re !== void 0)
            if (Y)
              if (_t(Re)) {
                for (var Ct = 0; Ct < Re.length; Ct++)
                  bi(Re[Ct], C);
                Object.freeze && Object.freeze(Re);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              bi(Re, C);
        }
        if (Qe.call($, "key")) {
          var st = D(C), ye = Object.keys($).filter(function(Af) {
            return Af !== "key";
          }), wn = ye.length > 0 ? "{key: someKey, " + ye.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wi[st + wn]) {
            var Sf = ye.length > 0 ? "{" + ye.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wn, st, Sf, st), wi[st + wn] = !0;
          }
        }
        return C === n ? Cf(le) : Ef(le), le;
      }
    }
    function xf(C, $, U) {
      return _i(C, $, U, !0);
    }
    function Tf(C, $, U) {
      return _i(C, $, U, !1);
    }
    var Of = Tf, Rf = xf;
    Qt.Fragment = n, Qt.jsx = Of, Qt.jsxs = Rf;
  }()), Qt;
}
var ts;
function Zp() {
  return ts || (ts = 1, process.env.NODE_ENV === "production" ? qr.exports = Xp() : qr.exports = Jp()), qr.exports;
}
var je = Zp();
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Qp = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Pa = /* @__PURE__ */ Qp.join(","), pu = typeof Element > "u", cr = pu ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Kr = !pu && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Gr = function e(t, r) {
  var n;
  r === void 0 && (r = !0);
  var o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "inert"), a = o === "" || o === "true", i = a || r && t && e(t.parentNode);
  return i;
}, eh = function(t) {
  var r, n = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
  return n === "" || n === "true";
}, th = function(t, r, n) {
  if (Gr(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Pa));
  return r && cr.call(t, Pa) && o.unshift(t), o = o.filter(n), o;
}, rh = function e(t, r, n) {
  for (var o = [], a = Array.from(t); a.length; ) {
    var i = a.shift();
    if (!Gr(i, !1))
      if (i.tagName === "SLOT") {
        var s = i.assignedElements(), l = s.length ? s : i.children, c = e(l, !0, n);
        n.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: i,
          candidates: c
        });
      } else {
        var u = cr.call(i, Pa);
        u && n.filter(i) && (r || !t.includes(i)) && o.push(i);
        var d = i.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(i), p = !Gr(d, !1) && (!n.shadowRootFilter || n.shadowRootFilter(i));
        if (d && p) {
          var f = e(d === !0 ? i.children : d.children, !0, n);
          n.flatten ? o.push.apply(o, f) : o.push({
            scopeParent: i,
            candidates: f
          });
        } else
          a.unshift.apply(a, i.children);
      }
  }
  return o;
}, hu = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, vu = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || eh(t)) && !hu(t) ? 0 : t.tabIndex;
}, nh = function(t, r) {
  var n = vu(t);
  return n < 0 && r && !hu(t) ? 0 : n;
}, oh = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, mu = function(t) {
  return t.tagName === "INPUT";
}, ah = function(t) {
  return mu(t) && t.type === "hidden";
}, ih = function(t) {
  var r = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return r;
}, sh = function(t, r) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === r)
      return t[n];
}, lh = function(t) {
  if (!t.name)
    return !0;
  var r = t.form || Kr(t), n = function(s) {
    return r.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = n(window.CSS.escape(t.name));
  else
    try {
      o = n(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var a = sh(o, t.form);
  return !a || a === t;
}, ch = function(t) {
  return mu(t) && t.type === "radio";
}, uh = function(t) {
  return ch(t) && !lh(t);
}, fh = function(t) {
  var r, n = t && Kr(t), o = (r = n) === null || r === void 0 ? void 0 : r.host, a = !1;
  if (n && n !== t) {
    var i, s, l;
    for (a = !!((i = o) !== null && i !== void 0 && (s = i.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && o; ) {
      var c, u, d;
      n = Kr(o), o = (c = n) === null || c === void 0 ? void 0 : c.host, a = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return a;
}, rs = function(t) {
  var r = t.getBoundingClientRect(), n = r.width, o = r.height;
  return n === 0 && o === 0;
}, dh = function(t, r) {
  var n = r.displayCheck, o = r.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = cr.call(t, "details>summary:first-of-type"), i = a ? t.parentElement : t;
  if (cr.call(i, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = Kr(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return rs(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (fh(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return rs(t);
  return !1;
}, ph = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var n = 0; n < r.children.length; n++) {
          var o = r.children.item(n);
          if (o.tagName === "LEGEND")
            return cr.call(r, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, hh = function(t, r) {
  return !(r.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Gr(r) || ah(r) || dh(r, t) || // For a details element with a summary, the summary element gets the focus
  ih(r) || ph(r));
}, ns = function(t, r) {
  return !(uh(r) || vu(r) < 0 || !hh(t, r));
}, vh = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, mh = function e(t) {
  var r = [], n = [];
  return t.forEach(function(o, a) {
    var i = !!o.scopeParent, s = i ? o.scopeParent : o, l = nh(s, i), c = i ? e(o.candidates) : s;
    l === 0 ? i ? r.push.apply(r, c) : r.push(s) : n.push({
      documentOrder: a,
      tabIndex: l,
      item: o,
      isScope: i,
      content: c
    });
  }), n.sort(oh).reduce(function(o, a) {
    return a.isScope ? o.push.apply(o, a.content) : o.push(a.content), o;
  }, []).concat(r);
}, gu = function(t, r) {
  r = r || {};
  var n;
  return r.getShadowRoot ? n = rh([t], r.includeContainer, {
    filter: ns.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: vh
  }) : n = th(t, r.includeContainer, ns.bind(null, r)), mh(n);
};
function os(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = qt(t), i = ti(t), s = ei(i), l = vt(t), c = a === "y", u = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, p = n[s] / 2 - o[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (br(t)) {
    case "start":
      f[i] -= p * (r && c ? -1 : 1);
      break;
    case "end":
      f[i] += p * (r && c ? -1 : 1);
      break;
  }
  return f;
}
const gh = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = os(c, n, l), p = n, f = {}, m = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: y,
      fn: b
    } = s[h], {
      x: w,
      y: O,
      data: _,
      reset: S
    } = await b({
      x: u,
      y: d,
      initialPlacement: n,
      placement: p,
      strategy: o,
      middlewareData: f,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, d = O ?? d, f = {
      ...f,
      [y]: {
        ...f[y],
        ..._
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (c = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: u,
      y: d
    } = os(c, p, l)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: o,
    middlewareData: f
  };
};
async function yu(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = yr(t, e), m = du(f), y = s[p ? d === "floating" ? "reference" : "floating" : d], b = zr(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(y))) == null || r ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement(O)) ? await (a.getScale == null ? void 0 : a.getScale(O)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = zr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: O,
    strategy: l
  }) : w);
  return {
    top: (b.top - S.top + m.top) / _.y,
    bottom: (S.bottom - b.bottom + m.bottom) / _.y,
    left: (b.left - S.left + m.left) / _.x,
    right: (S.right - b.right + m.right) / _.x
  };
}
const yh = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = yr(e, t) || {};
    if (c == null)
      return {};
    const d = du(u), p = {
      x: r,
      y: n
    }, f = ti(o), m = ei(f), h = await i.getDimensions(c), y = f === "y", b = y ? "top" : "left", w = y ? "bottom" : "right", O = y ? "clientHeight" : "clientWidth", _ = a.reference[m] + a.reference[f] - p[f] - a.floating[m], S = p[f] - a.reference[f], A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let P = A ? A[O] : 0;
    (!P || !await (i.isElement == null ? void 0 : i.isElement(A))) && (P = s.floating[O] || a.floating[m]);
    const N = _ / 2 - S / 2, j = P / 2 - h[m] / 2 - 1, F = Nt(d[b], j), M = Nt(d[w], j), I = F, D = P - h[m] - M, T = P / 2 - h[m] / 2 + N, R = Aa(I, T, D), g = !l.arrow && br(o) != null && T !== R && a.reference[m] / 2 - (T < I ? F : M) - h[m] / 2 < 0, v = g ? T < I ? T - I : T - D : 0;
    return {
      [f]: p[f] + v,
      data: {
        [f]: R,
        centerOffset: T - R - v,
        ...g && {
          alignmentOffset: v
        }
      },
      reset: g
    };
  }
}), bh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...y
      } = yr(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const b = vt(o), w = qt(s), O = vt(s) === s, _ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = p || (O || !h ? [Yr(s)] : Yp(s)), A = m !== "none";
      !p && A && S.push(...Kp(s, h, m, _));
      const P = [s, ...S], N = await yu(t, y), j = [];
      let F = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (u && j.push(N[b]), d) {
        const T = Vp(o, i, _);
        j.push(N[T[0]], N[T[1]]);
      }
      if (F = [...F, {
        placement: o,
        overflows: j
      }], !j.every((T) => T <= 0)) {
        var M, I;
        const T = (((M = a.flip) == null ? void 0 : M.index) || 0) + 1, R = P[T];
        if (R)
          return {
            data: {
              index: T,
              overflows: F
            },
            reset: {
              placement: R
            }
          };
        let g = (I = F.filter((v) => v.overflows[0] <= 0).sort((v, E) => v.overflows[1] - E.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!g)
          switch (f) {
            case "bestFit": {
              var D;
              const v = (D = F.filter((E) => {
                if (A) {
                  const k = qt(E.placement);
                  return k === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  k === "y";
                }
                return !0;
              }).map((E) => [E.placement, E.overflows.filter((k) => k > 0).reduce((k, q) => k + q, 0)]).sort((E, k) => E[1] - k[1])[0]) == null ? void 0 : D[0];
              v && (g = v);
              break;
            }
            case "initialPlacement":
              g = s;
              break;
          }
        if (o !== g)
          return {
            reset: {
              placement: g
            }
          };
      }
      return {};
    }
  };
};
async function wh(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = vt(r), s = br(r), l = qt(r) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = a && l ? -1 : 1, d = yr(t, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (f = s === "end" ? m * -1 : m), l ? {
    x: f * u,
    y: p * c
  } : {
    x: p * c,
    y: f * u
  };
}
const _h = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await wh(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, Eh = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: w
            } = y;
            return {
              x: b,
              y: w
            };
          }
        },
        ...l
      } = yr(e, t), c = {
        x: r,
        y: n
      }, u = await yu(t, l), d = qt(vt(o)), p = fu(d);
      let f = c[p], m = c[d];
      if (a) {
        const y = p === "y" ? "top" : "left", b = p === "y" ? "bottom" : "right", w = f + u[y], O = f - u[b];
        f = Aa(w, f, O);
      }
      if (i) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", w = m + u[y], O = m - u[b];
        m = Aa(w, m, O);
      }
      const h = s.fn({
        ...t,
        [p]: f,
        [d]: m
      });
      return {
        ...h,
        data: {
          x: h.x - r,
          y: h.y - n,
          enabled: {
            [p]: a,
            [d]: i
          }
        }
      };
    }
  };
};
function bu(e) {
  const t = Oe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Ee(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, s = Vr(r) !== a || Vr(n) !== i;
  return s && (r = a, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function ri(e) {
  return te(e) ? e : e.contextElement;
}
function Pt(e) {
  const t = ri(e);
  if (!Ee(t))
    return $e(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = bu(t);
  let i = (a ? Vr(r.width) : r.width) / n, s = (a ? Vr(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Ch = /* @__PURE__ */ $e(0);
function wu(e) {
  const t = _e(e);
  return !an() || !t.visualViewport ? Ch : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function xh(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== _e(e) ? !1 : t;
}
function mt(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = ri(e);
  let i = $e(1);
  t && (n ? te(n) && (i = Pt(n)) : i = Pt(e));
  const s = xh(a, r, n) ? wu(a) : $e(0);
  let l = (o.left + s.x) / i.x, c = (o.top + s.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (a) {
    const p = _e(a), f = n && te(n) ? _e(n) : n;
    let m = p, h = Ra(m);
    for (; h && n && f !== m; ) {
      const y = Pt(h), b = h.getBoundingClientRect(), w = Oe(h), O = b.left + (h.clientLeft + parseFloat(w.paddingLeft)) * y.x, _ = b.top + (h.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += O, c += _, m = _e(h), h = Ra(m);
    }
  }
  return zr({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function ni(e, t) {
  const r = sn(e).scrollLeft;
  return t ? t.left + r : mt(He(e)).left + r;
}
function _u(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    ni(e, n)
  )), a = n.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function Th(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = He(n), s = t ? on(t.floating) : !1;
  if (n === i || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = $e(1);
  const u = $e(0), d = Ee(n);
  if ((d || !d && !a) && (($t(n) !== "body" || gr(i)) && (l = sn(n)), Ee(n))) {
    const f = mt(n);
    c = Pt(n), u.x = f.x + n.clientLeft, u.y = f.y + n.clientTop;
  }
  const p = i && !d && !a ? _u(i, l, !0) : $e(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: r.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function Oh(e) {
  return Array.from(e.getClientRects());
}
function Rh(e) {
  const t = He(e), r = sn(e), n = e.ownerDocument.body, o = dt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = dt(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + ni(e);
  const s = -r.scrollTop;
  return Oe(n).direction === "rtl" && (i += dt(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function Sh(e, t) {
  const r = _e(e), n = He(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = an();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function Ah(e, t) {
  const r = mt(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = Ee(e) ? Pt(e) : $e(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, c = n * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function as(e, t, r) {
  let n;
  if (t === "viewport")
    n = Sh(e, r);
  else if (t === "document")
    n = Rh(He(e));
  else if (te(t))
    n = Ah(t, r);
  else {
    const o = wu(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return zr(n);
}
function Eu(e, t) {
  const r = Xe(e);
  return r === t || !te(r) || ze(r) ? !1 : Oe(r).position === "fixed" || Eu(r, t);
}
function kh(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = at(e, [], !1).filter((s) => te(s) && $t(s) !== "body"), o = null;
  const a = Oe(e).position === "fixed";
  let i = a ? Xe(e) : e;
  for (; te(i) && !ze(i); ) {
    const s = Oe(i), l = Qa(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || gr(i) && !l && Eu(e, i)) ? n = n.filter((u) => u !== i) : o = s, i = Xe(i);
  }
  return t.set(e, n), n;
}
function Ph(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...r === "clippingAncestors" ? on(t) ? [] : kh(t, this._c) : [].concat(r), n], s = i[0], l = i.reduce((c, u) => {
    const d = as(t, u, o);
    return c.top = dt(d.top, c.top), c.right = Nt(d.right, c.right), c.bottom = Nt(d.bottom, c.bottom), c.left = dt(d.left, c.left), c;
  }, as(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Mh(e) {
  const {
    width: t,
    height: r
  } = bu(e);
  return {
    width: t,
    height: r
  };
}
function Dh(e, t, r) {
  const n = Ee(t), o = He(t), a = r === "fixed", i = mt(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = $e(0);
  if (n || !n && !a)
    if (($t(t) !== "body" || gr(o)) && (s = sn(t)), n) {
      const p = mt(t, !0, a, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else o && (l.x = ni(o));
  const c = o && !n && !a ? _u(o, s) : $e(0), u = i.left + s.scrollLeft - l.x - c.x, d = i.top + s.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function On(e) {
  return Oe(e).position === "static";
}
function is(e, t) {
  if (!Ee(e) || Oe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return He(e) === r && (r = r.ownerDocument.body), r;
}
function Cu(e, t) {
  const r = _e(e);
  if (on(e))
    return r;
  if (!Ee(e)) {
    let o = Xe(e);
    for (; o && !ze(o); ) {
      if (te(o) && !On(o))
        return o;
      o = Xe(o);
    }
    return r;
  }
  let n = is(e, t);
  for (; n && Ip(n) && On(n); )
    n = is(n, t);
  return n && ze(n) && On(n) && !Qa(n) ? r : n || Np(e) || r;
}
const Lh = async function(e) {
  const t = this.getOffsetParent || Cu, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: Dh(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Ih(e) {
  return Oe(e).direction === "rtl";
}
const Nh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Th,
  getDocumentElement: He,
  getClippingRect: Ph,
  getOffsetParent: Cu,
  getElementRects: Lh,
  getClientRects: Oh,
  getDimensions: Mh,
  getScale: Pt,
  isElement: te,
  isRTL: Ih
};
function xu(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function qh(e, t) {
  let r = null, n;
  const o = He(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: f
    } = c;
    if (s || t(), !p || !f)
      return;
    const m = Nr(d), h = Nr(o.clientWidth - (u + p)), y = Nr(o.clientHeight - (d + f)), b = Nr(u), O = {
      rootMargin: -m + "px " + -h + "px " + -y + "px " + -b + "px",
      threshold: dt(0, Nt(1, l)) || 1
    };
    let _ = !0;
    function S(A) {
      const P = A[0].intersectionRatio;
      if (P !== l) {
        if (!_)
          return i();
        P ? i(!1, P) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !xu(c, e.getBoundingClientRect()) && i(), _ = !1;
    }
    try {
      r = new IntersectionObserver(S, {
        ...O,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(S, O);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function jh(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = ri(e), u = o || a ? [...c ? at(c) : [], ...at(t)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", r, {
      passive: !0
    }), a && b.addEventListener("resize", r);
  });
  const d = c && s ? qh(c, r) : null;
  let p = -1, f = null;
  i && (f = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === c && f && (f.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var O;
      (O = f) == null || O.observe(t);
    })), r();
  }), c && !l && f.observe(c), f.observe(t));
  let m, h = l ? mt(e) : null;
  l && y();
  function y() {
    const b = mt(e);
    h && !xu(h, b) && r(), h = b, m = requestAnimationFrame(y);
  }
  return r(), () => {
    var b;
    u.forEach((w) => {
      o && w.removeEventListener("scroll", r), a && w.removeEventListener("resize", r);
    }), d == null || d(), (b = f) == null || b.disconnect(), f = null, l && cancelAnimationFrame(m);
  };
}
const Fh = _h, $h = Eh, Bh = bh, ss = yh, Hh = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: Nh,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return gh(e, t, {
    ...o,
    platform: a
  });
};
var $r = typeof document < "u" ? hr : he;
function Xr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Xr(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Xr(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Tu(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ls(e, t) {
  const r = Tu(e);
  return Math.round(t * r) / r;
}
function Rn(e) {
  const t = L.useRef(e);
  return $r(() => {
    t.current = e;
  }), t;
}
function Wh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = L.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = L.useState(n);
  Xr(p, n) || f(n);
  const [m, h] = L.useState(null), [y, b] = L.useState(null), w = L.useCallback((E) => {
    E !== A.current && (A.current = E, h(E));
  }, []), O = L.useCallback((E) => {
    E !== P.current && (P.current = E, b(E));
  }, []), _ = a || m, S = i || y, A = L.useRef(null), P = L.useRef(null), N = L.useRef(u), j = l != null, F = Rn(l), M = Rn(o), I = Rn(c), D = L.useCallback(() => {
    if (!A.current || !P.current)
      return;
    const E = {
      placement: t,
      strategy: r,
      middleware: p
    };
    M.current && (E.platform = M.current), Hh(A.current, P.current, E).then((k) => {
      const q = {
        ...k,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      T.current && !Xr(N.current, q) && (N.current = q, Wa.flushSync(() => {
        d(q);
      }));
    });
  }, [p, t, r, M, I]);
  $r(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((E) => ({
      ...E,
      isPositioned: !1
    })));
  }, [c]);
  const T = L.useRef(!1);
  $r(() => (T.current = !0, () => {
    T.current = !1;
  }), []), $r(() => {
    if (_ && (A.current = _), S && (P.current = S), _ && S) {
      if (F.current)
        return F.current(_, S, D);
      D();
    }
  }, [_, S, D, F, j]);
  const R = L.useMemo(() => ({
    reference: A,
    floating: P,
    setReference: w,
    setFloating: O
  }), [w, O]), g = L.useMemo(() => ({
    reference: _,
    floating: S
  }), [_, S]), v = L.useMemo(() => {
    const E = {
      position: r,
      left: 0,
      top: 0
    };
    if (!g.floating)
      return E;
    const k = ls(g.floating, u.x), q = ls(g.floating, u.y);
    return s ? {
      ...E,
      transform: "translate(" + k + "px, " + q + "px)",
      ...Tu(g.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: k,
      top: q
    };
  }, [r, s, g.floating, u.x, u.y]);
  return L.useMemo(() => ({
    ...u,
    update: D,
    refs: R,
    elements: g,
    floatingStyles: v
  }), [u, D, R, g, v]);
}
const Uh = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? ss({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? ss({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, Vh = (e, t) => ({
  ...Fh(e),
  options: [e, t]
}), Yh = (e, t) => ({
  ...$h(e),
  options: [e, t]
}), zh = (e, t) => ({
  ...Bh(e),
  options: [e, t]
}), Kh = (e, t) => ({
  ...Uh(e),
  options: [e, t]
});
function Ou(e) {
  const t = L.useRef(void 0), r = L.useCallback((n) => {
    const o = e.map((a) => {
      if (a != null) {
        if (typeof a == "function") {
          const i = a, s = i(n);
          return typeof s == "function" ? s : () => {
            i(null);
          };
        }
        return a.current = n, () => {
          a.current = null;
        };
      }
    });
    return () => {
      o.forEach((a) => a == null ? void 0 : a());
    };
  }, e);
  return L.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    t.current && (t.current(), t.current = void 0), n != null && (t.current = r(n));
  }, e);
}
const Ru = {
  ...L
}, Gh = Ru.useInsertionEffect, Xh = Gh || ((e) => e());
function Ye(e) {
  const t = L.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Xh(() => {
    t.current = e;
  }), L.useCallback(function() {
    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
var Ne = typeof document < "u" ? hr : he;
let cs = !1, Jh = 0;
const us = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Jh++
);
function Zh() {
  const [e, t] = L.useState(() => cs ? us() : void 0);
  return Ne(() => {
    e == null && t(us());
  }, []), L.useEffect(() => {
    cs = !0;
  }, []), e;
}
const Qh = Ru.useId, ln = Qh || Zh;
let ur;
process.env.NODE_ENV !== "production" && (ur = /* @__PURE__ */ new Set());
function ev() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const o = "Floating UI: " + r.join(" ");
  if (!((e = ur) != null && e.has(o))) {
    var a;
    (a = ur) == null || a.add(o), console.warn(o);
  }
}
function tv() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const o = "Floating UI: " + r.join(" ");
  if (!((e = ur) != null && e.has(o))) {
    var a;
    (a = ur) == null || a.add(o), console.error(o);
  }
}
const rv = /* @__PURE__ */ L.forwardRef(function(t, r) {
  const {
    context: {
      placement: n,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: a,
        shift: i
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: d,
    stroke: p,
    d: f,
    style: {
      transform: m,
      ...h
    } = {},
    ...y
  } = t;
  process.env.NODE_ENV !== "production" && (r || ev("The `ref` prop is required for `FloatingArrow`."));
  const b = ln(), [w, O] = L.useState(!1);
  if (Ne(() => {
    if (!o) return;
    Oe(o).direction === "rtl" && O(!0);
  }, [o]), !o)
    return null;
  const [_, S] = n.split("-"), A = _ === "top" || _ === "bottom";
  let P = d;
  (A && i != null && i.x || !A && i != null && i.y) && (P = null);
  const N = u * 2, j = N / 2, F = s / 2 * (c / -8 + 1), M = l / 2 * c / 4, I = !!f, D = P && S === "end" ? "bottom" : "top";
  let T = P && S === "end" ? "right" : "left";
  P && w && (T = S === "end" ? "left" : "right");
  const R = (a == null ? void 0 : a.x) != null ? P || a.x : "", g = (a == null ? void 0 : a.y) != null ? P || a.y : "", v = f || "M0,0" + (" H" + s) + (" L" + (s - F) + "," + (l - M)) + (" Q" + s / 2 + "," + l + " " + F + "," + (l - M)) + " Z", E = {
    top: I ? "rotate(180deg)" : "",
    left: I ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: I ? "" : "rotate(180deg)",
    right: I ? "rotate(-90deg)" : "rotate(90deg)"
  }[_];
  return /* @__PURE__ */ je.jsxs("svg", {
    ...y,
    "aria-hidden": !0,
    ref: r,
    width: I ? s : s + N,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [T]: R,
      [D]: g,
      [_]: A || I ? "100%" : "calc(100% - " + N / 2 + "px)",
      transform: [E, m].filter((k) => !!k).join(" "),
      ...h
    },
    children: [N > 0 && /* @__PURE__ */ je.jsx("path", {
      clipPath: "url(#" + b + ")",
      fill: "none",
      stroke: p,
      strokeWidth: N + (f ? 0 : 1),
      d: v
    }), /* @__PURE__ */ je.jsx("path", {
      stroke: N && !f ? y.fill : "none",
      d: v
    }), /* @__PURE__ */ je.jsx("clipPath", {
      id: b,
      children: /* @__PURE__ */ je.jsx("rect", {
        x: -j,
        y: j * (I ? -1 : 1),
        width: s + N,
        height: s
      })
    })]
  });
});
function nv() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      var n;
      (n = e.get(t)) == null || n.forEach((o) => o(r));
    },
    on(t, r) {
      e.set(t, [...e.get(t) || [], r]);
    },
    off(t, r) {
      var n;
      e.set(t, ((n = e.get(t)) == null ? void 0 : n.filter((o) => o !== r)) || []);
    }
  };
}
const ov = /* @__PURE__ */ L.createContext(null), av = /* @__PURE__ */ L.createContext(null), oi = () => {
  var e;
  return ((e = L.useContext(ov)) == null ? void 0 : e.id) || null;
}, ai = () => L.useContext(av);
function wr(e) {
  return "data-floating-ui-" + e;
}
function Ae(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
function Sn(e) {
  const t = ue(e);
  return Ne(() => {
    t.current = e;
  }), t;
}
const fs = /* @__PURE__ */ wr("safe-polygon");
function An(e, t, r) {
  return r && !lr(r) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function iv(e, t) {
  t === void 0 && (t = {});
  const {
    open: r,
    onOpenChange: n,
    dataRef: o,
    events: a,
    elements: i
  } = e, {
    enabled: s = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: u = !1,
    restMs: d = 0,
    move: p = !0
  } = t, f = ai(), m = oi(), h = Sn(c), y = Sn(l), b = Sn(r), w = L.useRef(), O = L.useRef(-1), _ = L.useRef(), S = L.useRef(-1), A = L.useRef(!0), P = L.useRef(!1), N = L.useRef(() => {
  }), j = L.useRef(!1), F = L.useCallback(() => {
    var v;
    const E = (v = o.current.openEvent) == null ? void 0 : v.type;
    return (E == null ? void 0 : E.includes("mouse")) && E !== "mousedown";
  }, [o]);
  L.useEffect(() => {
    if (!s) return;
    function v(E) {
      let {
        open: k
      } = E;
      k || (Ae(O), Ae(S), A.current = !0, j.current = !1);
    }
    return a.on("openchange", v), () => {
      a.off("openchange", v);
    };
  }, [s, a]), L.useEffect(() => {
    if (!s || !h.current || !r) return;
    function v(k) {
      F() && n(!1, k, "hover");
    }
    const E = ot(i.floating).documentElement;
    return E.addEventListener("mouseleave", v), () => {
      E.removeEventListener("mouseleave", v);
    };
  }, [i.floating, r, n, s, h, F]);
  const M = L.useCallback(function(v, E, k) {
    E === void 0 && (E = !0), k === void 0 && (k = "hover");
    const q = An(y.current, "close", w.current);
    q && !_.current ? (Ae(O), O.current = window.setTimeout(() => n(!1, v, k), q)) : E && (Ae(O), n(!1, v, k));
  }, [y, n]), I = Ye(() => {
    N.current(), _.current = void 0;
  }), D = Ye(() => {
    if (P.current) {
      const v = ot(i.floating).body;
      v.style.pointerEvents = "", v.removeAttribute(fs), P.current = !1;
    }
  }), T = Ye(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  L.useEffect(() => {
    if (!s) return;
    function v(H) {
      if (Ae(O), A.current = !1, u && !lr(w.current) || d > 0 && !An(y.current, "open"))
        return;
      const V = An(y.current, "open", w.current);
      V ? O.current = window.setTimeout(() => {
        b.current || n(!0, H, "hover");
      }, V) : r || n(!0, H, "hover");
    }
    function E(H) {
      if (T()) return;
      N.current();
      const V = ot(i.floating);
      if (Ae(S), j.current = !1, h.current && o.current.floatingContext) {
        r || Ae(O), _.current = h.current({
          ...o.current.floatingContext,
          tree: f,
          x: H.clientX,
          y: H.clientY,
          onClose() {
            D(), I(), T() || M(H, !0, "safe-polygon");
          }
        });
        const z = _.current;
        V.addEventListener("mousemove", z), N.current = () => {
          V.removeEventListener("mousemove", z);
        };
        return;
      }
      (w.current === "touch" ? !Ke(i.floating, H.relatedTarget) : !0) && M(H);
    }
    function k(H) {
      T() || o.current.floatingContext && (h.current == null || h.current({
        ...o.current.floatingContext,
        tree: f,
        x: H.clientX,
        y: H.clientY,
        onClose() {
          D(), I(), T() || M(H);
        }
      })(H));
    }
    if (te(i.domReference)) {
      var q;
      const H = i.domReference;
      return r && H.addEventListener("mouseleave", k), (q = i.floating) == null || q.addEventListener("mouseleave", k), p && H.addEventListener("mousemove", v, {
        once: !0
      }), H.addEventListener("mouseenter", v), H.addEventListener("mouseleave", E), () => {
        var V;
        r && H.removeEventListener("mouseleave", k), (V = i.floating) == null || V.removeEventListener("mouseleave", k), p && H.removeEventListener("mousemove", v), H.removeEventListener("mouseenter", v), H.removeEventListener("mouseleave", E);
      };
    }
  }, [i, s, e, u, d, p, M, I, D, n, r, b, f, y, h, o, T]), Ne(() => {
    var v;
    if (s && r && (v = h.current) != null && v.__options.blockPointerEvents && F()) {
      P.current = !0;
      const k = i.floating;
      if (te(i.domReference) && k) {
        var E;
        const q = ot(i.floating).body;
        q.setAttribute(fs, "");
        const H = i.domReference, V = f == null || (E = f.nodesRef.current.find((J) => J.id === m)) == null || (E = E.context) == null ? void 0 : E.elements.floating;
        return V && (V.style.pointerEvents = ""), q.style.pointerEvents = "none", H.style.pointerEvents = "auto", k.style.pointerEvents = "auto", () => {
          q.style.pointerEvents = "", H.style.pointerEvents = "", k.style.pointerEvents = "";
        };
      }
    }
  }, [s, r, m, i, f, h, F]), Ne(() => {
    r || (w.current = void 0, j.current = !1, I(), D());
  }, [r, I, D]), L.useEffect(() => () => {
    I(), Ae(O), Ae(S), D();
  }, [s, i.domReference, I, D]);
  const R = L.useMemo(() => {
    function v(E) {
      w.current = E.pointerType;
    }
    return {
      onPointerDown: v,
      onPointerEnter: v,
      onMouseMove(E) {
        const {
          nativeEvent: k
        } = E;
        function q() {
          !A.current && !b.current && n(!0, k, "hover");
        }
        u && !lr(w.current) || r || d === 0 || j.current && E.movementX ** 2 + E.movementY ** 2 < 2 || (Ae(S), w.current === "touch" ? q() : (j.current = !0, S.current = window.setTimeout(q, d)));
      }
    };
  }, [u, n, r, b, d]), g = L.useMemo(() => ({
    onMouseEnter() {
      Ae(O);
    },
    onMouseLeave(v) {
      T() || M(v.nativeEvent, !1);
    }
  }), [M, T]);
  return L.useMemo(() => s ? {
    reference: R,
    floating: g
  } : {}, [s, R, g]);
}
function Br(e, t) {
  let r = e.filter((o) => {
    var a;
    return o.parentId === t && ((a = o.context) == null ? void 0 : a.open);
  }), n = r;
  for (; n.length; )
    n = e.filter((o) => {
      var a;
      return (a = n) == null ? void 0 : a.some((i) => {
        var s;
        return o.parentId === i.id && ((s = o.context) == null ? void 0 : s.open);
      });
    }), r = r.concat(n);
  return r;
}
const Su = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function Au(e, t) {
  const r = gu(e, Su());
  t === "prev" && r.reverse();
  const n = r.indexOf(Sa(ot(e)));
  return r.slice(n + 1)[0];
}
function sv() {
  return Au(document.body, "next");
}
function lv() {
  return Au(document.body, "prev");
}
function kn(e, t) {
  const r = t || e.currentTarget, n = e.relatedTarget;
  return !n || !Ke(r, n);
}
function cv(e) {
  gu(e, Su()).forEach((r) => {
    r.dataset.tabindex = r.getAttribute("tabindex") || "", r.setAttribute("tabindex", "-1");
  });
}
function ds(e) {
  e.querySelectorAll("[data-tabindex]").forEach((r) => {
    const n = r.dataset.tabindex;
    delete r.dataset.tabindex, n ? r.setAttribute("tabindex", n) : r.removeAttribute("tabindex");
  });
}
const ku = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, ps = /* @__PURE__ */ L.forwardRef(function(t, r) {
  const [n, o] = L.useState();
  Ne(() => {
    cu() && o("button");
  }, []);
  const a = {
    ref: r,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: n,
    "aria-hidden": n ? void 0 : !0,
    [wr("focus-guard")]: "",
    style: ku
  };
  return /* @__PURE__ */ je.jsx("span", {
    ...t,
    ...a
  });
}), Pu = /* @__PURE__ */ L.createContext(null), hs = /* @__PURE__ */ wr("portal");
function uv(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: r
  } = e, n = ln(), o = dv(), [a, i] = L.useState(null), s = L.useRef(null);
  return Ne(() => () => {
    a == null || a.remove(), queueMicrotask(() => {
      s.current = null;
    });
  }, [a]), Ne(() => {
    if (!n || s.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = n, c.setAttribute(hs, ""), l.appendChild(c), s.current = c, i(c);
  }, [t, n]), Ne(() => {
    if (r === null || !n || s.current) return;
    let l = r || (o == null ? void 0 : o.portalNode);
    l && !te(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const u = document.createElement("div");
    u.id = n, u.setAttribute(hs, ""), l = c || l, l.appendChild(u), s.current = u, i(u);
  }, [t, r, n, o]), a;
}
function fv(e) {
  const {
    children: t,
    id: r,
    root: n,
    preserveTabOrder: o = !0
  } = e, a = uv({
    id: r,
    root: n
  }), [i, s] = L.useState(null), l = L.useRef(null), c = L.useRef(null), u = L.useRef(null), d = L.useRef(null), p = i == null ? void 0 : i.modal, f = i == null ? void 0 : i.open, m = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!i && // Guards are only for non-modal focus management.
    !i.modal && // Don't render if unmount is transitioning.
    i.open && o && !!(n || a)
  );
  return L.useEffect(() => {
    if (!a || !o || p)
      return;
    function h(y) {
      a && kn(y) && (y.type === "focusin" ? ds : cv)(a);
    }
    return a.addEventListener("focusin", h, !0), a.addEventListener("focusout", h, !0), () => {
      a.removeEventListener("focusin", h, !0), a.removeEventListener("focusout", h, !0);
    };
  }, [a, o, p]), L.useEffect(() => {
    a && (f || ds(a));
  }, [f, a]), /* @__PURE__ */ je.jsxs(Pu.Provider, {
    value: L.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: u,
      afterInsideRef: d,
      portalNode: a,
      setFocusManagerState: s
    }), [o, a]),
    children: [m && a && /* @__PURE__ */ je.jsx(ps, {
      "data-type": "outside",
      ref: l,
      onFocus: (h) => {
        if (kn(h, a)) {
          var y;
          (y = u.current) == null || y.focus();
        } else {
          const b = lv() || (i == null ? void 0 : i.domReference);
          b == null || b.focus();
        }
      }
    }), m && a && /* @__PURE__ */ je.jsx("span", {
      "aria-owns": a.id,
      style: ku
    }), a && /* @__PURE__ */ Wa.createPortal(t, a), m && a && /* @__PURE__ */ je.jsx(ps, {
      "data-type": "outside",
      ref: c,
      onFocus: (h) => {
        if (kn(h, a)) {
          var y;
          (y = d.current) == null || y.focus();
        } else {
          const b = sv() || (i == null ? void 0 : i.domReference);
          b == null || b.focus(), i != null && i.closeOnFocusOut && (i == null || i.onOpenChange(!1, h.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const dv = () => L.useContext(Pu), pv = "data-floating-ui-focusable";
function vs(e) {
  return Ee(e.target) && e.target.tagName === "BUTTON";
}
function ms(e) {
  return uu(e);
}
function hv(e, t) {
  t === void 0 && (t = {});
  const {
    open: r,
    onOpenChange: n,
    dataRef: o,
    elements: {
      domReference: a
    }
  } = e, {
    enabled: i = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: u = !0,
    stickIfOpen: d = !0
  } = t, p = L.useRef(), f = L.useRef(!1), m = L.useMemo(() => ({
    onPointerDown(h) {
      p.current = h.pointerType;
    },
    onMouseDown(h) {
      const y = p.current;
      h.button === 0 && s !== "click" && (lr(y, !0) && c || (r && l && (!(o.current.openEvent && d) || o.current.openEvent.type === "mousedown") ? n(!1, h.nativeEvent, "click") : (h.preventDefault(), n(!0, h.nativeEvent, "click"))));
    },
    onClick(h) {
      const y = p.current;
      if (s === "mousedown" && p.current) {
        p.current = void 0;
        return;
      }
      lr(y, !0) && c || (r && l && (!(o.current.openEvent && d) || o.current.openEvent.type === "click") ? n(!1, h.nativeEvent, "click") : n(!0, h.nativeEvent, "click"));
    },
    onKeyDown(h) {
      p.current = void 0, !(h.defaultPrevented || !u || vs(h)) && (h.key === " " && !ms(a) && (h.preventDefault(), f.current = !0), h.key === "Enter" && n(!(r && l), h.nativeEvent, "click"));
    },
    onKeyUp(h) {
      h.defaultPrevented || !u || vs(h) || ms(a) || h.key === " " && f.current && (f.current = !1, n(!(r && l), h.nativeEvent, "click"));
    }
  }), [o, a, s, c, u, n, r, d, l]);
  return L.useMemo(() => i ? {
    reference: m
  } : {}, [i, m]);
}
const vv = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, mv = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, gs = (e) => {
  var t, r;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (r = e == null ? void 0 : e.outsidePress) != null ? r : !0
  };
};
function gv(e, t) {
  t === void 0 && (t = {});
  const {
    open: r,
    onOpenChange: n,
    elements: o,
    dataRef: a
  } = e, {
    enabled: i = !0,
    escapeKey: s = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: u = !1,
    referencePressEvent: d = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: f,
    capture: m
  } = t, h = ai(), y = Ye(typeof l == "function" ? l : () => !1), b = typeof l == "function" ? y : l, w = L.useRef(!1), O = L.useRef(!1), {
    escapeKey: _,
    outsidePress: S
  } = gs(f), {
    escapeKey: A,
    outsidePress: P
  } = gs(m), N = L.useRef(!1), j = Ye((R) => {
    var g;
    if (!r || !i || !s || R.key !== "Escape" || N.current)
      return;
    const v = (g = a.current.floatingContext) == null ? void 0 : g.nodeId, E = h ? Br(h.nodesRef.current, v) : [];
    if (!_ && (R.stopPropagation(), E.length > 0)) {
      let k = !0;
      if (E.forEach((q) => {
        var H;
        if ((H = q.context) != null && H.open && !q.context.dataRef.current.__escapeKeyBubbles) {
          k = !1;
          return;
        }
      }), !k)
        return;
    }
    n(!1, $p(R) ? R.nativeEvent : R, "escape-key");
  }), F = Ye((R) => {
    var g;
    const v = () => {
      var E;
      j(R), (E = ct(R)) == null || E.removeEventListener("keydown", v);
    };
    (g = ct(R)) == null || g.addEventListener("keydown", v);
  }), M = Ye((R) => {
    var g;
    const v = w.current;
    w.current = !1;
    const E = O.current;
    if (O.current = !1, c === "click" && E || v || typeof b == "function" && !b(R))
      return;
    const k = ct(R), q = "[" + wr("inert") + "]", H = ot(o.floating).querySelectorAll(q);
    let V = te(k) ? k : null;
    for (; V && !ze(V); ) {
      const re = Xe(V);
      if (ze(re) || !te(re))
        break;
      V = re;
    }
    if (H.length && te(k) && !Bp(k) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Ke(k, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(H).every((re) => !Ke(V, re)))
      return;
    if (Ee(k) && T) {
      const re = ze(k), ne = Oe(k), K = /auto|scroll/, ae = re || K.test(ne.overflowX), de = re || K.test(ne.overflowY), ve = ae && k.clientWidth > 0 && k.scrollWidth > k.clientWidth, Ce = de && k.clientHeight > 0 && k.scrollHeight > k.clientHeight, yt = ne.direction === "rtl", Wt = Ce && (yt ? R.offsetX <= k.offsetWidth - k.clientWidth : R.offsetX > k.clientWidth), Ze = ve && R.offsetY > k.clientHeight;
      if (Wt || Ze)
        return;
    }
    const J = (g = a.current.floatingContext) == null ? void 0 : g.nodeId, z = h && Br(h.nodesRef.current, J).some((re) => {
      var ne;
      return Tn(R, (ne = re.context) == null ? void 0 : ne.elements.floating);
    });
    if (Tn(R, o.floating) || Tn(R, o.domReference) || z)
      return;
    const Q = h ? Br(h.nodesRef.current, J) : [];
    if (Q.length > 0) {
      let re = !0;
      if (Q.forEach((ne) => {
        var K;
        if ((K = ne.context) != null && K.open && !ne.context.dataRef.current.__outsidePressBubbles) {
          re = !1;
          return;
        }
      }), !re)
        return;
    }
    n(!1, R, "outside-press");
  }), I = Ye((R) => {
    var g;
    const v = () => {
      var E;
      M(R), (E = ct(R)) == null || E.removeEventListener(c, v);
    };
    (g = ct(R)) == null || g.addEventListener(c, v);
  });
  L.useEffect(() => {
    if (!r || !i)
      return;
    a.current.__escapeKeyBubbles = _, a.current.__outsidePressBubbles = S;
    let R = -1;
    function g(H) {
      n(!1, H, "ancestor-scroll");
    }
    function v() {
      window.clearTimeout(R), N.current = !0;
    }
    function E() {
      R = window.setTimeout(
        () => {
          N.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        an() ? 5 : 0
      );
    }
    const k = ot(o.floating);
    s && (k.addEventListener("keydown", A ? F : j, A), k.addEventListener("compositionstart", v), k.addEventListener("compositionend", E)), b && k.addEventListener(c, P ? I : M, P);
    let q = [];
    return p && (te(o.domReference) && (q = at(o.domReference)), te(o.floating) && (q = q.concat(at(o.floating))), !te(o.reference) && o.reference && o.reference.contextElement && (q = q.concat(at(o.reference.contextElement)))), q = q.filter((H) => {
      var V;
      return H !== ((V = k.defaultView) == null ? void 0 : V.visualViewport);
    }), q.forEach((H) => {
      H.addEventListener("scroll", g, {
        passive: !0
      });
    }), () => {
      s && (k.removeEventListener("keydown", A ? F : j, A), k.removeEventListener("compositionstart", v), k.removeEventListener("compositionend", E)), b && k.removeEventListener(c, P ? I : M, P), q.forEach((H) => {
        H.removeEventListener("scroll", g);
      }), window.clearTimeout(R);
    };
  }, [a, o, s, b, c, r, n, p, i, _, S, j, A, F, M, P, I]), L.useEffect(() => {
    w.current = !1;
  }, [b, c]);
  const D = L.useMemo(() => ({
    onKeyDown: j,
    ...u && {
      [vv[d]]: (R) => {
        n(!1, R.nativeEvent, "reference-press");
      },
      ...d !== "click" && {
        onClick(R) {
          n(!1, R.nativeEvent, "reference-press");
        }
      }
    }
  }), [j, n, u, d]), T = L.useMemo(() => ({
    onKeyDown: j,
    onMouseDown() {
      O.current = !0;
    },
    onMouseUp() {
      O.current = !0;
    },
    [mv[c]]: () => {
      w.current = !0;
    }
  }), [j, c]);
  return L.useMemo(() => i ? {
    reference: D,
    floating: T
  } : {}, [i, D, T]);
}
function yv(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: n
  } = e, o = ln(), a = L.useRef({}), [i] = L.useState(() => nv()), s = oi() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = n.reference;
    f && !te(f) && tv("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = L.useState(n.reference), u = Ye((f, m, h) => {
    a.current.openEvent = f ? m : void 0, i.emit("openchange", {
      open: f,
      event: m,
      reason: h,
      nested: s
    }), r == null || r(f, m, h);
  }), d = L.useMemo(() => ({
    setPositionReference: c
  }), []), p = L.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return L.useMemo(() => ({
    dataRef: a,
    open: t,
    onOpenChange: u,
    elements: p,
    events: i,
    floatingId: o,
    refs: d
  }), [t, u, p, i, o, d]);
}
function bv(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, r = yv({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || r, o = n.elements, [a, i] = L.useState(null), [s, l] = L.useState(null), u = (o == null ? void 0 : o.domReference) || a, d = L.useRef(null), p = ai();
  Ne(() => {
    u && (d.current = u);
  }, [u]);
  const f = Wh({
    ...e,
    elements: {
      ...o,
      ...s && {
        reference: s
      }
    }
  }), m = L.useCallback((O) => {
    const _ = te(O) ? {
      getBoundingClientRect: () => O.getBoundingClientRect(),
      contextElement: O
    } : O;
    l(_), f.refs.setReference(_);
  }, [f.refs]), h = L.useCallback((O) => {
    (te(O) || O === null) && (d.current = O, i(O)), (te(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    O !== null && !te(O)) && f.refs.setReference(O);
  }, [f.refs]), y = L.useMemo(() => ({
    ...f.refs,
    setReference: h,
    setPositionReference: m,
    domReference: d
  }), [f.refs, h, m]), b = L.useMemo(() => ({
    ...f.elements,
    domReference: u
  }), [f.elements, u]), w = L.useMemo(() => ({
    ...f,
    ...n,
    refs: y,
    elements: b,
    nodeId: t
  }), [f, y, b, t, n]);
  return Ne(() => {
    n.dataRef.current.floatingContext = w;
    const O = p == null ? void 0 : p.nodesRef.current.find((_) => _.id === t);
    O && (O.context = w);
  }), L.useMemo(() => ({
    ...f,
    context: w,
    refs: y,
    elements: b
  }), [f, y, b, w]);
}
function wv(e, t) {
  t === void 0 && (t = {});
  const {
    open: r,
    onOpenChange: n,
    events: o,
    dataRef: a,
    elements: i
  } = e, {
    enabled: s = !0,
    visibleOnly: l = !0
  } = t, c = L.useRef(!1), u = L.useRef(-1), d = L.useRef(!0);
  L.useEffect(() => {
    if (!s) return;
    const f = _e(i.domReference);
    function m() {
      !r && Ee(i.domReference) && i.domReference === Sa(ot(i.domReference)) && (c.current = !0);
    }
    function h() {
      d.current = !0;
    }
    return f.addEventListener("blur", m), f.addEventListener("keydown", h, !0), () => {
      f.removeEventListener("blur", m), f.removeEventListener("keydown", h, !0);
    };
  }, [i.domReference, r, s]), L.useEffect(() => {
    if (!s) return;
    function f(m) {
      let {
        reason: h
      } = m;
      (h === "reference-press" || h === "escape-key") && (c.current = !0);
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, s]), L.useEffect(() => () => {
    Ae(u);
  }, []);
  const p = L.useMemo(() => ({
    onPointerDown(f) {
      qp(f.nativeEvent) || (d.current = !1);
    },
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(f) {
      if (c.current) return;
      const m = ct(f.nativeEvent);
      if (l && te(m))
        try {
          if (cu() && jp()) throw Error();
          if (!m.matches(":focus-visible")) return;
        } catch {
          if (!d.current && !uu(m))
            return;
        }
      n(!0, f.nativeEvent, "focus");
    },
    onBlur(f) {
      c.current = !1;
      const m = f.relatedTarget, h = f.nativeEvent, y = te(m) && m.hasAttribute(wr("focus-guard")) && m.getAttribute("data-type") === "outside";
      u.current = window.setTimeout(() => {
        var b;
        const w = Sa(i.domReference ? i.domReference.ownerDocument : document);
        !m && w === i.domReference || Ke((b = a.current.floatingContext) == null ? void 0 : b.refs.floating.current, w) || Ke(i.domReference, w) || y || n(!1, h, "focus");
      });
    }
  }), [a, i.domReference, n, l]);
  return L.useMemo(() => s ? {
    reference: p
  } : {}, [s, p]);
}
const ys = "active", bs = "selected";
function Pn(e, t, r) {
  const n = /* @__PURE__ */ new Map(), o = r === "item";
  let a = e;
  if (o && e) {
    const {
      [ys]: i,
      [bs]: s,
      ...l
    } = e;
    a = l;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1,
      [pv]: ""
    },
    ...a,
    ...t.map((i) => {
      const s = i ? i[r] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((i, s) => (s && Object.entries(s).forEach((l) => {
      let [c, u] = l;
      if (!(o && [ys, bs].includes(c)))
        if (c.indexOf("on") === 0) {
          if (n.has(c) || n.set(c, []), typeof u == "function") {
            var d;
            (d = n.get(c)) == null || d.push(u), i[c] = function() {
              for (var p, f = arguments.length, m = new Array(f), h = 0; h < f; h++)
                m[h] = arguments[h];
              return (p = n.get(c)) == null ? void 0 : p.map((y) => y(...m)).find((y) => y !== void 0);
            };
          }
        } else
          i[c] = u;
    }), i), {})
  };
}
function _v(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), r = e.map((s) => s == null ? void 0 : s.floating), n = e.map((s) => s == null ? void 0 : s.item), o = L.useCallback(
    (s) => Pn(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), a = L.useCallback(
    (s) => Pn(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), i = L.useCallback(
    (s) => Pn(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  );
  return L.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: a,
    getItemProps: i
  }), [o, a, i]);
}
const Ev = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Cv(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    open: n,
    floatingId: o
  } = e, {
    enabled: a = !0,
    role: i = "dialog"
  } = t, s = (r = Ev.get(i)) != null ? r : i, l = ln(), u = oi() != null, d = L.useMemo(() => s === "tooltip" || i === "label" ? {
    ["aria-" + (i === "label" ? "labelledby" : "describedby")]: n ? o : void 0
  } : {
    "aria-expanded": n ? "true" : "false",
    "aria-haspopup": s === "alertdialog" ? "dialog" : s,
    "aria-controls": n ? o : void 0,
    ...s === "listbox" && {
      role: "combobox"
    },
    ...s === "menu" && {
      id: l
    },
    ...s === "menu" && u && {
      role: "menuitem"
    },
    ...i === "select" && {
      "aria-autocomplete": "none"
    },
    ...i === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [s, o, u, n, l, i]), p = L.useMemo(() => {
    const m = {
      id: o,
      ...s && {
        role: s
      }
    };
    return s === "tooltip" || i === "label" ? m : {
      ...m,
      ...s === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [s, o, l, i]), f = L.useCallback((m) => {
    let {
      active: h,
      selected: y
    } = m;
    const b = {
      role: "option",
      ...h && {
        id: o + "-option"
      }
    };
    switch (i) {
      case "select":
        return {
          ...b,
          "aria-selected": h && y
        };
      case "combobox":
        return {
          ...b,
          ...h && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [o, i]);
  return L.useMemo(() => a ? {
    reference: d,
    floating: p,
    item: f
  } : {}, [a, d, p, f]);
}
function ws(e, t) {
  const [r, n] = e;
  let o = !1;
  const a = t.length;
  for (let i = 0, s = a - 1; i < a; s = i++) {
    const [l, c] = t[i] || [0, 0], [u, d] = t[s] || [0, 0];
    c >= n != d >= n && r <= (u - l) * (n - c) / (d - c) + l && (o = !o);
  }
  return o;
}
function xv(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function Tv(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: r = !1,
    requireIntent: n = !0
  } = e;
  let o, a = !1, i = null, s = null, l = performance.now();
  function c(d, p) {
    const f = performance.now(), m = f - l;
    if (i === null || s === null || m === 0)
      return i = d, s = p, l = f, null;
    const h = d - i, y = p - s, w = Math.sqrt(h * h + y * y) / m;
    return i = d, s = p, l = f, w;
  }
  const u = (d) => {
    let {
      x: p,
      y: f,
      placement: m,
      elements: h,
      onClose: y,
      nodeId: b,
      tree: w
    } = d;
    return function(_) {
      function S() {
        clearTimeout(o), y();
      }
      if (clearTimeout(o), !h.domReference || !h.floating || m == null || p == null || f == null)
        return;
      const {
        clientX: A,
        clientY: P
      } = _, N = [A, P], j = ct(_), F = _.type === "mouseleave", M = Ke(h.floating, j), I = Ke(h.domReference, j), D = h.domReference.getBoundingClientRect(), T = h.floating.getBoundingClientRect(), R = m.split("-")[0], g = p > T.right - T.width / 2, v = f > T.bottom - T.height / 2, E = xv(N, D), k = T.width > D.width, q = T.height > D.height, H = (k ? D : T).left, V = (k ? D : T).right, J = (q ? D : T).top, z = (q ? D : T).bottom;
      if (M && (a = !0, !F))
        return;
      if (I && (a = !1), I && !F) {
        a = !0;
        return;
      }
      if (F && te(_.relatedTarget) && Ke(h.floating, _.relatedTarget) || w && Br(w.nodesRef.current, b).some((ne) => {
        let {
          context: K
        } = ne;
        return K == null ? void 0 : K.open;
      }))
        return;
      if (R === "top" && f >= D.bottom - 1 || R === "bottom" && f <= D.top + 1 || R === "left" && p >= D.right - 1 || R === "right" && p <= D.left + 1)
        return S();
      let Q = [];
      switch (R) {
        case "top":
          Q = [[H, D.top + 1], [H, T.bottom - 1], [V, T.bottom - 1], [V, D.top + 1]];
          break;
        case "bottom":
          Q = [[H, T.top + 1], [H, D.bottom - 1], [V, D.bottom - 1], [V, T.top + 1]];
          break;
        case "left":
          Q = [[T.right - 1, z], [T.right - 1, J], [D.left + 1, J], [D.left + 1, z]];
          break;
        case "right":
          Q = [[D.right - 1, z], [D.right - 1, J], [T.left + 1, J], [T.left + 1, z]];
          break;
      }
      function re(ne) {
        let [K, ae] = ne;
        switch (R) {
          case "top": {
            const de = [k ? K + t / 2 : g ? K + t * 4 : K - t * 4, ae + t + 1], ve = [k ? K - t / 2 : g ? K + t * 4 : K - t * 4, ae + t + 1], Ce = [[T.left, g || k ? T.bottom - t : T.top], [T.right, g ? k ? T.bottom - t : T.top : T.bottom - t]];
            return [de, ve, ...Ce];
          }
          case "bottom": {
            const de = [k ? K + t / 2 : g ? K + t * 4 : K - t * 4, ae - t], ve = [k ? K - t / 2 : g ? K + t * 4 : K - t * 4, ae - t], Ce = [[T.left, g || k ? T.top + t : T.bottom], [T.right, g ? k ? T.top + t : T.bottom : T.top + t]];
            return [de, ve, ...Ce];
          }
          case "left": {
            const de = [K + t + 1, q ? ae + t / 2 : v ? ae + t * 4 : ae - t * 4], ve = [K + t + 1, q ? ae - t / 2 : v ? ae + t * 4 : ae - t * 4];
            return [...[[v || q ? T.right - t : T.left, T.top], [v ? q ? T.right - t : T.left : T.right - t, T.bottom]], de, ve];
          }
          case "right": {
            const de = [K - t, q ? ae + t / 2 : v ? ae + t * 4 : ae - t * 4], ve = [K - t, q ? ae - t / 2 : v ? ae + t * 4 : ae - t * 4], Ce = [[v || q ? T.left + t : T.right, T.top], [v ? q ? T.left + t : T.right : T.left + t, T.bottom]];
            return [de, ve, ...Ce];
          }
        }
      }
      if (!ws([A, P], Q)) {
        if (a && !E)
          return S();
        if (!F && n) {
          const ne = c(_.clientX, _.clientY);
          if (ne !== null && ne < 0.1)
            return S();
        }
        ws([A, P], re([p, f])) ? !a && n && (o = window.setTimeout(S, 40)) : S();
      }
    };
  };
  return u.__options = {
    blockPointerEvents: r
  }, u;
}
const Ov = ({
  initialOpen: e = !1,
  placement: t = "bottom-end",
  open: r,
  onOpenChange: n,
  enabled: o = !0,
  delay: a
}) => {
  const i = ue(null), [s, l] = xe(e), c = r ?? s, u = n ?? l, d = bv({
    placement: t,
    open: c,
    onOpenChange: u,
    whileElementsMounted: jh,
    middleware: [
      Kh({
        element: i
      }),
      Vh(6),
      zh({
        fallbackAxisSideDirection: "start"
      }),
      Yh({ padding: 5 })
    ]
  }), { context: p } = d, f = iv(p, {
    move: !1,
    enabled: r === void 0 && o,
    delay: {
      open: (a == null ? void 0 : a.open) ?? 600,
      close: (a == null ? void 0 : a.close) ?? 0
    },
    // keeping the tooltip open when hovering on the content
    handleClose: Tv()
  }), m = hv(p), h = wv(p, {
    enabled: r === void 0
  }), y = gv(p), b = Cv(p, { role: "tooltip" }), w = _v([f, m, h, y, b]);
  return kt(
    () => ({
      open: c,
      setOpen: u,
      arrowRef: i,
      ...w,
      ...d
    }),
    [c, u, w, d, i]
  );
}, Mu = Ba(null), Du = () => {
  const e = ut(Mu);
  if (e === null)
    throw new Error("Popover components must be wrapped in <Popover />");
  return e;
}, Rv = ({ children: e, ...t }) => {
  const r = Ov({ ...t });
  return /* @__PURE__ */ x.createElement(Mu.Provider, { value: r }, e);
}, Sv = x.forwardRef(function({ children: t, asChild: r = !1, ...n }, o) {
  const a = Du(), i = t.ref, s = Ou([a.refs.setReference, o, i]);
  return r && x.isValidElement(t) ? x.cloneElement(
    t,
    a.getReferenceProps({
      ref: s,
      ...n,
      ...t.props,
      "data-state": a.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ x.createElement(
    "div",
    {
      ref: s,
      "data-state": a.open ? "open" : "closed",
      ...a.getReferenceProps(n)
    },
    t
  );
}), _s = {
  WHITE: "#ffffff"
}, Av = x.forwardRef(
  function({ children: t, isHidePopover: r, style: n, ...o }, a) {
    const i = Du(), s = Ou([i.refs.setFloating, a]);
    return i.open ? /* @__PURE__ */ x.createElement(fv, null, /* @__PURE__ */ x.createElement(
      "div",
      {
        ref: s,
        style: {
          position: i.strategy,
          background: _s.WHITE,
          top: i.y ?? 0,
          left: i.x ?? 0,
          visibility: i.x === null || r ? "hidden" : "visible",
          boxShadow: "2px 2px 6px 4px #0000002f",
          borderRadius: "8px",
          zIndex: 99999,
          ...n
        },
        ...i.getFloatingProps(o)
      },
      t,
      /* @__PURE__ */ x.createElement(
        rv,
        {
          ref: i.arrowRef,
          context: i.context,
          fill: _s.WHITE,
          staticOffset: i.placement === "bottom-end" || i.placement === "top-end" ? "15%" : null
        }
      )
    )) : null;
  }
), kv = "_checkboxMenu_d20zh_1", Pv = "_button_d20zh_5", Mv = "_arrowIcon_d20zh_29", Dv = "_popup_d20zh_34", Lv = "_option_d20zh_37", Tt = {
  checkboxMenu: kv,
  button: Pv,
  arrowIcon: Mv,
  popup: Dv,
  option: Lv
};
function Ob({
  id: e,
  selectedValue: t,
  options: r,
  onChange: n,
  placement: o = "bottom-end",
  optionWidth: a,
  triggerElement: i,
  ariaLabel: s
}) {
  var d, p;
  const [l, c] = xe(!1), u = ((d = r.find(({ value: f }) => f === t)) == null ? void 0 : d.label) || ((p = r[0]) == null ? void 0 : p.label) || "No options found";
  return /* @__PURE__ */ x.createElement(
    Rv,
    {
      enabled: !0,
      placement: o,
      open: l,
      onOpenChange: (f) => {
        c(f);
      }
    },
    /* @__PURE__ */ x.createElement("div", { className: Tt.checkboxMenu }, /* @__PURE__ */ x.createElement(Sv, null, i || /* @__PURE__ */ x.createElement(
      "button",
      {
        type: "button",
        id: e,
        className: Tt.button,
        disabled: !r.length,
        "aria-label": s || "Open menu"
      },
      u,
      /* @__PURE__ */ x.createElement(Lp, { className: Tt.arrowIcon, color: "#000" })
    )), /* @__PURE__ */ x.createElement(Av, null, /* @__PURE__ */ x.createElement("div", { className: Tt.checkboxMenu }, /* @__PURE__ */ x.createElement("nav", { className: Tt.popup }, r.map((f) => /* @__PURE__ */ x.createElement(
      "button",
      {
        type: "button",
        key: f.label,
        className: Tt.option,
        style: {
          ...!!a && { width: a }
        },
        onClick: () => {
          n(f), c(!1);
        },
        "aria-pressed": f.value === t
      },
      /* @__PURE__ */ x.createElement("span", null, f.label),
      /* @__PURE__ */ x.createElement(
        Za,
        {
          checked: f.value === t,
          isBorderVisible: !1,
          isStatic: !0
        }
      )
    ))))))
  );
}
const Iv = "_checkboxButtonGroup_jb8kc_1", Nv = "_buttonList_jb8kc_1", qv = "_checkboxButton_jb8kc_1", Mn = {
  checkboxButtonGroup: Iv,
  buttonList: Nv,
  checkboxButton: qv
}, Rb = ({
  className: e,
  groupName: t,
  items: r,
  selectedIds: n,
  onChange: o
}) => {
  const a = (i) => {
    const s = new Set(n);
    s.has(i) ? s.delete(i) : s.add(i), o(s);
  };
  return /* @__PURE__ */ x.createElement("div", { className: fe(Mn.checkboxButtonGroup, e) }, /* @__PURE__ */ x.createElement("ul", { className: Mn.buttonList }, r.map(({ id: i, name: s }) => {
    const l = n.has(i);
    return /* @__PURE__ */ x.createElement("li", { key: i }, /* @__PURE__ */ x.createElement(
      "button",
      {
        className: Mn.checkboxButton,
        type: "button",
        onClick: () => a(i)
      },
      /* @__PURE__ */ x.createElement(Za, { isStatic: !0, id: `${t}-${i}`, name: t, checked: l }),
      s
    ));
  })));
};
function jv({ src: e, fallback: t, alt: r, className: n, ...o }) {
  const [a, i] = xe(!1), s = () => {
    i(!0);
  };
  return he(() => {
    e && i(!1);
  }, [e, i]), !a && e ? /* @__PURE__ */ x.createElement(
    "img",
    {
      src: e,
      onError: s,
      alt: r,
      className: n,
      ...o
    }
  ) : t;
}
jv.propTypes = {
  src: W.string,
  fallback: W.node.isRequired,
  alt: W.string.isRequired,
  className: W.string
};
const Jr = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, Ot = (e, t, r) => Math.min(Math.max(e, t), r), Fv = (...e) => e.filter((t) => t && typeof t == "string").join(" "), Es = (e, t) => e === t || e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.unit === t.unit;
function $v(e, t, r, n) {
  const o = Ie(e, r, n);
  return e.width && (o.height = o.width / t), e.height && (o.width = o.height * t), o.y + o.height > n && (o.height = n - o.y, o.width = o.height * t), o.x + o.width > r && (o.width = r - o.x, o.height = o.width / t), e.unit === "%" ? nt(o, r, n) : o;
}
function Bv(e, t, r) {
  const n = Ie(e, t, r);
  return n.x = (t - n.width) / 2, n.y = (r - n.height) / 2, e.unit === "%" ? nt(n, t, r) : n;
}
function nt(e, t, r) {
  return e.unit === "%" ? { ...Jr, ...e, unit: "%" } : {
    unit: "%",
    x: e.x ? e.x / t * 100 : 0,
    y: e.y ? e.y / r * 100 : 0,
    width: e.width ? e.width / t * 100 : 0,
    height: e.height ? e.height / r * 100 : 0
  };
}
function Ie(e, t, r) {
  return e.unit ? e.unit === "px" ? { ...Jr, ...e, unit: "px" } : {
    unit: "px",
    x: e.x ? e.x * t / 100 : 0,
    y: e.y ? e.y * r / 100 : 0,
    width: e.width ? e.width * t / 100 : 0,
    height: e.height ? e.height * r / 100 : 0
  } : { ...Jr, ...e, unit: "px" };
}
function Cs(e, t, r, n, o, a = 0, i = 0, s = n, l = o) {
  const c = { ...e };
  let u = Math.min(a, n), d = Math.min(i, o), p = Math.min(s, n), f = Math.min(l, o);
  t && (t > 1 ? (u = i ? i * t : u, d = u / t, p = s * t) : (d = a ? a / t : d, u = d * t, f = l / t)), c.y < 0 && (c.height = Math.max(c.height + c.y, d), c.y = 0), c.x < 0 && (c.width = Math.max(c.width + c.x, u), c.x = 0);
  const m = n - (c.x + c.width);
  m < 0 && (c.x = Math.min(c.x, n - u), c.width += m);
  const h = o - (c.y + c.height);
  if (h < 0 && (c.y = Math.min(c.y, o - d), c.height += h), c.width < u && ((r === "sw" || r == "nw") && (c.x -= u - c.width), c.width = u), c.height < d && ((r === "nw" || r == "ne") && (c.y -= d - c.height), c.height = d), c.width > p && ((r === "sw" || r == "nw") && (c.x -= p - c.width), c.width = p), c.height > f && ((r === "nw" || r == "ne") && (c.y -= f - c.height), c.height = f), t) {
    const y = c.width / c.height;
    if (y < t) {
      const b = Math.max(c.width / t, d);
      (r === "nw" || r == "ne") && (c.y -= b - c.height), c.height = b;
    } else if (y > t) {
      const b = Math.max(c.height * t, u);
      (r === "sw" || r == "nw") && (c.x -= b - c.width), c.width = b;
    }
  }
  return c;
}
function Hv(e, t, r, n) {
  const o = { ...e };
  return t === "ArrowLeft" ? n === "nw" ? (o.x -= r, o.y -= r, o.width += r, o.height += r) : n === "w" ? (o.x -= r, o.width += r) : n === "sw" ? (o.x -= r, o.width += r, o.height += r) : n === "ne" ? (o.y += r, o.width -= r, o.height -= r) : n === "e" ? o.width -= r : n === "se" && (o.width -= r, o.height -= r) : t === "ArrowRight" && (n === "nw" ? (o.x += r, o.y += r, o.width -= r, o.height -= r) : n === "w" ? (o.x += r, o.width -= r) : n === "sw" ? (o.x += r, o.width -= r, o.height -= r) : n === "ne" ? (o.y -= r, o.width += r, o.height += r) : n === "e" ? o.width += r : n === "se" && (o.width += r, o.height += r)), t === "ArrowUp" ? n === "nw" ? (o.x -= r, o.y -= r, o.width += r, o.height += r) : n === "n" ? (o.y -= r, o.height += r) : n === "ne" ? (o.y -= r, o.width += r, o.height += r) : n === "sw" ? (o.x += r, o.width -= r, o.height -= r) : n === "s" ? o.height -= r : n === "se" && (o.width -= r, o.height -= r) : t === "ArrowDown" && (n === "nw" ? (o.x += r, o.y += r, o.width -= r, o.height -= r) : n === "n" ? (o.y += r, o.height -= r) : n === "ne" ? (o.y += r, o.width -= r, o.height -= r) : n === "sw" ? (o.x -= r, o.width += r, o.height += r) : n === "s" ? o.height += r : n === "se" && (o.width += r, o.height += r)), o;
}
const Rt = { capture: !0, passive: !1 };
let Wv = 0;
const rt = class Le extends kf {
  constructor() {
    super(...arguments), this.docMoveBound = !1, this.mouseDownOnCrop = !1, this.dragStarted = !1, this.evData = {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }, this.componentRef = Ei(), this.mediaRef = Ei(), this.initChangeCalled = !1, this.instanceId = `rc-${Wv++}`, this.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, this.onCropPointerDown = (t) => {
      const { crop: r, disabled: n } = this.props, o = this.getBox();
      if (!r)
        return;
      const a = Ie(r, o.width, o.height);
      if (n)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const i = t.target.dataset.ord, s = !!i;
      let l = t.clientX, c = t.clientY, u = a.x, d = a.y;
      if (i) {
        const p = t.clientX - o.x, f = t.clientY - o.y;
        let m = 0, h = 0;
        i === "ne" || i == "e" ? (m = p - (a.x + a.width), h = f - a.y, u = a.x, d = a.y + a.height) : i === "se" || i === "s" ? (m = p - (a.x + a.width), h = f - (a.y + a.height), u = a.x, d = a.y) : i === "sw" || i == "w" ? (m = p - a.x, h = f - (a.y + a.height), u = a.x + a.width, d = a.y) : (i === "nw" || i == "n") && (m = p - a.x, h = f - a.y, u = a.x + a.width, d = a.y + a.height), l = u + o.x + m, c = d + o.y + h;
      }
      this.evData = {
        startClientX: l,
        startClientY: c,
        startCropX: u,
        startCropY: d,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: s,
        ord: i
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }, this.onComponentPointerDown = (t) => {
      const { crop: r, disabled: n, locked: o, keepSelection: a, onChange: i } = this.props, s = this.getBox();
      if (n || o || a && r)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const l = t.clientX - s.x, c = t.clientY - s.y, u = {
        unit: "px",
        x: l,
        y: c,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: t.clientX,
        startClientY: t.clientY,
        startCropX: l,
        startCropY: c,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, i(Ie(u, s.width, s.height), nt(u, s.width, s.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }, this.onDocPointerMove = (t) => {
      const { crop: r, disabled: n, onChange: o, onDragStart: a } = this.props, i = this.getBox();
      if (n || !r || !this.mouseDownOnCrop)
        return;
      t.cancelable && t.preventDefault(), this.dragStarted || (this.dragStarted = !0, a && a(t));
      const { evData: s } = this;
      s.clientX = t.clientX, s.clientY = t.clientY;
      let l;
      s.isResize ? l = this.resizeCrop() : l = this.dragCrop(), Es(r, l) || o(
        Ie(l, i.width, i.height),
        nt(l, i.width, i.height)
      );
    }, this.onComponentKeyDown = (t) => {
      const { crop: r, disabled: n, onChange: o, onComplete: a } = this.props;
      if (n)
        return;
      const i = t.key;
      let s = !1;
      if (!r)
        return;
      const l = this.getBox(), c = this.makePixelCrop(l), u = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? Le.nudgeStepLarge : t.shiftKey ? Le.nudgeStepMedium : Le.nudgeStep;
      if (i === "ArrowLeft" ? (c.x -= u, s = !0) : i === "ArrowRight" ? (c.x += u, s = !0) : i === "ArrowUp" ? (c.y -= u, s = !0) : i === "ArrowDown" && (c.y += u, s = !0), s) {
        t.cancelable && t.preventDefault(), c.x = Ot(c.x, 0, l.width - c.width), c.y = Ot(c.y, 0, l.height - c.height);
        const d = Ie(c, l.width, l.height), p = nt(c, l.width, l.height);
        o(d, p), a && a(d, p);
      }
    }, this.onHandlerKeyDown = (t, r) => {
      const {
        aspect: n = 0,
        crop: o,
        disabled: a,
        minWidth: i = 0,
        minHeight: s = 0,
        maxWidth: l,
        maxHeight: c,
        onChange: u,
        onComplete: d
      } = this.props, p = this.getBox();
      if (a || !o)
        return;
      if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight")
        t.stopPropagation(), t.preventDefault();
      else
        return;
      const f = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? Le.nudgeStepLarge : t.shiftKey ? Le.nudgeStepMedium : Le.nudgeStep, m = Ie(o, p.width, p.height), h = Hv(m, t.key, f, r), y = Cs(
        h,
        n,
        r,
        p.width,
        p.height,
        i,
        s,
        l,
        c
      );
      if (!Es(o, y)) {
        const b = nt(y, p.width, p.height);
        u(y, b), d && d(y, b);
      }
    }, this.onDocPointerDone = (t) => {
      const { crop: r, disabled: n, onComplete: o, onDragEnd: a } = this.props, i = this.getBox();
      this.unbindDocMove(), !(n || !r) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, a && a(t), o && o(Ie(r, i.width, i.height), nt(r, i.width, i.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }, this.onDragFocus = () => {
      var t;
      (t = this.componentRef.current) == null || t.scrollTo(0, 0);
    };
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const t = this.mediaRef.current;
    if (!t)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: r, y: n, width: o, height: a } = t.getBoundingClientRect();
    return { x: r, y: n, width: o, height: a };
  }
  componentDidUpdate(t) {
    const { crop: r, onComplete: n } = this.props;
    if (n && !t.crop && r) {
      const { width: o, height: a } = this.getBox();
      o && a && n(Ie(r, o, a), nt(r, o, a));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, Rt), this.document.addEventListener("pointerup", this.onDocPointerDone, Rt), this.document.addEventListener("pointercancel", this.onDocPointerDone, Rt), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, Rt), this.document.removeEventListener("pointerup", this.onDocPointerDone, Rt), this.document.removeEventListener("pointercancel", this.onDocPointerDone, Rt), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: t } = this.props;
    if (t)
      return {
        top: `${t.y}${t.unit}`,
        left: `${t.x}${t.unit}`,
        width: `${t.width}${t.unit}`,
        height: `${t.height}${t.unit}`
      };
  }
  dragCrop() {
    const { evData: t } = this, r = this.getBox(), n = this.makePixelCrop(r), o = t.clientX - t.startClientX, a = t.clientY - t.startClientY;
    return n.x = Ot(t.startCropX + o, 0, r.width - n.width), n.y = Ot(t.startCropY + a, 0, r.height - n.height), n;
  }
  getPointRegion(t, r, n, o) {
    const { evData: a } = this, i = a.clientX - t.x, s = a.clientY - t.y;
    let l;
    o && r ? l = r === "nw" || r === "n" || r === "ne" : l = s < a.startCropY;
    let c;
    return n && r ? c = r === "nw" || r === "w" || r === "sw" : c = i < a.startCropX, c ? l ? "nw" : "sw" : l ? "ne" : "se";
  }
  resolveMinDimensions(t, r, n = 0, o = 0) {
    const a = Math.min(n, t.width), i = Math.min(o, t.height);
    return !r || !a && !i ? [a, i] : r > 1 ? a ? [a, a / r] : [i * r, i] : i ? [i * r, i] : [a, a / r];
  }
  resizeCrop() {
    const { evData: t } = this, { aspect: r = 0, maxWidth: n, maxHeight: o } = this.props, a = this.getBox(), [i, s] = this.resolveMinDimensions(a, r, this.props.minWidth, this.props.minHeight);
    let l = this.makePixelCrop(a);
    const c = this.getPointRegion(a, t.ord, i, s), u = t.ord || c;
    let d = t.clientX - t.startClientX, p = t.clientY - t.startClientY;
    (i && u === "nw" || u === "w" || u === "sw") && (d = Math.min(d, -i)), (s && u === "nw" || u === "n" || u === "ne") && (p = Math.min(p, -s));
    const f = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    c === "ne" ? (f.x = t.startCropX, f.width = d, r ? (f.height = f.width / r, f.y = t.startCropY - f.height) : (f.height = Math.abs(p), f.y = t.startCropY - f.height)) : c === "se" ? (f.x = t.startCropX, f.y = t.startCropY, f.width = d, r ? f.height = f.width / r : f.height = p) : c === "sw" ? (f.x = t.startCropX + d, f.y = t.startCropY, f.width = Math.abs(d), r ? f.height = f.width / r : f.height = p) : c === "nw" && (f.x = t.startCropX + d, f.width = Math.abs(d), r ? (f.height = f.width / r, f.y = t.startCropY - f.height) : (f.height = Math.abs(p), f.y = t.startCropY + p));
    const m = Cs(
      f,
      r,
      c,
      a.width,
      a.height,
      i,
      s,
      n,
      o
    );
    return r || Le.xyOrds.indexOf(u) > -1 ? l = m : Le.xOrds.indexOf(u) > -1 ? (l.x = m.x, l.width = m.width) : Le.yOrds.indexOf(u) > -1 && (l.y = m.y, l.height = m.height), l.x = Ot(l.x, 0, a.width - l.width), l.y = Ot(l.y, 0, a.height - l.height), l;
  }
  renderCropSelection() {
    const {
      ariaLabels: t = Le.defaultProps.ariaLabels,
      disabled: r,
      locked: n,
      renderSelectionAddon: o,
      ruleOfThirds: a,
      crop: i
    } = this.props, s = this.getCropStyle();
    if (i)
      return /* @__PURE__ */ x.createElement(
        "div",
        {
          style: s,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !r && !n && /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": t.nwDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": t.nDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": t.neDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": t.eDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": t.seDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": t.sDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": t.swDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ x.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": t.wDragHandle,
            onKeyDown: (l) => this.onHandlerKeyDown(l, "w"),
            role: "button"
          }
        )),
        o && /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (l) => l.stopPropagation() }, o(this.state)),
        a && /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ x.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(t) {
    const r = { ...Jr, ...this.props.crop || {} };
    return Ie(r, t.width, t.height);
  }
  render() {
    const { aspect: t, children: r, circularCrop: n, className: o, crop: a, disabled: i, locked: s, style: l, ruleOfThirds: c } = this.props, { cropIsActive: u, newCropIsBeingDrawn: d } = this.state, p = a ? this.renderCropSelection() : null, f = Fv(
      "ReactCrop",
      o,
      u && "ReactCrop--active",
      i && "ReactCrop--disabled",
      s && "ReactCrop--locked",
      d && "ReactCrop--new-crop",
      a && t && "ReactCrop--fixed-aspect",
      a && n && "ReactCrop--circular-crop",
      a && c && "ReactCrop--rule-of-thirds",
      !this.dragStarted && a && !a.width && !a.height && "ReactCrop--invisible-crop",
      n && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ x.createElement("div", { ref: this.componentRef, className: f, style: l }, /* @__PURE__ */ x.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, r), a ? /* @__PURE__ */ x.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "white" }), n ? /* @__PURE__ */ x.createElement(
      "ellipse",
      {
        cx: `${a.x + a.width / 2}${a.unit}`,
        cy: `${a.y + a.height / 2}${a.unit}`,
        rx: `${a.width / 2}${a.unit}`,
        ry: `${a.height / 2}${a.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ x.createElement(
      "rect",
      {
        x: `${a.x}${a.unit}`,
        y: `${a.y}${a.unit}`,
        width: `${a.width}${a.unit}`,
        height: `${a.height}${a.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ x.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, p);
  }
};
rt.xOrds = ["e", "w"], rt.yOrds = ["n", "s"], rt.xyOrds = ["nw", "ne", "se", "sw"], rt.nudgeStep = 1, rt.nudgeStepMedium = 10, rt.nudgeStepLarge = 100, rt.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
let Uv = rt;
var Dn, xs;
function Vv() {
  if (xs) return Dn;
  xs = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Dn = e, Dn;
}
var Ln, Ts;
function Lu() {
  if (Ts) return Ln;
  Ts = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Ln = e, Ln;
}
var In, Os;
function cn() {
  if (Os) return In;
  Os = 1;
  var e = Lu();
  function t(r, n) {
    for (var o = r.length; o--; )
      if (e(r[o][0], n))
        return o;
    return -1;
  }
  return In = t, In;
}
var Nn, Rs;
function Yv() {
  if (Rs) return Nn;
  Rs = 1;
  var e = cn(), t = Array.prototype, r = t.splice;
  function n(o) {
    var a = this.__data__, i = e(a, o);
    if (i < 0)
      return !1;
    var s = a.length - 1;
    return i == s ? a.pop() : r.call(a, i, 1), --this.size, !0;
  }
  return Nn = n, Nn;
}
var qn, Ss;
function zv() {
  if (Ss) return qn;
  Ss = 1;
  var e = cn();
  function t(r) {
    var n = this.__data__, o = e(n, r);
    return o < 0 ? void 0 : n[o][1];
  }
  return qn = t, qn;
}
var jn, As;
function Kv() {
  if (As) return jn;
  As = 1;
  var e = cn();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return jn = t, jn;
}
var Fn, ks;
function Gv() {
  if (ks) return Fn;
  ks = 1;
  var e = cn();
  function t(r, n) {
    var o = this.__data__, a = e(o, r);
    return a < 0 ? (++this.size, o.push([r, n])) : o[a][1] = n, this;
  }
  return Fn = t, Fn;
}
var $n, Ps;
function un() {
  if (Ps) return $n;
  Ps = 1;
  var e = Vv(), t = Yv(), r = zv(), n = Kv(), o = Gv();
  function a(i) {
    var s = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++s < l; ) {
      var c = i[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, $n = a, $n;
}
var Bn, Ms;
function Xv() {
  if (Ms) return Bn;
  Ms = 1;
  var e = un();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Bn = t, Bn;
}
var Hn, Ds;
function Jv() {
  if (Ds) return Hn;
  Ds = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Hn = e, Hn;
}
var Wn, Ls;
function Zv() {
  if (Ls) return Wn;
  Ls = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Wn = e, Wn;
}
var Un, Is;
function Qv() {
  if (Is) return Un;
  Is = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Un = e, Un;
}
var Vn, Ns;
function Iu() {
  if (Ns) return Vn;
  Ns = 1;
  var e = typeof Ar == "object" && Ar && Ar.Object === Object && Ar;
  return Vn = e, Vn;
}
var Yn, qs;
function We() {
  if (qs) return Yn;
  qs = 1;
  var e = Iu(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Yn = r, Yn;
}
var zn, js;
function ii() {
  if (js) return zn;
  js = 1;
  var e = We(), t = e.Symbol;
  return zn = t, zn;
}
var Kn, Fs;
function em() {
  if (Fs) return Kn;
  Fs = 1;
  var e = ii(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, o = e ? e.toStringTag : void 0;
  function a(i) {
    var s = r.call(i, o), l = i[o];
    try {
      i[o] = void 0;
      var c = !0;
    } catch {
    }
    var u = n.call(i);
    return c && (s ? i[o] = l : delete i[o]), u;
  }
  return Kn = a, Kn;
}
var Gn, $s;
function tm() {
  if ($s) return Gn;
  $s = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Gn = r, Gn;
}
var Xn, Bs;
function _r() {
  if (Bs) return Xn;
  Bs = 1;
  var e = ii(), t = em(), r = tm(), n = "[object Null]", o = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function i(s) {
    return s == null ? s === void 0 ? o : n : a && a in Object(s) ? t(s) : r(s);
  }
  return Xn = i, Xn;
}
var Jn, Hs;
function Er() {
  if (Hs) return Jn;
  Hs = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Jn = e, Jn;
}
var Zn, Ws;
function Nu() {
  if (Ws) return Zn;
  Ws = 1;
  var e = _r(), t = Er(), r = "[object AsyncFunction]", n = "[object Function]", o = "[object GeneratorFunction]", a = "[object Proxy]";
  function i(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == n || l == o || l == r || l == a;
  }
  return Zn = i, Zn;
}
var Qn, Us;
function rm() {
  if (Us) return Qn;
  Us = 1;
  var e = We(), t = e["__core-js_shared__"];
  return Qn = t, Qn;
}
var eo, Vs;
function nm() {
  if (Vs) return eo;
  Vs = 1;
  var e = rm(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return eo = r, eo;
}
var to, Ys;
function qu() {
  if (Ys) return to;
  Ys = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return to = r, to;
}
var ro, zs;
function om() {
  if (zs) return ro;
  zs = 1;
  var e = Nu(), t = nm(), r = Er(), n = qu(), o = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, i = Function.prototype, s = Object.prototype, l = i.toString, c = s.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(p) {
    if (!r(p) || t(p))
      return !1;
    var f = e(p) ? u : a;
    return f.test(n(p));
  }
  return ro = d, ro;
}
var no, Ks;
function am() {
  if (Ks) return no;
  Ks = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return no = e, no;
}
var oo, Gs;
function Bt() {
  if (Gs) return oo;
  Gs = 1;
  var e = om(), t = am();
  function r(n, o) {
    var a = t(n, o);
    return e(a) ? a : void 0;
  }
  return oo = r, oo;
}
var ao, Xs;
function si() {
  if (Xs) return ao;
  Xs = 1;
  var e = Bt(), t = We(), r = e(t, "Map");
  return ao = r, ao;
}
var io, Js;
function fn() {
  if (Js) return io;
  Js = 1;
  var e = Bt(), t = e(Object, "create");
  return io = t, io;
}
var so, Zs;
function im() {
  if (Zs) return so;
  Zs = 1;
  var e = fn();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return so = t, so;
}
var lo, Qs;
function sm() {
  if (Qs) return lo;
  Qs = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return lo = e, lo;
}
var co, el;
function lm() {
  if (el) return co;
  el = 1;
  var e = fn(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function o(a) {
    var i = this.__data__;
    if (e) {
      var s = i[a];
      return s === t ? void 0 : s;
    }
    return n.call(i, a) ? i[a] : void 0;
  }
  return co = o, co;
}
var uo, tl;
function cm() {
  if (tl) return uo;
  tl = 1;
  var e = fn(), t = Object.prototype, r = t.hasOwnProperty;
  function n(o) {
    var a = this.__data__;
    return e ? a[o] !== void 0 : r.call(a, o);
  }
  return uo = n, uo;
}
var fo, rl;
function um() {
  if (rl) return fo;
  rl = 1;
  var e = fn(), t = "__lodash_hash_undefined__";
  function r(n, o) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && o === void 0 ? t : o, this;
  }
  return fo = r, fo;
}
var po, nl;
function fm() {
  if (nl) return po;
  nl = 1;
  var e = im(), t = sm(), r = lm(), n = cm(), o = um();
  function a(i) {
    var s = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++s < l; ) {
      var c = i[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, po = a, po;
}
var ho, ol;
function dm() {
  if (ol) return ho;
  ol = 1;
  var e = fm(), t = un(), r = si();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return ho = n, ho;
}
var vo, al;
function pm() {
  if (al) return vo;
  al = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return vo = e, vo;
}
var mo, il;
function dn() {
  if (il) return mo;
  il = 1;
  var e = pm();
  function t(r, n) {
    var o = r.__data__;
    return e(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
  }
  return mo = t, mo;
}
var go, sl;
function hm() {
  if (sl) return go;
  sl = 1;
  var e = dn();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return go = t, go;
}
var yo, ll;
function vm() {
  if (ll) return yo;
  ll = 1;
  var e = dn();
  function t(r) {
    return e(this, r).get(r);
  }
  return yo = t, yo;
}
var bo, cl;
function mm() {
  if (cl) return bo;
  cl = 1;
  var e = dn();
  function t(r) {
    return e(this, r).has(r);
  }
  return bo = t, bo;
}
var wo, ul;
function gm() {
  if (ul) return wo;
  ul = 1;
  var e = dn();
  function t(r, n) {
    var o = e(this, r), a = o.size;
    return o.set(r, n), this.size += o.size == a ? 0 : 1, this;
  }
  return wo = t, wo;
}
var _o, fl;
function ju() {
  if (fl) return _o;
  fl = 1;
  var e = dm(), t = hm(), r = vm(), n = mm(), o = gm();
  function a(i) {
    var s = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++s < l; ) {
      var c = i[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, _o = a, _o;
}
var Eo, dl;
function ym() {
  if (dl) return Eo;
  dl = 1;
  var e = un(), t = si(), r = ju(), n = 200;
  function o(a, i) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < n - 1)
        return l.push([a, i]), this.size = ++s.size, this;
      s = this.__data__ = new r(l);
    }
    return s.set(a, i), this.size = s.size, this;
  }
  return Eo = o, Eo;
}
var Co, pl;
function bm() {
  if (pl) return Co;
  pl = 1;
  var e = un(), t = Xv(), r = Jv(), n = Zv(), o = Qv(), a = ym();
  function i(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = o, i.prototype.set = a, Co = i, Co;
}
var xo, hl;
function wm() {
  if (hl) return xo;
  hl = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return xo = t, xo;
}
var To, vl;
function _m() {
  if (vl) return To;
  vl = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return To = e, To;
}
var Oo, ml;
function Em() {
  if (ml) return Oo;
  ml = 1;
  var e = ju(), t = wm(), r = _m();
  function n(o) {
    var a = -1, i = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++a < i; )
      this.add(o[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Oo = n, Oo;
}
var Ro, gl;
function Cm() {
  if (gl) return Ro;
  gl = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length; ++n < o; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Ro = e, Ro;
}
var So, yl;
function xm() {
  if (yl) return So;
  yl = 1;
  function e(t, r) {
    return t.has(r);
  }
  return So = e, So;
}
var Ao, bl;
function Fu() {
  if (bl) return Ao;
  bl = 1;
  var e = Em(), t = Cm(), r = xm(), n = 1, o = 2;
  function a(i, s, l, c, u, d) {
    var p = l & n, f = i.length, m = s.length;
    if (f != m && !(p && m > f))
      return !1;
    var h = d.get(i), y = d.get(s);
    if (h && y)
      return h == s && y == i;
    var b = -1, w = !0, O = l & o ? new e() : void 0;
    for (d.set(i, s), d.set(s, i); ++b < f; ) {
      var _ = i[b], S = s[b];
      if (c)
        var A = p ? c(S, _, b, s, i, d) : c(_, S, b, i, s, d);
      if (A !== void 0) {
        if (A)
          continue;
        w = !1;
        break;
      }
      if (O) {
        if (!t(s, function(P, N) {
          if (!r(O, N) && (_ === P || u(_, P, l, c, d)))
            return O.push(N);
        })) {
          w = !1;
          break;
        }
      } else if (!(_ === S || u(_, S, l, c, d))) {
        w = !1;
        break;
      }
    }
    return d.delete(i), d.delete(s), w;
  }
  return Ao = a, Ao;
}
var ko, wl;
function Tm() {
  if (wl) return ko;
  wl = 1;
  var e = We(), t = e.Uint8Array;
  return ko = t, ko;
}
var Po, _l;
function Om() {
  if (_l) return Po;
  _l = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(o, a) {
      n[++r] = [a, o];
    }), n;
  }
  return Po = e, Po;
}
var Mo, El;
function Rm() {
  if (El) return Mo;
  El = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(o) {
      n[++r] = o;
    }), n;
  }
  return Mo = e, Mo;
}
var Do, Cl;
function Sm() {
  if (Cl) return Do;
  Cl = 1;
  var e = ii(), t = Tm(), r = Lu(), n = Fu(), o = Om(), a = Rm(), i = 1, s = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", d = "[object Map]", p = "[object Number]", f = "[object RegExp]", m = "[object Set]", h = "[object String]", y = "[object Symbol]", b = "[object ArrayBuffer]", w = "[object DataView]", O = e ? e.prototype : void 0, _ = O ? O.valueOf : void 0;
  function S(A, P, N, j, F, M, I) {
    switch (N) {
      case w:
        if (A.byteLength != P.byteLength || A.byteOffset != P.byteOffset)
          return !1;
        A = A.buffer, P = P.buffer;
      case b:
        return !(A.byteLength != P.byteLength || !M(new t(A), new t(P)));
      case l:
      case c:
      case p:
        return r(+A, +P);
      case u:
        return A.name == P.name && A.message == P.message;
      case f:
      case h:
        return A == P + "";
      case d:
        var D = o;
      case m:
        var T = j & i;
        if (D || (D = a), A.size != P.size && !T)
          return !1;
        var R = I.get(A);
        if (R)
          return R == P;
        j |= s, I.set(A, P);
        var g = n(D(A), D(P), j, F, M, I);
        return I.delete(A), g;
      case y:
        if (_)
          return _.call(A) == _.call(P);
    }
    return !1;
  }
  return Do = S, Do;
}
var Lo, xl;
function Am() {
  if (xl) return Lo;
  xl = 1;
  function e(t, r) {
    for (var n = -1, o = r.length, a = t.length; ++n < o; )
      t[a + n] = r[n];
    return t;
  }
  return Lo = e, Lo;
}
var Io, Tl;
function li() {
  if (Tl) return Io;
  Tl = 1;
  var e = Array.isArray;
  return Io = e, Io;
}
var No, Ol;
function km() {
  if (Ol) return No;
  Ol = 1;
  var e = Am(), t = li();
  function r(n, o, a) {
    var i = o(n);
    return t(n) ? i : e(i, a(n));
  }
  return No = r, No;
}
var qo, Rl;
function Pm() {
  if (Rl) return qo;
  Rl = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length, a = 0, i = []; ++n < o; ) {
      var s = t[n];
      r(s, n, t) && (i[a++] = s);
    }
    return i;
  }
  return qo = e, qo;
}
var jo, Sl;
function Mm() {
  if (Sl) return jo;
  Sl = 1;
  function e() {
    return [];
  }
  return jo = e, jo;
}
var Fo, Al;
function Dm() {
  if (Al) return Fo;
  Al = 1;
  var e = Pm(), t = Mm(), r = Object.prototype, n = r.propertyIsEnumerable, o = Object.getOwnPropertySymbols, a = o ? function(i) {
    return i == null ? [] : (i = Object(i), e(o(i), function(s) {
      return n.call(i, s);
    }));
  } : t;
  return Fo = a, Fo;
}
var $o, kl;
function Lm() {
  if (kl) return $o;
  kl = 1;
  function e(t, r) {
    for (var n = -1, o = Array(t); ++n < t; )
      o[n] = r(n);
    return o;
  }
  return $o = e, $o;
}
var Bo, Pl;
function Cr() {
  if (Pl) return Bo;
  Pl = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Bo = e, Bo;
}
var Ho, Ml;
function Im() {
  if (Ml) return Ho;
  Ml = 1;
  var e = _r(), t = Cr(), r = "[object Arguments]";
  function n(o) {
    return t(o) && e(o) == r;
  }
  return Ho = n, Ho;
}
var Wo, Dl;
function Nm() {
  if (Dl) return Wo;
  Dl = 1;
  var e = Im(), t = Cr(), r = Object.prototype, n = r.hasOwnProperty, o = r.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !o.call(i, "callee");
  };
  return Wo = a, Wo;
}
var tr = { exports: {} }, Uo, Ll;
function qm() {
  if (Ll) return Uo;
  Ll = 1;
  function e() {
    return !1;
  }
  return Uo = e, Uo;
}
tr.exports;
var Il;
function $u() {
  return Il || (Il = 1, function(e, t) {
    var r = We(), n = qm(), o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, i = a && a.exports === o, s = i ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
    e.exports = c;
  }(tr, tr.exports)), tr.exports;
}
var Vo, Nl;
function jm() {
  if (Nl) return Vo;
  Nl = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, o) {
    var a = typeof n;
    return o = o ?? e, !!o && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < o;
  }
  return Vo = r, Vo;
}
var Yo, ql;
function Bu() {
  if (ql) return Yo;
  ql = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Yo = t, Yo;
}
var zo, jl;
function Fm() {
  if (jl) return zo;
  jl = 1;
  var e = _r(), t = Bu(), r = Cr(), n = "[object Arguments]", o = "[object Array]", a = "[object Boolean]", i = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", d = "[object Object]", p = "[object RegExp]", f = "[object Set]", m = "[object String]", h = "[object WeakMap]", y = "[object ArrayBuffer]", b = "[object DataView]", w = "[object Float32Array]", O = "[object Float64Array]", _ = "[object Int8Array]", S = "[object Int16Array]", A = "[object Int32Array]", P = "[object Uint8Array]", N = "[object Uint8ClampedArray]", j = "[object Uint16Array]", F = "[object Uint32Array]", M = {};
  M[w] = M[O] = M[_] = M[S] = M[A] = M[P] = M[N] = M[j] = M[F] = !0, M[n] = M[o] = M[y] = M[a] = M[b] = M[i] = M[s] = M[l] = M[c] = M[u] = M[d] = M[p] = M[f] = M[m] = M[h] = !1;
  function I(D) {
    return r(D) && t(D.length) && !!M[e(D)];
  }
  return zo = I, zo;
}
var Ko, Fl;
function $m() {
  if (Fl) return Ko;
  Fl = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Ko = e, Ko;
}
var rr = { exports: {} };
rr.exports;
var $l;
function Bm() {
  return $l || ($l = 1, function(e, t) {
    var r = Iu(), n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, a = o && o.exports === n, i = a && r.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || i && i.binding && i.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(rr, rr.exports)), rr.exports;
}
var Go, Bl;
function Hu() {
  if (Bl) return Go;
  Bl = 1;
  var e = Fm(), t = $m(), r = Bm(), n = r && r.isTypedArray, o = n ? t(n) : e;
  return Go = o, Go;
}
var Xo, Hl;
function Hm() {
  if (Hl) return Xo;
  Hl = 1;
  var e = Lm(), t = Nm(), r = li(), n = $u(), o = jm(), a = Hu(), i = Object.prototype, s = i.hasOwnProperty;
  function l(c, u) {
    var d = r(c), p = !d && t(c), f = !d && !p && n(c), m = !d && !p && !f && a(c), h = d || p || f || m, y = h ? e(c.length, String) : [], b = y.length;
    for (var w in c)
      (u || s.call(c, w)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      f && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      o(w, b))) && y.push(w);
    return y;
  }
  return Xo = l, Xo;
}
var Jo, Wl;
function Wm() {
  if (Wl) return Jo;
  Wl = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, o = typeof n == "function" && n.prototype || e;
    return r === o;
  }
  return Jo = t, Jo;
}
var Zo, Ul;
function Um() {
  if (Ul) return Zo;
  Ul = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Zo = e, Zo;
}
var Qo, Vl;
function Vm() {
  if (Vl) return Qo;
  Vl = 1;
  var e = Um(), t = e(Object.keys, Object);
  return Qo = t, Qo;
}
var ea, Yl;
function Ym() {
  if (Yl) return ea;
  Yl = 1;
  var e = Wm(), t = Vm(), r = Object.prototype, n = r.hasOwnProperty;
  function o(a) {
    if (!e(a))
      return t(a);
    var i = [];
    for (var s in Object(a))
      n.call(a, s) && s != "constructor" && i.push(s);
    return i;
  }
  return ea = o, ea;
}
var ta, zl;
function zm() {
  if (zl) return ta;
  zl = 1;
  var e = Nu(), t = Bu();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ta = r, ta;
}
var ra, Kl;
function Km() {
  if (Kl) return ra;
  Kl = 1;
  var e = Hm(), t = Ym(), r = zm();
  function n(o) {
    return r(o) ? e(o) : t(o);
  }
  return ra = n, ra;
}
var na, Gl;
function Gm() {
  if (Gl) return na;
  Gl = 1;
  var e = km(), t = Dm(), r = Km();
  function n(o) {
    return e(o, r, t);
  }
  return na = n, na;
}
var oa, Xl;
function Xm() {
  if (Xl) return oa;
  Xl = 1;
  var e = Gm(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function o(a, i, s, l, c, u) {
    var d = s & t, p = e(a), f = p.length, m = e(i), h = m.length;
    if (f != h && !d)
      return !1;
    for (var y = f; y--; ) {
      var b = p[y];
      if (!(d ? b in i : n.call(i, b)))
        return !1;
    }
    var w = u.get(a), O = u.get(i);
    if (w && O)
      return w == i && O == a;
    var _ = !0;
    u.set(a, i), u.set(i, a);
    for (var S = d; ++y < f; ) {
      b = p[y];
      var A = a[b], P = i[b];
      if (l)
        var N = d ? l(P, A, b, i, a, u) : l(A, P, b, a, i, u);
      if (!(N === void 0 ? A === P || c(A, P, s, l, u) : N)) {
        _ = !1;
        break;
      }
      S || (S = b == "constructor");
    }
    if (_ && !S) {
      var j = a.constructor, F = i.constructor;
      j != F && "constructor" in a && "constructor" in i && !(typeof j == "function" && j instanceof j && typeof F == "function" && F instanceof F) && (_ = !1);
    }
    return u.delete(a), u.delete(i), _;
  }
  return oa = o, oa;
}
var aa, Jl;
function Jm() {
  if (Jl) return aa;
  Jl = 1;
  var e = Bt(), t = We(), r = e(t, "DataView");
  return aa = r, aa;
}
var ia, Zl;
function Zm() {
  if (Zl) return ia;
  Zl = 1;
  var e = Bt(), t = We(), r = e(t, "Promise");
  return ia = r, ia;
}
var sa, Ql;
function Qm() {
  if (Ql) return sa;
  Ql = 1;
  var e = Bt(), t = We(), r = e(t, "Set");
  return sa = r, sa;
}
var la, ec;
function eg() {
  if (ec) return la;
  ec = 1;
  var e = Bt(), t = We(), r = e(t, "WeakMap");
  return la = r, la;
}
var ca, tc;
function tg() {
  if (tc) return ca;
  tc = 1;
  var e = Jm(), t = si(), r = Zm(), n = Qm(), o = eg(), a = _r(), i = qu(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", d = "[object WeakMap]", p = "[object DataView]", f = i(e), m = i(t), h = i(r), y = i(n), b = i(o), w = a;
  return (e && w(new e(new ArrayBuffer(1))) != p || t && w(new t()) != s || r && w(r.resolve()) != c || n && w(new n()) != u || o && w(new o()) != d) && (w = function(O) {
    var _ = a(O), S = _ == l ? O.constructor : void 0, A = S ? i(S) : "";
    if (A)
      switch (A) {
        case f:
          return p;
        case m:
          return s;
        case h:
          return c;
        case y:
          return u;
        case b:
          return d;
      }
    return _;
  }), ca = w, ca;
}
var ua, rc;
function rg() {
  if (rc) return ua;
  rc = 1;
  var e = bm(), t = Fu(), r = Sm(), n = Xm(), o = tg(), a = li(), i = $u(), s = Hu(), l = 1, c = "[object Arguments]", u = "[object Array]", d = "[object Object]", p = Object.prototype, f = p.hasOwnProperty;
  function m(h, y, b, w, O, _) {
    var S = a(h), A = a(y), P = S ? u : o(h), N = A ? u : o(y);
    P = P == c ? d : P, N = N == c ? d : N;
    var j = P == d, F = N == d, M = P == N;
    if (M && i(h)) {
      if (!i(y))
        return !1;
      S = !0, j = !1;
    }
    if (M && !j)
      return _ || (_ = new e()), S || s(h) ? t(h, y, b, w, O, _) : r(h, y, P, b, w, O, _);
    if (!(b & l)) {
      var I = j && f.call(h, "__wrapped__"), D = F && f.call(y, "__wrapped__");
      if (I || D) {
        var T = I ? h.value() : h, R = D ? y.value() : y;
        return _ || (_ = new e()), O(T, R, b, w, _);
      }
    }
    return M ? (_ || (_ = new e()), n(h, y, b, w, O, _)) : !1;
  }
  return ua = m, ua;
}
var fa, nc;
function ng() {
  if (nc) return fa;
  nc = 1;
  var e = rg(), t = Cr();
  function r(n, o, a, i, s) {
    return n === o ? !0 : n == null || o == null || !t(n) && !t(o) ? n !== n && o !== o : e(n, o, a, i, r, s);
  }
  return fa = r, fa;
}
var da, oc;
function og() {
  if (oc) return da;
  oc = 1;
  var e = ng();
  function t(r, n) {
    return e(r, n);
  }
  return da = t, da;
}
var ag = og();
const ig = /* @__PURE__ */ Ft(ag);
var sg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, lg = window.device, B = {}, Ma = [];
window.device = B;
var fr = window.document.documentElement, cg = window.navigator.userAgent.toLowerCase(), ac = ["googletv", "viera", "smarttv", "internet.tv", "netcast", "nettv", "appletv", "boxee", "kylo", "roku", "dlnadoc", "pov_tv", "hbbtv", "ce-html"];
B.macos = function() {
  return se("mac");
};
B.ios = function() {
  return B.iphone() || B.ipod() || B.ipad();
};
B.iphone = function() {
  return !B.windows() && se("iphone");
};
B.ipod = function() {
  return se("ipod");
};
B.ipad = function() {
  var e = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return se("ipad") || e;
};
B.android = function() {
  return !B.windows() && se("android");
};
B.androidPhone = function() {
  return B.android() && se("mobile");
};
B.androidTablet = function() {
  return B.android() && !se("mobile");
};
B.blackberry = function() {
  return se("blackberry") || se("bb10");
};
B.blackberryPhone = function() {
  return B.blackberry() && !se("tablet");
};
B.blackberryTablet = function() {
  return B.blackberry() && se("tablet");
};
B.windows = function() {
  return se("windows");
};
B.windowsPhone = function() {
  return B.windows() && se("phone");
};
B.windowsTablet = function() {
  return B.windows() && se("touch") && !B.windowsPhone();
};
B.fxos = function() {
  return (se("(mobile") || se("(tablet")) && se(" rv:");
};
B.fxosPhone = function() {
  return B.fxos() && se("mobile");
};
B.fxosTablet = function() {
  return B.fxos() && se("tablet");
};
B.meego = function() {
  return se("meego");
};
B.cordova = function() {
  return window.cordova && location.protocol === "file:";
};
B.nodeWebkit = function() {
  return sg(window.process) === "object";
};
B.mobile = function() {
  return B.androidPhone() || B.iphone() || B.ipod() || B.windowsPhone() || B.blackberryPhone() || B.fxosPhone() || B.meego();
};
B.tablet = function() {
  return B.ipad() || B.androidTablet() || B.blackberryTablet() || B.windowsTablet() || B.fxosTablet();
};
B.desktop = function() {
  return !B.tablet() && !B.mobile();
};
B.television = function() {
  for (var e = 0; e < ac.length; ) {
    if (se(ac[e]))
      return !0;
    e++;
  }
  return !1;
};
B.portrait = function() {
  return screen.orientation && Object.prototype.hasOwnProperty.call(window, "onorientationchange") ? ci(screen.orientation.type, "portrait") : B.ios() && Object.prototype.hasOwnProperty.call(window, "orientation") ? Math.abs(window.orientation) !== 90 : window.innerHeight / window.innerWidth > 1;
};
B.landscape = function() {
  return screen.orientation && Object.prototype.hasOwnProperty.call(window, "onorientationchange") ? ci(screen.orientation.type, "landscape") : B.ios() && Object.prototype.hasOwnProperty.call(window, "orientation") ? Math.abs(window.orientation) === 90 : window.innerHeight / window.innerWidth < 1;
};
B.noConflict = function() {
  return window.device = lg, this;
};
function ci(e, t) {
  return e.indexOf(t) !== -1;
}
function se(e) {
  return ci(cg, e);
}
function Wu(e) {
  return fr.className.match(new RegExp(e, "i"));
}
function ce(e) {
  var t = null;
  Wu(e) || (t = fr.className.replace(/^\s+|\s+$/g, ""), fr.className = t + " " + e);
}
function ic(e) {
  Wu(e) && (fr.className = fr.className.replace(" " + e, ""));
}
B.ios() ? B.ipad() ? ce("ios ipad tablet") : B.iphone() ? ce("ios iphone mobile") : B.ipod() && ce("ios ipod mobile") : B.macos() ? ce("macos desktop") : B.android() ? B.androidTablet() ? ce("android tablet") : ce("android mobile") : B.blackberry() ? B.blackberryTablet() ? ce("blackberry tablet") : ce("blackberry mobile") : B.windows() ? B.windowsTablet() ? ce("windows tablet") : B.windowsPhone() ? ce("windows mobile") : ce("windows desktop") : B.fxos() ? B.fxosTablet() ? ce("fxos tablet") : ce("fxos mobile") : B.meego() ? ce("meego mobile") : B.nodeWebkit() ? ce("node-webkit") : B.television() ? ce("television") : B.desktop() && ce("desktop");
B.cordova() && ce("cordova");
function Hr() {
  B.landscape() ? (ic("portrait"), ce("landscape"), sc("landscape")) : (ic("landscape"), ce("portrait"), sc("portrait")), Uu();
}
function sc(e) {
  for (var t = 0; t < Ma.length; t++)
    Ma[t](e);
}
B.onChangeOrientation = function(e) {
  typeof e == "function" && Ma.push(e);
};
var Wr = "resize";
Object.prototype.hasOwnProperty.call(window, "onorientationchange") && (Wr = "orientationchange");
window.addEventListener ? window.addEventListener(Wr, Hr, !1) : window.attachEvent ? window.attachEvent(Wr, Hr) : window[Wr] = Hr;
Hr();
function ui(e) {
  for (var t = 0; t < e.length; t++)
    if (B[e[t]]())
      return e[t];
  return "unknown";
}
B.type = ui(["mobile", "tablet", "desktop"]);
B.os = ui(["ios", "iphone", "ipad", "ipod", "android", "blackberry", "macos", "windows", "fxos", "meego", "television"]);
function Uu() {
  B.orientation = ui(["portrait", "landscape"]);
}
Uu();
const ug = (e = "") => {
  var t, r;
  try {
    const n = (r = (t = window == null ? void 0 : window.localStorage) == null ? void 0 : t.getItem) == null ? void 0 : r.call(t, e);
    return n ? JSON.parse(n) : null;
  } catch {
    return console.error("error parse data from localstorage"), null;
  }
}, lc = (e = "", t = {}) => {
  var r;
  try {
    (r = window == null ? void 0 : window.localStorage) != null && r.setItem && window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
    console.error("error parse data from localstorage");
  }
}, Sb = (e = "") => {
  var t;
  try {
    (t = window.localStorage) != null && t.removeItem && window.localStorage.removeItem(e);
  } catch (r) {
    throw console.error(`Error removing data with key ${e} from LocalStorage`), r;
  }
}, Ab = (e = "") => {
  var t, r;
  try {
    const n = (r = (t = window == null ? void 0 : window.sessionStorage) == null ? void 0 : t.getItem) == null ? void 0 : r.call(t, e);
    return n ? JSON.parse(n) : null;
  } catch {
    return console.error("error parse data from sessionStorage"), null;
  }
}, kb = (e = "", t = {}) => {
  var r;
  try {
    (r = window == null ? void 0 : window.sessionStorage) != null && r.setItem && window.sessionStorage.setItem(e, JSON.stringify(t));
  } catch {
    console.error("error saving data in sessionStorage");
  }
}, Pb = (e = "") => {
  var t;
  try {
    (t = window == null ? void 0 : window.sessionStorage) != null && t.removeItem && window.sessionStorage.removeItem(e);
  } catch {
    console.error("error removing data from sessionStorage");
  }
}, fg = () => window.matchMedia(" (max-width: 672px) ").matches, Vu = B.mobile() || fg(), Mb = B.mobile() && window.matchMedia(" (max-width: 360px) ").matches, Db = B.desktop() && window.matchMedia(" (min-width: 1440px) ").matches, Lb = Vu || B.tablet(), Ib = () => {
  var e;
  return /MSIE|Trident/.test((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent);
}, Nb = () => {
  var e;
  return /^((?!chrome|android|crios|fxios).)*safari/i.test((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent);
}, qb = () => {
  var t, r;
  const e = (r = new URL((t = window == null ? void 0 : window.location) == null ? void 0 : t.href)) == null ? void 0 : r.searchParams;
  e && (lc("isWebview", e == null ? void 0 : e.get("isWebview")), lc("device", e == null ? void 0 : e.get("device")));
}, fi = () => {
  var e;
  return ug("isWebview") || /(Version\/\d+.*\/\d+.0.0.0 Mobile|; ?wv|(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari))/i.test(
    (e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent
  );
}, Yu = () => fi() && B.ios(), jb = () => B.iphone() && fi(), dg = (e = window.location.href) => {
  var t, r, n, o;
  (o = (n = (r = (t = window == null ? void 0 : window.webkit) == null ? void 0 : t.messageHandlers) == null ? void 0 : r.reloadWebview) == null ? void 0 : n.postMessage) == null || o.call(n, e);
}, Fb = () => {
  const e = window.matchMedia("(display-mode: standalone)").matches, t = typeof window.getDigitalAssetLinks < "u";
  return typeof window.Android < "u" || t || e;
}, zu = 10, pg = "image/png,image/jpeg,image/jpg,image/gif", hg = (e, t, r) => {
  const n = new FileReader();
  n.onload = () => {
    var o;
    t && t(((o = n.result) == null ? void 0 : o.toString()) || "");
  }, n.onerror = () => {
    r && r();
  }, n.readAsDataURL(e);
}, $b = ({ name: e, blob: t }) => {
  const r = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(t) : window.webkitURL.createObjectURL(t), n = document.createElement("a");
  n.style.display = "none", n.href = r, n.setAttribute("download", e), typeof n.download > "u" && (n.setAttribute("target", "_blank"), n.rel = "noopener noreferrer"), document.body.appendChild(n), n.click(), setTimeout(() => {
    document.body.removeChild(n), window.URL.revokeObjectURL(r);
  }, 200);
}, Bb = (e) => {
  var t, r, n;
  Yu() && ((n = (r = (t = window == null ? void 0 : window.webkit) == null ? void 0 : t.messageHandlers) == null ? void 0 : r.openDocument) == null || n.postMessage(e));
}, vg = (e, t = zu) => e.size / 1024 / 1024 > t, cc = pg.split(",").map((e) => e.trim()), Hb = ({
  file: e,
  size: t = zu,
  allowPdf: r = !1
}) => {
  const n = [], o = r ? [...cc.filter((a) => a !== "image/gif"), "application/pdf"] : cc;
  if (!o.includes(e.type)) {
    const a = o.map((i) => i.replace("image/", "").replace("application/", "")).join(", ");
    n.push(`Unsupported file type. Allowed types: ${a}.`);
  }
  return vg(e, t) && n.push(`File is too large. Maximum allowed size is ${t}MB`), n.join(" ");
}, mg = Math.PI / 180;
async function gg(e, t, r, n = 1, o = 0, a = 1, i = 1, s = 1) {
  const l = t.getContext("2d");
  if (!l)
    throw new Error("No 2d context");
  const c = e.naturalWidth / e.width, u = e.naturalHeight / e.height, d = window.devicePixelRatio;
  t.width = Math.floor(r.width * c * d), t.height = Math.floor(r.height * u * d), l.scale(d, d), l.imageSmoothingQuality = "high";
  const p = r.x * c, f = r.y * u, m = o * mg, h = e.naturalWidth / 2, y = e.naturalHeight / 2;
  l.save(), l.filter = `brightness(${a}) contrast(${i}) sepia(${s})`, l.translate(-p, -f), l.translate(h, y), l.rotate(m), l.scale(n, n), l.translate(-h, -y), l.drawImage(
    e,
    0,
    0,
    e.naturalWidth,
    e.naturalHeight,
    0,
    0,
    e.naturalWidth,
    e.naturalHeight
  ), l.restore();
}
function uc(e, t, r) {
  return Bv(
    $v(
      {
        unit: "%",
        width: 90
      },
      r,
      e,
      t
    ),
    e,
    t
  );
}
function yg(e, t, r) {
  he(() => {
    const n = setTimeout(() => {
      e();
    }, t);
    return () => {
      clearTimeout(n);
    };
  }, r);
}
const bg = "_cropper_dydpj_1", wg = "_cropControls_dydpj_8", _g = "_toggle_dydpj_44", Eg = "_cropControlButtons_dydpj_87", Cg = "_previewCanvas_dydpj_144", St = {
  cropper: bg,
  cropControls: wg,
  toggle: _g,
  cropControlButtons: Eg,
  previewCanvas: Cg
};
function xg({ confirmAction: e, file: t, defaultAspectRatio: r = 16 / 9, className: n, isPad: o = !1 }, a) {
  const [i, s] = xe(""), l = ue(null), c = ue(null), [u, d] = xe(), [p, f] = xe(), m = {
    scale: 1,
    rotate: 0,
    showPreview: !1,
    brightness: 1,
    contrast: 1,
    sepia: 0,
    aspect: r
  }, [h, y] = xe(m);
  he(() => {
    d(void 0), hg(
      t,
      (_) => s(_),
      () => s("")
    );
  }, [t]), yg(
    () => {
      p != null && p.width && (p != null && p.height) && c.current && l.current && gg(
        c.current,
        l.current,
        p,
        h.scale,
        h.rotate,
        h.brightness,
        h.contrast,
        h.sepia
      );
    },
    100,
    [
      p,
      h.scale,
      h.rotate,
      h.brightness,
      h.contrast,
      h.sepia
    ]
  );
  function b(_) {
    if (h.aspect) {
      const { width: S, height: A } = _.currentTarget;
      d(uc(S, A, h.aspect));
    }
  }
  function w() {
    const _ = c.current, S = l.current;
    if (!_ || !S || !p)
      throw new Error("Crop canvas does not exist");
    const A = document.createElement("canvas"), P = _.naturalWidth / _.width, N = _.naturalHeight / _.height;
    A.width = Math.ceil(p.width * P), A.height = Math.ceil(p.height * N);
    const j = A.getContext("2d");
    if (!j)
      throw new Error("No 2d context");
    j.drawImage(
      S,
      0,
      0,
      S.width,
      S.height,
      0,
      0,
      A.width,
      A.height
    );
    const F = new FileReader();
    A.toBlob((M) => {
      M && (F.readAsDataURL(M), F.onloadend = () => {
        const I = new File([M], t.name);
        e(F.result, I);
      });
    }, "image/png");
  }
  function O() {
    if (h.aspect)
      y((_) => ({ ..._, aspect: void 0 }));
    else if (y((_) => ({ ..._, aspect: r })), c.current) {
      const { width: _, height: S } = c.current, A = uc(_, S, r);
      d(A), f(Ie(A, _, S));
    }
  }
  return /* @__PURE__ */ x.createElement("div", { className: fe(St.cropper, n) }, !!i && /* @__PURE__ */ x.createElement(
    Uv,
    {
      crop: u,
      onChange: (_, S) => d(S),
      onComplete: (_) => f(_),
      aspect: h.aspect,
      minHeight: 100,
      ruleOfThirds: !0,
      keepSelection: !0
    },
    /* @__PURE__ */ x.createElement(
      "img",
      {
        ref: c,
        alt: "Crop me",
        src: i,
        style: {
          transform: `scale(${h.scale}) rotate(${h.rotate}deg)`,
          filter: `brightness(${h.brightness}) contrast(${h.contrast}) sepia(${h.sepia})`
        },
        onLoad: b
      }
    )
  ), /* @__PURE__ */ x.createElement("div", { className: St.cropControls }, o || B.ios() ? null : /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "brightness-input" }, "Brightness: "), /* @__PURE__ */ x.createElement(
    "input",
    {
      id: "brightness-input",
      type: "range",
      value: h.brightness,
      disabled: !i,
      min: "0.2",
      max: "2",
      step: "0.1",
      onChange: (_) => {
        const S = Number(_.target.value);
        y((A) => ({ ...A, brightness: S }));
      }
    }
  )), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "contrast-input" }, "Contrast: "), /* @__PURE__ */ x.createElement(
    "input",
    {
      id: "contrast-input",
      type: "range",
      value: h.contrast,
      disabled: !i,
      min: "0.2",
      max: "2",
      step: "0.1",
      onChange: (_) => {
        const S = Number(_.target.value);
        y((A) => ({ ...A, contrast: S }));
      }
    }
  )), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "sepia-input" }, "Sepia: "), /* @__PURE__ */ x.createElement(
    "input",
    {
      id: "sepia-input",
      type: "range",
      value: h.sepia,
      disabled: !i,
      min: "0.1",
      max: "1",
      step: "0.1",
      onChange: (_) => {
        const S = Number(_.target.value);
        y((A) => ({ ...A, sepia: S }));
      }
    }
  ))), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "scale-input" }, "Zoom: "), /* @__PURE__ */ x.createElement(
    "input",
    {
      id: "scale-input",
      type: "range",
      value: h.scale,
      disabled: !i,
      min: "0.1",
      max: "10",
      step: "0.1",
      onChange: (_) => {
        const S = Number(_.target.value);
        y((A) => ({ ...A, scale: S }));
      }
    }
  )), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "rotate-input" }, "Rotate: "), /* @__PURE__ */ x.createElement(
    "input",
    {
      id: "rotate-input",
      type: "range",
      min: "-180",
      max: "180",
      step: "0.25",
      value: h.rotate,
      disabled: !i,
      onChange: (_) => {
        const S = Math.min(180, Math.max(-180, Number(_.target.value)));
        y((A) => ({
          ...A,
          rotate: S
        }));
      }
    }
  )), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "show-preview" }, "Show preview:"), /* @__PURE__ */ x.createElement(
    Ji,
    {
      name: "show-preview",
      checked: h.showPreview,
      onChange: () => {
        y((_) => ({
          ..._,
          showPreview: !_.showPreview
        }));
      },
      disabled: !i,
      className: St.toggle
    }
  )), /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("label", { htmlFor: "toggle-aspect" }, "Fixed aspect ratio:"), /* @__PURE__ */ x.createElement(
    Ji,
    {
      name: "toggle-aspect",
      checked: !!h.aspect,
      onChange: () => O(),
      disabled: !i,
      className: St.toggle
    }
  )), /* @__PURE__ */ x.createElement("div", { className: St.cropControlButtons }, /* @__PURE__ */ x.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        y(m);
      },
      disabled: !i || ig(h, m)
    },
    "Reset"
  ))), !!p && /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", { className: St.previewCanvas }, h.showPreview && /* @__PURE__ */ x.createElement("label", { htmlFor: "preview-canvas" }, "Preview:"), /* @__PURE__ */ x.createElement(
    "canvas",
    {
      id: "preview-canvas",
      ref: l,
      style: {
        width: p.width,
        height: p.height,
        display: h.showPreview ? "flex" : "none"
      }
    }
  )), /* @__PURE__ */ x.createElement(
    "button",
    {
      style: { display: "none" },
      ref: a,
      type: "button",
      onClick: w
    }
  )));
}
const Wb = Pf(xg);
function Tg({ height: e = 45, width: t = 211, color: r = "#19A69A", className: n, title: o }) {
  return /* @__PURE__ */ x.createElement(
    "svg",
    {
      width: t,
      height: e,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: n
    },
    /* @__PURE__ */ x.createElement("title", null, o),
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M0 27.064V4.27h1.955v22.686c0 10.634 5.76 16.27 14.473 16.27 8.677 0 14.295-5.383 14.295-16.163V4.27h1.955v22.615C32.678 38.867 26.064 45 16.356 45 6.72 45 0 38.938 0 27.064zM42.849 4.271h1.849l16.997 24.387 16.96-24.387h1.85v40.09h-1.956V7.639L61.73 31.707h-.107L44.804 7.639v36.722H42.92V4.271h-.071zM137.437 4.271h1.955v40.09h-1.955V4.271zM109.66 3.988h-1.814l-19.09 40.374h2.026l5.512-11.697 12.411-26.408 11.592 24.635.889 1.773 5.441 11.697h2.136L109.66 3.988z",
        fill: r
      }
    ),
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M115.247 30.892h-13.726v1.773h13.726v-1.773zM157.385 18.936h2.549c3.398 0 5.478 1.641 5.478 4.337 0 2.504-2.226 4.306-5.288 4.306-3.047 0-5.171-1.7-5.332-4.058h-1.934c.132 3.384 3.018 5.816 7.281 5.816 4.116 0 7.309-2.549 7.309-6.123 0-2.988-2.08-4.995-5.317-5.186v-.058c2.695-.484 4.409-2.388 4.409-5.04 0-3.134-2.798-5.405-6.519-5.405-3.808 0-6.474 2.286-6.723 5.684h1.933c.22-2.344 2.081-3.926 4.703-3.926 2.856 0 4.585 1.612 4.585 3.897 0 2.358-1.905 4.057-4.673 4.057h-2.461v1.7zm20.713 10.4c4.233 0 7.339-3.046 7.339-7.191 0-4-3.003-6.988-7.017-6.988-2.857 0-5.361 1.64-6.226 4.014h-.044c0-6.27 2.212-9.873 6.079-9.873 2.359 0 4.278 1.435 4.805 3.589h2.022c-.601-3.238-3.296-5.362-6.812-5.362-5.01 0-8.027 4.263-8.027 11.353 0 2.651.469 4.805 1.421 6.46 1.303 2.563 3.618 3.999 6.46 3.999zm-.015-1.786c-3.032 0-5.361-2.417-5.361-5.493 0-2.871 2.358-5.127 5.376-5.127 3.061 0 5.302 2.24 5.302 5.273 0 2.988-2.343 5.347-5.317 5.347zm17.417 1.787c4.805 0 7.646-4.248 7.646-10.928 0-6.636-2.856-10.884-7.646-10.884-4.775 0-7.661 4.263-7.661 10.899 0 6.68 2.856 10.913 7.661 10.913zm0-1.758c-3.574 0-5.64-3.56-5.64-9.17 0-5.508 2.11-9.111 5.64-9.111 3.545 0 5.64 3.574 5.64 9.126 0 5.596-2.066 9.155-5.64 9.155z",
        fill: r
      }
    ),
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M207.499 10.37a2.896 2.896 0 002.901-2.892 2.896 2.896 0 00-2.901-2.892 2.895 2.895 0 00-2.9 2.892 2.895 2.895 0 002.9 2.891z",
        stroke: r,
        strokeWidth: 1.2
      }
    )
  );
}
const Og = "_closeButton_1th4j_2", Rg = "_modal_1th4j_6", Sg = "_header_1th4j_22", Ag = "_title_1th4j_28", kg = "_description_1th4j_37", Pg = "_subtitle_1th4j_45", At = {
  closeButton: Og,
  modal: Rg,
  header: Sg,
  title: Ag,
  description: kg,
  subtitle: Pg
};
function Ub({
  modalIsOpen: e,
  closeModal: t,
  containerClassName: r,
  hideClose: n,
  customClasses: o,
  ...a
}) {
  return /* @__PURE__ */ x.createElement(
    nu,
    {
      modalIsOpen: e,
      onRequestClose: t,
      contentLabel: "premium modal",
      closeButtonClassName: At.closeButton,
      hideClose: n,
      customClasses: o,
      ...a
    },
    /* @__PURE__ */ x.createElement("section", { className: fe(At.modal, { containerClassName: r }) }, /* @__PURE__ */ x.createElement("h1", { className: At.header }, /* @__PURE__ */ x.createElement(Tg, null)), /* @__PURE__ */ x.createElement("h3", { className: At.title }, "This feature is not included in your current subscription. To utilize it and get the most out of UMAI 360 upgrade to a higher tier."), /* @__PURE__ */ x.createElement("p", { className: At.description }, "Get more detailed room and table management, unlock table combinations and table specific turn time that help increase guests in your venue.", /* @__PURE__ */ x.createElement("br", null), /* @__PURE__ */ x.createElement("br", null), "Unlock table based smart capacity to maximize the amount of reservations without ever having to worry about overbookings.", /* @__PURE__ */ x.createElement("br", null), /* @__PURE__ */ x.createElement("br", null), "Accept cancellation fees, deposits, and pre-payments and make no-shows a thing of the past."), /* @__PURE__ */ x.createElement("p", { className: At.subtitle }, "Speak to your UMAI account manager for help"))
  );
}
const Mg = "_proIcon_1apzh_1", Dg = "_labelText_1apzh_10", fc = {
  proIcon: Mg,
  labelText: Dg
}, Vb = ({ className: e, children: t = "Pro" }) => /* @__PURE__ */ x.createElement("span", { className: fe(fc.proIcon, e) }, /* @__PURE__ */ x.createElement("span", { className: fc.labelText }, t));
function Ku(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Ku(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function pt() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Ku(e)) && (n && (n += " "), n += t);
  return n;
}
function Lg(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
Lg(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var xr = (e) => typeof e == "number" && !isNaN(e), gt = (e) => typeof e == "string", Je = (e) => typeof e == "function", Ig = (e) => gt(e) || xr(e), Da = (e) => gt(e) || Je(e) ? e : null, Ng = (e, t) => e === !1 || xr(e) && e > 0 ? e : t, La = (e) => tn(e) || gt(e) || Je(e) || xr(e);
function qg(e, t, r = 300) {
  let { scrollHeight: n, style: o } = e;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = n + "px", o.transition = `all ${r}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(t, r);
    });
  });
}
function jg({ enter: e, exit: t, appendPosition: r = !1, collapse: n = !0, collapseDuration: o = 300 }) {
  return function({ children: a, position: i, preventExitTransition: s, done: l, nodeRef: c, isIn: u, playToast: d }) {
    let p = r ? `${e}--${i}` : e, f = r ? `${t}--${i}` : t, m = ue(0);
    return hr(() => {
      let h = c.current, y = p.split(" "), b = (w) => {
        w.target === c.current && (d(), h.removeEventListener("animationend", b), h.removeEventListener("animationcancel", b), m.current === 0 && w.type !== "animationcancel" && h.classList.remove(...y));
      };
      h.classList.add(...y), h.addEventListener("animationend", b), h.addEventListener("animationcancel", b);
    }, []), he(() => {
      let h = c.current, y = () => {
        h.removeEventListener("animationend", y), n ? qg(h, l, o) : l();
      };
      u || (s ? y() : (m.current = 1, h.className += ` ${f}`, h.addEventListener("animationend", y)));
    }, [u]), x.createElement(x.Fragment, null, a);
  };
}
function dc(e, t) {
  return { content: Gu(e.content, e.props), containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, reason: e.removalReason, status: t };
}
function Gu(e, t, r = !1) {
  return tn(e) && !gt(e.type) ? Ha(e, { closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: r }) : Je(e) ? e({ closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: r }) : e;
}
function Fg({ closeToast: e, theme: t, ariaLabel: r = "close" }) {
  return x.createElement("button", { className: `Toastify__close-button Toastify__close-button--${t}`, type: "button", onClick: (n) => {
    n.stopPropagation(), e(!0);
  }, "aria-label": r }, x.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, x.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function $g({ delay: e, isRunning: t, closeToast: r, type: n = "default", hide: o, className: a, controlledProgress: i, progress: s, rtl: l, isIn: c, theme: u }) {
  let d = o || i && s === 0, p = { animationDuration: `${e}ms`, animationPlayState: t ? "running" : "paused" };
  i && (p.transform = `scaleX(${s})`);
  let f = pt("Toastify__progress-bar", i ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${u}`, `Toastify__progress-bar--${n}`, { "Toastify__progress-bar--rtl": l }), m = Je(a) ? a({ rtl: l, type: n, defaultClassName: f }) : pt(f, a), h = { [i && s >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: i && s < 1 ? null : () => {
    c && r();
  } };
  return x.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": d }, x.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${u} Toastify__progress-bar--${n}` }), x.createElement("div", { role: "progressbar", "aria-hidden": d ? "true" : "false", "aria-label": "notification timer", className: m, style: p, ...h }));
}
var Bg = 1, Xu = () => `${Bg++}`;
function Hg(e, t, r) {
  let n = 1, o = 0, a = [], i = [], s = t, l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set(), u = (w) => (c.add(w), () => c.delete(w)), d = () => {
    i = Array.from(l.values()), c.forEach((w) => w());
  }, p = ({ containerId: w, toastId: O, updateId: _ }) => {
    let S = w ? w !== e : e !== 1, A = l.has(O) && _ == null;
    return S || A;
  }, f = (w, O) => {
    l.forEach((_) => {
      var S;
      (O == null || O === _.props.toastId) && ((S = _.toggle) == null || S.call(_, w));
    });
  }, m = (w) => {
    var O, _;
    (_ = (O = w.props) == null ? void 0 : O.onClose) == null || _.call(O, w.removalReason), w.isActive = !1;
  }, h = (w) => {
    if (w == null) l.forEach(m);
    else {
      let O = l.get(w);
      O && m(O);
    }
    d();
  }, y = () => {
    o -= a.length, a = [];
  }, b = (w) => {
    var O, _;
    let { toastId: S, updateId: A } = w.props, P = A == null;
    w.staleId && l.delete(w.staleId), w.isActive = !0, l.set(S, w), d(), r(dc(w, P ? "added" : "updated")), P && ((_ = (O = w.props).onOpen) == null || _.call(O));
  };
  return { id: e, props: s, observe: u, toggle: f, removeToast: h, toasts: l, clearQueue: y, buildToast: (w, O) => {
    if (p(O)) return;
    let { toastId: _, updateId: S, data: A, staleId: P, delay: N } = O, j = S == null;
    j && o++;
    let F = { ...s, style: s.toastStyle, key: n++, ...Object.fromEntries(Object.entries(O).filter(([I, D]) => D != null)), toastId: _, updateId: S, data: A, isIn: !1, className: Da(O.className || s.toastClassName), progressClassName: Da(O.progressClassName || s.progressClassName), autoClose: O.isLoading ? !1 : Ng(O.autoClose, s.autoClose), closeToast(I) {
      l.get(_).removalReason = I, h(_);
    }, deleteToast() {
      let I = l.get(_);
      if (I != null) {
        if (r(dc(I, "removed")), l.delete(_), o--, o < 0 && (o = 0), a.length > 0) {
          b(a.shift());
          return;
        }
        d();
      }
    } };
    F.closeButton = s.closeButton, O.closeButton === !1 || La(O.closeButton) ? F.closeButton = O.closeButton : O.closeButton === !0 && (F.closeButton = La(s.closeButton) ? s.closeButton : !0);
    let M = { content: w, props: F, staleId: P };
    s.limit && s.limit > 0 && o > s.limit && j ? a.push(M) : xr(N) ? setTimeout(() => {
      b(M);
    }, N) : b(M);
  }, setProps(w) {
    s = w;
  }, setToggle: (w, O) => {
    let _ = l.get(w);
    _ && (_.toggle = O);
  }, isToastActive: (w) => {
    var O;
    return (O = l.get(w)) == null ? void 0 : O.isActive;
  }, getSnapshot: () => i };
}
var ge = /* @__PURE__ */ new Map(), dr = [], Ia = /* @__PURE__ */ new Set(), Wg = (e) => Ia.forEach((t) => t(e)), Ju = () => ge.size > 0;
function Ug() {
  dr.forEach((e) => Qu(e.content, e.options)), dr = [];
}
var Vg = (e, { containerId: t }) => {
  var r;
  return (r = ge.get(t || 1)) == null ? void 0 : r.toasts.get(e);
};
function Zu(e, t) {
  var r;
  if (t) return !!((r = ge.get(t)) != null && r.isToastActive(e));
  let n = !1;
  return ge.forEach((o) => {
    o.isToastActive(e) && (n = !0);
  }), n;
}
function Yg(e) {
  if (!Ju()) {
    dr = dr.filter((t) => e != null && t.options.toastId !== e);
    return;
  }
  if (e == null || Ig(e)) ge.forEach((t) => {
    t.removeToast(e);
  });
  else if (e && ("containerId" in e || "id" in e)) {
    let t = ge.get(e.containerId);
    t ? t.removeToast(e.id) : ge.forEach((r) => {
      r.removeToast(e.id);
    });
  }
}
var zg = (e = {}) => {
  ge.forEach((t) => {
    t.props.limit && (!e.containerId || t.id === e.containerId) && t.clearQueue();
  });
};
function Qu(e, t) {
  La(e) && (Ju() || dr.push({ content: e, options: t }), ge.forEach((r) => {
    r.buildToast(e, t);
  }));
}
function Kg(e) {
  var t;
  (t = ge.get(e.containerId || 1)) == null || t.setToggle(e.id, e.fn);
}
function ef(e, t) {
  ge.forEach((r) => {
    (t == null || !(t != null && t.containerId) || (t == null ? void 0 : t.containerId) === r.id) && r.toggle(e, t == null ? void 0 : t.id);
  });
}
function Gg(e) {
  let t = e.containerId || 1;
  return { subscribe(r) {
    let n = Hg(t, e, Wg);
    ge.set(t, n);
    let o = n.observe(r);
    return Ug(), () => {
      o(), ge.delete(t);
    };
  }, setProps(r) {
    var n;
    (n = ge.get(t)) == null || n.setProps(r);
  }, getSnapshot() {
    var r;
    return (r = ge.get(t)) == null ? void 0 : r.getSnapshot();
  } };
}
function Xg(e) {
  return Ia.add(e), () => {
    Ia.delete(e);
  };
}
function Jg(e) {
  return e && (gt(e.toastId) || xr(e.toastId)) ? e.toastId : Xu();
}
function Tr(e, t) {
  return Qu(e, t), t.toastId;
}
function pn(e, t) {
  return { ...t, type: t && t.type || e, toastId: Jg(t) };
}
function hn(e) {
  return (t, r) => Tr(t, pn(e, r));
}
function G(e, t) {
  return Tr(e, pn("default", t));
}
G.loading = (e, t) => Tr(e, pn("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t }));
function Zg(e, { pending: t, error: r, success: n }, o) {
  let a;
  t && (a = gt(t) ? G.loading(t, o) : G.loading(t.render, { ...o, ...t }));
  let i = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, s = (c, u, d) => {
    if (u == null) {
      G.dismiss(a);
      return;
    }
    let p = { type: c, ...i, ...o, data: d }, f = gt(u) ? { render: u } : u;
    return a ? G.update(a, { ...p, ...f }) : G(f.render, { ...p, ...f }), d;
  }, l = Je(e) ? e() : e;
  return l.then((c) => s("success", n, c)).catch((c) => s("error", r, c)), l;
}
G.promise = Zg;
G.success = hn("success");
G.info = hn("info");
G.error = hn("error");
G.warning = hn("warning");
G.warn = G.warning;
G.dark = (e, t) => Tr(e, pn("default", { theme: "dark", ...t }));
function Qg(e) {
  Yg(e);
}
G.dismiss = Qg;
G.clearWaitingQueue = zg;
G.isActive = Zu;
G.update = (e, t = {}) => {
  let r = Vg(e, t);
  if (r) {
    let { props: n, content: o } = r, a = { delay: 100, ...n, ...t, toastId: t.toastId || e, updateId: Xu() };
    a.toastId !== e && (a.staleId = e);
    let i = a.render || o;
    delete a.render, Tr(i, a);
  }
};
G.done = (e) => {
  G.update(e, { progress: 1 });
};
G.onChange = Xg;
G.play = (e) => ef(!0, e);
G.pause = (e) => ef(!1, e);
function ey(e) {
  var t;
  let { subscribe: r, getSnapshot: n, setProps: o } = ue(Gg(e)).current;
  o(e);
  let a = (t = Mf(r, n, n)) == null ? void 0 : t.slice();
  function i(s) {
    if (!a) return [];
    let l = /* @__PURE__ */ new Map();
    return e.newestOnTop && a.reverse(), a.forEach((c) => {
      let { position: u } = c.props;
      l.has(u) || l.set(u, []), l.get(u).push(c);
    }), Array.from(l, (c) => s(c[0], c[1]));
  }
  return { getToastToRender: i, isToastActive: Zu, count: a == null ? void 0 : a.length };
}
function ty(e) {
  let [t, r] = xe(!1), [n, o] = xe(!1), a = ue(null), i = ue({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: s, pauseOnHover: l, closeToast: c, onClick: u, closeOnClick: d } = e;
  Kg({ id: e.toastId, containerId: e.containerId, fn: r }), he(() => {
    if (e.pauseOnFocusLoss) return p(), () => {
      f();
    };
  }, [e.pauseOnFocusLoss]);
  function p() {
    document.hasFocus() || b(), window.addEventListener("focus", y), window.addEventListener("blur", b);
  }
  function f() {
    window.removeEventListener("focus", y), window.removeEventListener("blur", b);
  }
  function m(P) {
    if (e.draggable === !0 || e.draggable === P.pointerType) {
      w();
      let N = a.current;
      i.canCloseOnClick = !0, i.canDrag = !0, N.style.transition = "none", e.draggableDirection === "x" ? (i.start = P.clientX, i.removalDistance = N.offsetWidth * (e.draggablePercent / 100)) : (i.start = P.clientY, i.removalDistance = N.offsetHeight * (e.draggablePercent === 80 ? e.draggablePercent * 1.5 : e.draggablePercent) / 100);
    }
  }
  function h(P) {
    let { top: N, bottom: j, left: F, right: M } = a.current.getBoundingClientRect();
    P.nativeEvent.type !== "touchend" && e.pauseOnHover && P.clientX >= F && P.clientX <= M && P.clientY >= N && P.clientY <= j ? b() : y();
  }
  function y() {
    r(!0);
  }
  function b() {
    r(!1);
  }
  function w() {
    i.didMove = !1, document.addEventListener("pointermove", _), document.addEventListener("pointerup", S);
  }
  function O() {
    document.removeEventListener("pointermove", _), document.removeEventListener("pointerup", S);
  }
  function _(P) {
    let N = a.current;
    if (i.canDrag && N) {
      i.didMove = !0, t && b(), e.draggableDirection === "x" ? i.delta = P.clientX - i.start : i.delta = P.clientY - i.start, i.start !== P.clientX && (i.canCloseOnClick = !1);
      let j = e.draggableDirection === "x" ? `${i.delta}px, var(--y)` : `0, calc(${i.delta}px + var(--y))`;
      N.style.transform = `translate3d(${j},0)`, N.style.opacity = `${1 - Math.abs(i.delta / i.removalDistance)}`;
    }
  }
  function S() {
    O();
    let P = a.current;
    if (i.canDrag && i.didMove && P) {
      if (i.canDrag = !1, Math.abs(i.delta) > i.removalDistance) {
        o(!0), e.closeToast(!0), e.collapseAll();
        return;
      }
      P.style.transition = "transform 0.2s, opacity 0.2s", P.style.removeProperty("transform"), P.style.removeProperty("opacity");
    }
  }
  let A = { onPointerDown: m, onPointerUp: h };
  return s && l && (A.onMouseEnter = b, e.stacked || (A.onMouseLeave = y)), d && (A.onClick = (P) => {
    u && u(P), i.canCloseOnClick && c(!0);
  }), { playToast: y, pauseToast: b, isRunning: t, preventExitTransition: n, toastRef: a, eventHandlers: A };
}
var ry = typeof window < "u" ? hr : he, vn = ({ theme: e, type: t, isLoading: r, ...n }) => x.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: e === "colored" ? "currentColor" : `var(--toastify-icon-color-${t})`, ...n });
function ny(e) {
  return x.createElement(vn, { ...e }, x.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function oy(e) {
  return x.createElement(vn, { ...e }, x.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function ay(e) {
  return x.createElement(vn, { ...e }, x.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function iy(e) {
  return x.createElement(vn, { ...e }, x.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function sy() {
  return x.createElement("div", { className: "Toastify__spinner" });
}
var Na = { info: oy, warning: ny, success: ay, error: iy, spinner: sy }, ly = (e) => e in Na;
function cy({ theme: e, type: t, isLoading: r, icon: n }) {
  let o = null, a = { theme: e, type: t };
  return n === !1 || (Je(n) ? o = n({ ...a, isLoading: r }) : tn(n) ? o = Ha(n, a) : r ? o = Na.spinner() : ly(t) && (o = Na[t](a))), o;
}
var uy = (e) => {
  let { isRunning: t, preventExitTransition: r, toastRef: n, eventHandlers: o, playToast: a } = ty(e), { closeButton: i, children: s, autoClose: l, onClick: c, type: u, hideProgressBar: d, closeToast: p, transition: f, position: m, className: h, style: y, progressClassName: b, updateId: w, role: O, progress: _, rtl: S, toastId: A, deleteToast: P, isIn: N, isLoading: j, closeOnClick: F, theme: M, ariaLabel: I } = e, D = pt("Toastify__toast", `Toastify__toast-theme--${M}`, `Toastify__toast--${u}`, { "Toastify__toast--rtl": S }, { "Toastify__toast--close-on-click": F }), T = Je(h) ? h({ rtl: S, position: m, type: u, defaultClassName: D }) : pt(D, h), R = cy(e), g = !!_ || !l, v = { closeToast: p, type: u, theme: M }, E = null;
  return i === !1 || (Je(i) ? E = i(v) : tn(i) ? E = Ha(i, v) : E = Fg(v)), x.createElement(f, { isIn: N, done: P, position: m, preventExitTransition: r, nodeRef: n, playToast: a }, x.createElement("div", { id: A, tabIndex: 0, onClick: c, "data-in": N, className: T, ...o, style: y, ref: n, ...N && { role: O, "aria-label": I } }, R != null && x.createElement("div", { className: pt("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !j }) }, R), Gu(s, e, !t), E, !e.customProgressBar && x.createElement($g, { ...w && !g ? { key: `p-${w}` } : {}, rtl: S, theme: M, delay: l, isRunning: t, isIn: N, closeToast: p, hide: d, type: u, className: b, controlledProgress: g, progress: _ || 0 })));
}, fy = (e, t = !1) => ({ enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t }), dy = jg(fy("bounce", !0)), py = { position: "top-right", transition: dy, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (e) => e.altKey && e.code === "KeyT" };
function hy(e) {
  let t = { ...py, ...e }, r = e.stacked, [n, o] = xe(!0), a = ue(null), { getToastToRender: i, isToastActive: s, count: l } = ey(t), { className: c, style: u, rtl: d, containerId: p, hotKeys: f } = t;
  function m(y) {
    let b = pt("Toastify__toast-container", `Toastify__toast-container--${y}`, { "Toastify__toast-container--rtl": d });
    return Je(c) ? c({ position: y, rtl: d, defaultClassName: b }) : pt(b, Da(c));
  }
  function h() {
    r && (o(!0), G.play());
  }
  return ry(() => {
    var y;
    if (r) {
      let b = a.current.querySelectorAll('[data-in="true"]'), w = 12, O = (y = t.position) == null ? void 0 : y.includes("top"), _ = 0, S = 0;
      Array.from(b).reverse().forEach((A, P) => {
        let N = A;
        N.classList.add("Toastify__toast--stacked"), P > 0 && (N.dataset.collapsed = `${n}`), N.dataset.pos || (N.dataset.pos = O ? "top" : "bot");
        let j = _ * (n ? 0.2 : 1) + (n ? 0 : w * P);
        N.style.setProperty("--y", `${O ? j : j * -1}px`), N.style.setProperty("--g", `${w}`), N.style.setProperty("--s", `${1 - (n ? S : 0)}`), _ += N.offsetHeight, S += 0.025;
      });
    }
  }, [n, l, r]), he(() => {
    function y(b) {
      var w;
      let O = a.current;
      f(b) && ((w = O.querySelector('[tabIndex="0"]')) == null || w.focus(), o(!1), G.pause()), b.key === "Escape" && (document.activeElement === O || O != null && O.contains(document.activeElement)) && (o(!0), G.play());
    }
    return document.addEventListener("keydown", y), () => {
      document.removeEventListener("keydown", y);
    };
  }, [f]), x.createElement("section", { ref: a, className: "Toastify", id: p, onMouseEnter: () => {
    r && (o(!1), G.pause());
  }, onMouseLeave: h, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": t["aria-label"] }, i((y, b) => {
    let w = b.length ? { ...u } : { ...u, pointerEvents: "none" };
    return x.createElement("div", { tabIndex: -1, className: m(y), "data-stacked": r, style: w, key: `c-${y}` }, b.map(({ content: O, props: _ }) => x.createElement(uy, { ..._, stacked: r, collapseAll: h, isIn: s(_.toastId, _.containerId), key: `t-${_.key}` }, O)));
  }));
}
const vy = "webrms_onlineNetworkToastId", pc = "webrms_offlineNetworkToastId", Ht = {
  closeButton: !0,
  position: "top-right",
  autoClose: 7e3,
  hideProgressBar: !0,
  closeOnClick: !0,
  rtl: !1,
  pauseOnFocusLoss: !1,
  draggable: !0,
  pauseOnHover: !0,
  theme: "colored",
  icon: !1
}, Yb = (e, t = {}) => {
  G.error(e, { ...Ht, toastId: e == null ? void 0 : e.toString(), ...t });
}, zb = (e, t = {}) => {
  G.success(e, { ...Ht, toastId: e == null ? void 0 : e.toString(), ...t });
}, Kb = (e, t = {}) => {
  G.info(e, { ...Ht, toastId: e == null ? void 0 : e.toString(), ...t });
}, Gb = (e, t = {}) => {
  G.warn(e, { ...Ht, toastId: e == null ? void 0 : e.toString(), ...t });
}, my = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-wifi-off", ...e }, /* @__PURE__ */ L.createElement("line", { x1: 1, y1: 1, x2: 23, y2: 23 }), /* @__PURE__ */ L.createElement("path", { d: "M16.72 11.06A10.94 10.94 0 0 1 19 12.55" }), /* @__PURE__ */ L.createElement("path", { d: "M5 12.55a10.94 10.94 0 0 1 5.17-2.39" }), /* @__PURE__ */ L.createElement("path", { d: "M10.71 5.05A16 16 0 0 1 22.58 9" }), /* @__PURE__ */ L.createElement("path", { d: "M1.42 9a15.91 15.91 0 0 1 4.7-2.88" }), /* @__PURE__ */ L.createElement("path", { d: "M8.53 16.11a6 6 0 0 1 6.95 0" }), /* @__PURE__ */ L.createElement("line", { x1: 12, y1: 20, x2: 12, y2: 20 })), gy = (e) => /* @__PURE__ */ L.createElement("svg", { width: 26, height: 26, viewBox: "0 0 18 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.59652 10.036L9.00002 10.4395L9.40352 10.036C9.13669 9.98761 8.86334 9.98761 8.59652 10.036ZM6.85802 9.17201C7.48621 8.73366 8.234 8.49906 9.00002 8.50001C9.79502 8.50001 10.5345 8.74751 11.142 9.17201C11.2318 9.23468 11.3068 9.31626 11.3617 9.41102C11.4166 9.50577 11.4501 9.6114 11.4599 9.72048C11.4696 9.82956 11.4553 9.93945 11.418 10.0424C11.3807 10.1454 11.3213 10.2389 11.244 10.3165L9.53102 12.031C9.46135 12.1009 9.37858 12.1563 9.28747 12.1941C9.19635 12.2319 9.09867 12.2514 9.00002 12.2514C8.90137 12.2514 8.80368 12.2319 8.71257 12.1941C8.62145 12.1563 8.53869 12.1009 8.46902 12.031L6.75602 10.315C6.65137 10.21 6.58018 10.0764 6.55142 9.93101C6.52267 9.7856 6.53765 9.63493 6.59446 9.49803C6.65128 9.36113 6.74738 9.24413 6.87064 9.16181C6.9939 9.07949 7.13879 9.03554 7.28702 9.03551V9.78551L6.85802 9.17051V9.17201ZM9.00002 6.25001C7.53913 6.24762 6.11729 6.72157 4.95002 7.60001C4.87122 7.65911 4.78156 7.7021 4.68615 7.72655C4.59074 7.75099 4.49145 7.7564 4.39395 7.74247C4.19704 7.71434 4.01936 7.60914 3.90002 7.45001C3.78067 7.29088 3.72942 7.09086 3.75756 6.89395C3.78569 6.69703 3.89089 6.51936 4.05002 6.40001C5.42852 5.36501 7.14302 4.75001 9.00002 4.75001C10.857 4.75001 12.5715 5.36501 13.95 6.40001C14.0288 6.45911 14.0952 6.53314 14.1454 6.61789C14.1956 6.70264 14.2286 6.79644 14.2425 6.89395C14.2564 6.99145 14.251 7.09074 14.2266 7.18615C14.2021 7.28156 14.1591 7.37122 14.1 7.45001C14.0409 7.52881 13.9669 7.59519 13.8821 7.64537C13.7974 7.69555 13.7036 7.72855 13.6061 7.74247C13.5086 7.7564 13.4093 7.75099 13.3139 7.72655C13.2185 7.7021 13.1288 7.65911 13.05 7.60001C11.8827 6.72157 10.4609 6.24762 9.00002 6.25001ZM9.00002 1.75001C6.25052 1.75001 3.73502 2.73551 1.77902 4.37201C1.62581 4.49207 1.43193 4.54787 1.23834 4.52761C1.04475 4.50735 0.866627 4.41262 0.741597 4.26344C0.616568 4.11426 0.554432 3.92232 0.568319 3.72817C0.582206 3.53402 0.671028 3.35288 0.816017 3.22301C3.10854 1.29873 6.00695 0.245829 9.00002 0.250012C12.114 0.250012 14.97 1.36751 17.184 3.22301C17.2632 3.28504 17.329 3.36236 17.3777 3.45036C17.4264 3.53837 17.4569 3.63526 17.4673 3.73528C17.4778 3.8353 17.468 3.9364 17.4387 4.03258C17.4093 4.12875 17.3608 4.21803 17.2962 4.29511C17.2316 4.37218 17.1522 4.43548 17.0626 4.48123C16.9731 4.52698 16.8752 4.55426 16.7749 4.56143C16.6746 4.56861 16.5739 4.55554 16.4787 4.523C16.3836 4.49046 16.2959 4.43911 16.221 4.37201C14.1983 2.67418 11.6408 1.74553 9.00002 1.75001Z", fill: "white" })), yy = () => /* @__PURE__ */ x.createElement(x.Fragment, null, "Internet connection is back", /* @__PURE__ */ x.createElement(
  "button",
  {
    className: "reload-after-online",
    type: "button",
    onClick: () => {
      var e, t;
      if (fi()) {
        dg();
        return;
      }
      (t = (e = window == null ? void 0 : window.location) == null ? void 0 : e.reload) == null || t.call(e);
    }
  },
  "Reload"
)), Xb = (e = {}) => {
  G.clearWaitingQueue(), G.dismiss(), G.success(yy, {
    ...Ht,
    toastId: vy,
    closeOnClick: !0,
    autoClose: !1,
    draggable: !0,
    icon: /* @__PURE__ */ x.createElement(gy, null),
    ...e
  });
}, Jb = (e = {}) => {
  G.isActive(pc) || (G.clearWaitingQueue(), G.dismiss(), G.error("No internet connection", {
    ...Ht,
    toastId: pc,
    closeButton: !1,
    closeOnClick: !1,
    autoClose: !1,
    draggable: !1,
    icon: /* @__PURE__ */ x.createElement(my, null),
    ...e
  }));
}, Zb = (e) => (he(() => () => G.dismiss(), []), /* @__PURE__ */ x.createElement(hy, { stacked: !0, limit: 3, ...e })), by = function(e = "", t = "") {
  return this.windowObjectReference = null, this.openNewWindow = () => {
    var r, n, o;
    if (this.windowObjectReference == null || (r = this.windowObjectReference) != null && r.closed) {
      if (B.ios()) {
        this.windowObjectReference = window.open(e, `${t}-${(/* @__PURE__ */ new Date()).toString()}`);
        return;
      }
      this.windowObjectReference = window.open(e, t);
    } else {
      if (B.ios()) {
        this.windowObjectReference.close(), this.windowObjectReference = window.open(e, t), (n = this.windowObjectReference) != null && n.focus && this.windowObjectReference.focus();
        return;
      }
      this.windowObjectReference = window.open(e, t), (o = this.windowObjectReference) != null && o.focus && this.windowObjectReference.focus();
    }
  }, () => {
    var r, n, o, a;
    if (Yu()) {
      (a = (o = (n = (r = window == null ? void 0 : window.webkit) == null ? void 0 : r.messageHandlers) == null ? void 0 : n.openBrowser) == null ? void 0 : o.postMessage) == null || a.call(o, e);
      return;
    }
    this.openNewWindow(e, t);
  };
}, wy = ({
  venueId: e,
  email: t,
  countryIsoCode: r,
  // Example: format in Malaysian English (en-MY)
  languageCode: n
}) => new by(
  // c=country iso code, l=language
  `https://www.umai.io/en/referral-program?referral=${e}&referrer_email=${t}&c=${r}&l=${n}`
), _y = ({
  amount: e = 0,
  symbol: t = "MY,MYR",
  defaultLanguage: r = "en",
  minDigits: n = 2,
  maxDigits: o = 2,
  abbreviationThreshold: a = 2e4
}) => {
  const [i, s] = (String(t) || "MY,MYR").split(",");
  let l = {
    style: "currency",
    currency: s,
    currencyDisplay: "symbol",
    minimumFractionDigits: n,
    maximumFractionDigits: o
  };
  return +e > a && (l = {
    ...l,
    notation: "compact",
    compactDisplay: "short"
  }), new Intl.NumberFormat(`${r}-${i}`, l).format(e);
}, Qb = (e = "", t = "", r = "") => {
  var n;
  return e != null && e.replaceAll ? e.replaceAll(t, r) : (n = e == null ? void 0 : e.toString()) == null ? void 0 : n.replace(new RegExp(`\\${t}`, "g"), r);
}, e0 = (e = "", t = 20) => e && e.length > t ? `${e.substring(0, t)}...` : e, t0 = ({
  venueId: e,
  email: t,
  amount: r,
  currency: n,
  countryIsoCode: o,
  defaultLanguage: a
}) => {
  const i = r ? _y({
    amount: +r,
    symbol: `${o},${n}`,
    defaultLanguage: a,
    minDigits: 2
  }) : null, s = wy({
    venueId: e,
    email: t,
    countryIsoCode: o,
    // Example: format in Malaysian English (en-MY)
    languageCode: `${a}-${o}`
  });
  return {
    rewardOffer: i,
    openReferralLink: s
  };
}, Ey = "We can't reach our servers. They should be back up shortly - if you are experiencing this issue for a prolonged time please contact your UMAI account manager.", hc = "You've found an unexpected error. Sorry about that. If you experience it repeatedly then please contact your UMAI account manager.", Cy = "Network Error: Please check your internet connection and try again. If the problem persists, don't hesitate to contact your UMAI account manager for assistance.", xy = "Not Found: We couldn't find the requested resource. It appears that the information you're looking for isn't available or has been moved.", r0 = (e) => {
  var o, a, i;
  console.error(e);
  const t = e == null ? void 0 : e.status, r = e == null ? void 0 : e.data;
  let n = hc;
  return t === 500 && (n = hc), t === 404 && (n = xy), t === 502 && (n = Ey), r != null && r.hasOwnProperty("error") && (n = (r == null ? void 0 : r.error) || ""), r != null && r.hasOwnProperty("errors") && (Array.isArray(r == null ? void 0 : r.errors) && (n = (o = r == null ? void 0 : r.errors) != null && o.length ? (a = r == null ? void 0 : r.errors) == null ? void 0 : a.join(", ") : ""), typeof (r == null ? void 0 : r.errors) == "string" && (n = (r == null ? void 0 : r.errors) || "")), (i = r == null ? void 0 : r.base) != null && i[0] && (n = r.base[0]), typeof r == "string" && (n = r), typeof e == "string" && (n = e), n === "Network Error" && (n = Cy), n;
}, n0 = (e) => typeof e == "object" && Object.keys(e).length > 0, o0 = {
  portugal: "pt",
  france: "fr",
  denmark: "da",
  germany: "de",
  default: "en"
}, vc = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed"
}, a0 = [
  vc.SUCCEEDED,
  vc.FAILED
], i0 = "en", s0 = "Asia/Singapore", l0 = "RM", c0 = "GB", u0 = "umai_help_chat_link", f0 = "https://help.letsumai.com/en/", d0 = {
  LOCAL: "LOCAL",
  DEV: "DEV",
  STAGING: "STAGING",
  PRODUCTION: "PRODUCTION"
}, p0 = "chargifyPaymentIntent", h0 = {
  EN_24: {
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      // All uppercase formats are required, even though these didn't change
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    }
  }
}, v0 = "24-hour", m0 = "12-hour", g0 = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
], y0 = "YYYY-MM-DDTHH:mm:ss.SSSZ", b0 = ["HH:mm", "HH:mm Z"], w0 = "YYYY-MM-DD", _0 = 6;
var jr = { exports: {} }, pa = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mc;
function Ty() {
  return mc || (mc = 1, function(e) {
    function t(g, v) {
      var E = g.length;
      g.push(v);
      e: for (; 0 < E; ) {
        var k = E - 1 >>> 1, q = g[k];
        if (0 < o(q, v))
          g[k] = v, g[E] = q, E = k;
        else break e;
      }
    }
    function r(g) {
      return g.length === 0 ? null : g[0];
    }
    function n(g) {
      if (g.length === 0) return null;
      var v = g[0], E = g.pop();
      if (E !== v) {
        g[0] = E;
        e: for (var k = 0, q = g.length, H = q >>> 1; k < H; ) {
          var V = 2 * (k + 1) - 1, J = g[V], z = V + 1, Q = g[z];
          if (0 > o(J, E))
            z < q && 0 > o(Q, J) ? (g[k] = Q, g[z] = E, k = z) : (g[k] = J, g[V] = E, k = V);
          else if (z < q && 0 > o(Q, E))
            g[k] = Q, g[z] = E, k = z;
          else break e;
        }
      }
      return v;
    }
    function o(g, v) {
      var E = g.sortIndex - v.sortIndex;
      return E !== 0 ? E : g.id - v.id;
    }
    if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var a = performance;
      e.unstable_now = function() {
        return a.now();
      };
    } else {
      var i = Date, s = i.now();
      e.unstable_now = function() {
        return i.now() - s;
      };
    }
    var l = [], c = [], u = 1, d = null, p = 3, f = !1, m = !1, h = !1, y = typeof setTimeout == "function" ? setTimeout : null, b = typeof clearTimeout == "function" ? clearTimeout : null, w = typeof setImmediate < "u" ? setImmediate : null;
    function O(g) {
      for (var v = r(c); v !== null; ) {
        if (v.callback === null) n(c);
        else if (v.startTime <= g)
          n(c), v.sortIndex = v.expirationTime, t(l, v);
        else break;
        v = r(c);
      }
    }
    function _(g) {
      if (h = !1, O(g), !m)
        if (r(l) !== null)
          m = !0, T();
        else {
          var v = r(c);
          v !== null && R(_, v.startTime - g);
        }
    }
    var S = !1, A = -1, P = 5, N = -1;
    function j() {
      return !(e.unstable_now() - N < P);
    }
    function F() {
      if (S) {
        var g = e.unstable_now();
        N = g;
        var v = !0;
        try {
          e: {
            m = !1, h && (h = !1, b(A), A = -1), f = !0;
            var E = p;
            try {
              t: {
                for (O(g), d = r(l); d !== null && !(d.expirationTime > g && j()); ) {
                  var k = d.callback;
                  if (typeof k == "function") {
                    d.callback = null, p = d.priorityLevel;
                    var q = k(
                      d.expirationTime <= g
                    );
                    if (g = e.unstable_now(), typeof q == "function") {
                      d.callback = q, O(g), v = !0;
                      break t;
                    }
                    d === r(l) && n(l), O(g);
                  } else n(l);
                  d = r(l);
                }
                if (d !== null) v = !0;
                else {
                  var H = r(c);
                  H !== null && R(
                    _,
                    H.startTime - g
                  ), v = !1;
                }
              }
              break e;
            } finally {
              d = null, p = E, f = !1;
            }
            v = void 0;
          }
        } finally {
          v ? M() : S = !1;
        }
      }
    }
    var M;
    if (typeof w == "function")
      M = function() {
        w(F);
      };
    else if (typeof MessageChannel < "u") {
      var I = new MessageChannel(), D = I.port2;
      I.port1.onmessage = F, M = function() {
        D.postMessage(null);
      };
    } else
      M = function() {
        y(F, 0);
      };
    function T() {
      S || (S = !0, M());
    }
    function R(g, v) {
      A = y(function() {
        g(e.unstable_now());
      }, v);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(g) {
      g.callback = null;
    }, e.unstable_continueExecution = function() {
      m || f || (m = !0, T());
    }, e.unstable_forceFrameRate = function(g) {
      0 > g || 125 < g ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : P = 0 < g ? Math.floor(1e3 / g) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return p;
    }, e.unstable_getFirstCallbackNode = function() {
      return r(l);
    }, e.unstable_next = function(g) {
      switch (p) {
        case 1:
        case 2:
        case 3:
          var v = 3;
          break;
        default:
          v = p;
      }
      var E = p;
      p = v;
      try {
        return g();
      } finally {
        p = E;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(g, v) {
      switch (g) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          g = 3;
      }
      var E = p;
      p = g;
      try {
        return v();
      } finally {
        p = E;
      }
    }, e.unstable_scheduleCallback = function(g, v, E) {
      var k = e.unstable_now();
      switch (typeof E == "object" && E !== null ? (E = E.delay, E = typeof E == "number" && 0 < E ? k + E : k) : E = k, g) {
        case 1:
          var q = -1;
          break;
        case 2:
          q = 250;
          break;
        case 5:
          q = 1073741823;
          break;
        case 4:
          q = 1e4;
          break;
        default:
          q = 5e3;
      }
      return q = E + q, g = {
        id: u++,
        callback: v,
        priorityLevel: g,
        startTime: E,
        expirationTime: q,
        sortIndex: -1
      }, E > k ? (g.sortIndex = E, t(c, g), r(l) === null && g === r(c) && (h ? (b(A), A = -1) : h = !0, R(_, E - k))) : (g.sortIndex = q, t(l, g), m || f || (m = !0, T())), g;
    }, e.unstable_shouldYield = j, e.unstable_wrapCallback = function(g) {
      var v = p;
      return function() {
        var E = p;
        p = v;
        try {
          return g.apply(this, arguments);
        } finally {
          p = E;
        }
      };
    };
  }(pa)), pa;
}
var ha = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gc;
function Oy() {
  return gc || (gc = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      function t() {
        if (j) {
          var g = e.unstable_now();
          I = g;
          var v = !0;
          try {
            e: {
              _ = !1, S && (S = !1, P(F), F = -1), O = !0;
              var E = w;
              try {
                t: {
                  for (i(g), b = n(m); b !== null && !(b.expirationTime > g && l()); ) {
                    var k = b.callback;
                    if (typeof k == "function") {
                      b.callback = null, w = b.priorityLevel;
                      var q = k(
                        b.expirationTime <= g
                      );
                      if (g = e.unstable_now(), typeof q == "function") {
                        b.callback = q, i(g), v = !0;
                        break t;
                      }
                      b === n(m) && o(m), i(g);
                    } else o(m);
                    b = n(m);
                  }
                  if (b !== null) v = !0;
                  else {
                    var H = n(h);
                    H !== null && u(
                      s,
                      H.startTime - g
                    ), v = !1;
                  }
                }
                break e;
              } finally {
                b = null, w = E, O = !1;
              }
              v = void 0;
            }
          } finally {
            v ? D() : j = !1;
          }
        }
      }
      function r(g, v) {
        var E = g.length;
        g.push(v);
        e: for (; 0 < E; ) {
          var k = E - 1 >>> 1, q = g[k];
          if (0 < a(q, v))
            g[k] = v, g[E] = q, E = k;
          else break e;
        }
      }
      function n(g) {
        return g.length === 0 ? null : g[0];
      }
      function o(g) {
        if (g.length === 0) return null;
        var v = g[0], E = g.pop();
        if (E !== v) {
          g[0] = E;
          e: for (var k = 0, q = g.length, H = q >>> 1; k < H; ) {
            var V = 2 * (k + 1) - 1, J = g[V], z = V + 1, Q = g[z];
            if (0 > a(J, E))
              z < q && 0 > a(Q, J) ? (g[k] = Q, g[z] = E, k = z) : (g[k] = J, g[V] = E, k = V);
            else if (z < q && 0 > a(Q, E))
              g[k] = Q, g[z] = E, k = z;
            else break e;
          }
        }
        return v;
      }
      function a(g, v) {
        var E = g.sortIndex - v.sortIndex;
        return E !== 0 ? E : g.id - v.id;
      }
      function i(g) {
        for (var v = n(h); v !== null; ) {
          if (v.callback === null) o(h);
          else if (v.startTime <= g)
            o(h), v.sortIndex = v.expirationTime, r(m, v);
          else break;
          v = n(h);
        }
      }
      function s(g) {
        if (S = !1, i(g), !_)
          if (n(m) !== null)
            _ = !0, c();
          else {
            var v = n(h);
            v !== null && u(
              s,
              v.startTime - g
            );
          }
      }
      function l() {
        return !(e.unstable_now() - I < M);
      }
      function c() {
        j || (j = !0, D());
      }
      function u(g, v) {
        F = A(function() {
          g(e.unstable_now());
        }, v);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var d = performance;
        e.unstable_now = function() {
          return d.now();
        };
      } else {
        var p = Date, f = p.now();
        e.unstable_now = function() {
          return p.now() - f;
        };
      }
      var m = [], h = [], y = 1, b = null, w = 3, O = !1, _ = !1, S = !1, A = typeof setTimeout == "function" ? setTimeout : null, P = typeof clearTimeout == "function" ? clearTimeout : null, N = typeof setImmediate < "u" ? setImmediate : null, j = !1, F = -1, M = 5, I = -1;
      if (typeof N == "function")
        var D = function() {
          N(t);
        };
      else if (typeof MessageChannel < "u") {
        var T = new MessageChannel(), R = T.port2;
        T.port1.onmessage = t, D = function() {
          R.postMessage(null);
        };
      } else
        D = function() {
          A(t, 0);
        };
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(g) {
        g.callback = null;
      }, e.unstable_continueExecution = function() {
        _ || O || (_ = !0, c());
      }, e.unstable_forceFrameRate = function(g) {
        0 > g || 125 < g ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : M = 0 < g ? Math.floor(1e3 / g) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return w;
      }, e.unstable_getFirstCallbackNode = function() {
        return n(m);
      }, e.unstable_next = function(g) {
        switch (w) {
          case 1:
          case 2:
          case 3:
            var v = 3;
            break;
          default:
            v = w;
        }
        var E = w;
        w = v;
        try {
          return g();
        } finally {
          w = E;
        }
      }, e.unstable_pauseExecution = function() {
      }, e.unstable_requestPaint = function() {
      }, e.unstable_runWithPriority = function(g, v) {
        switch (g) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            g = 3;
        }
        var E = w;
        w = g;
        try {
          return v();
        } finally {
          w = E;
        }
      }, e.unstable_scheduleCallback = function(g, v, E) {
        var k = e.unstable_now();
        switch (typeof E == "object" && E !== null ? (E = E.delay, E = typeof E == "number" && 0 < E ? k + E : k) : E = k, g) {
          case 1:
            var q = -1;
            break;
          case 2:
            q = 250;
            break;
          case 5:
            q = 1073741823;
            break;
          case 4:
            q = 1e4;
            break;
          default:
            q = 5e3;
        }
        return q = E + q, g = {
          id: y++,
          callback: v,
          priorityLevel: g,
          startTime: E,
          expirationTime: q,
          sortIndex: -1
        }, E > k ? (g.sortIndex = E, r(h, g), n(m) === null && g === n(h) && (S ? (P(F), F = -1) : S = !0, u(s, E - k))) : (g.sortIndex = q, r(m, g), _ || O || (_ = !0, c())), g;
      }, e.unstable_shouldYield = l, e.unstable_wrapCallback = function(g) {
        var v = w;
        return function() {
          var E = w;
          w = v;
          try {
            return g.apply(this, arguments);
          } finally {
            w = E;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(ha)), ha;
}
var yc;
function Ry() {
  return yc || (yc = 1, process.env.NODE_ENV === "production" ? jr.exports = Ty() : jr.exports = Oy()), jr.exports;
}
var va = Ry();
const pr = Symbol(), Sy = Symbol(), Ay = typeof window > "u" || /ServerSideRendering/.test(window.navigator && window.navigator.userAgent), tf = Ay ? he : hr, ky = va.unstable_runWithPriority ? (e) => {
  try {
    va.unstable_runWithPriority(va.unstable_NormalPriority, e);
  } catch (t) {
    if (t.message === "Not implemented.")
      e();
    else
      throw t;
  }
} : (e) => e(), Py = (e) => ({
  value: r,
  children: n
}) => {
  const o = ue(r), a = ue(0), [i, s] = xe(null);
  i && (i(r), s(null));
  const l = ue();
  if (!l.current) {
    const c = /* @__PURE__ */ new Set(), u = (d, p) => {
      Df(() => {
        a.current += 1;
        const f = {
          n: a.current
        };
        p != null && p.suspense && (f.n *= -1, f.p = new Promise((m) => {
          s(() => (h) => {
            f.v = h, delete f.p, m(h);
          });
        })), c.forEach((m) => m(f)), d();
      });
    };
    l.current = {
      [pr]: {
        /* "v"alue     */
        v: o,
        /* versio"n"   */
        n: a,
        /* "l"isteners */
        l: c,
        /* "u"pdate    */
        u
      }
    };
  }
  return tf(() => {
    o.current = r, a.current += 1, ky(() => {
      l.current[pr].l.forEach((c) => {
        c({
          n: a.current,
          v: r
        });
      });
    });
  }, [r]), Ca(e, {
    value: l.current
  }, n);
};
function My(e) {
  const t = Ba({
    [pr]: {
      /* "v"alue     */
      v: {
        current: e
      },
      /* versio"n"   */
      n: {
        current: -1
      },
      /* "l"isteners */
      l: /* @__PURE__ */ new Set(),
      /* "u"pdate    */
      u: (r) => r()
    }
  });
  return t[Sy] = t.Provider, t.Provider = Py(t.Provider), delete t.Consumer, t;
}
function Dy(e, t) {
  const r = ut(e)[pr];
  if (typeof process == "object" && process.env.NODE_ENV !== "production" && !r)
    throw new Error("useContextSelector requires special context");
  const {
    /* "v"alue     */
    v: {
      current: n
    },
    /* versio"n"   */
    n: {
      current: o
    },
    /* "l"isteners */
    l: a
  } = r, i = t(n), [s, l] = Ac((c, u) => {
    if (!u)
      return [n, i];
    if ("p" in u)
      throw u.p;
    if (u.n === o)
      return Object.is(c[1], i) ? c : [n, i];
    try {
      if ("v" in u) {
        if (Object.is(c[0], u.v))
          return c;
        const d = t(u.v);
        return Object.is(c[1], d) ? c : [u.v, d];
      }
    } catch {
    }
    return [...c];
  }, [n, i]);
  return Object.is(s[1], i) || l(), tf(() => (a.add(l), () => {
    a.delete(l);
  }), [a]), s[1];
}
function Ly(e) {
  const t = ut(e)[pr];
  if (typeof process == "object" && process.env.NODE_ENV !== "production" && !t)
    throw new Error("useContextUpdate requires special context");
  const {
    u: r
  } = t;
  return r;
}
const Iy = Symbol(), rf = Symbol(), er = "a", ar = "w";
let Ny = (e, t) => new Proxy(e, t);
const qa = Object.getPrototypeOf, bc = /* @__PURE__ */ new WeakMap(), qy = (e) => e && (bc.has(e) ? bc.get(e) : qa(e) === Object.prototype || qa(e) === Array.prototype), Zr = (e) => typeof e == "object" && e !== null, jy = (e) => {
  if (Array.isArray(e)) return Array.from(e);
  const t = Object.getOwnPropertyDescriptors(e);
  return Object.values(t).forEach((r) => {
    r.configurable = !0;
  }), Object.create(qa(e), t);
}, di = (e) => e[rf] || e, nf = (e, t, r, n) => {
  if (!qy(e)) return e;
  let o = n && n.get(e);
  if (!o) {
    const l = di(e);
    o = ((c) => Object.values(Object.getOwnPropertyDescriptors(c)).some((u) => !u.configurable && !u.writable))(l) ? [l, jy(l)] : [l], n == null || n.set(e, o);
  }
  const [a, i] = o;
  let s = r && r.get(a);
  return s && s[1].f === !!i || (s = ((l, c) => {
    const u = { f: c };
    let d = !1;
    const p = (m, h) => {
      if (!d) {
        let y = u[er].get(l);
        if (y || (y = {}, u[er].set(l, y)), m === ar) y[ar] = !0;
        else {
          let b = y[m];
          b || (b = /* @__PURE__ */ new Set(), y[m] = b), b.add(h);
        }
      }
    }, f = { get: (m, h) => h === rf ? l : (p("k", h), nf(Reflect.get(m, h), u[er], u.c, u.t)), has: (m, h) => h === Iy ? (d = !0, u[er].delete(l), !0) : (p("h", h), Reflect.has(m, h)), getOwnPropertyDescriptor: (m, h) => (p("o", h), Reflect.getOwnPropertyDescriptor(m, h)), ownKeys: (m) => (p(ar), Reflect.ownKeys(m)) };
    return c && (f.set = f.deleteProperty = () => !1), [f, u];
  })(a, !!i), s[1].p = Ny(i || a, s[0]), r && r.set(a, s)), s[1][er] = t, s[1].c = r, s[1].t = n, s[1].p;
}, ja = (e, t, r, n, o = Object.is) => {
  if (o(e, t)) return !1;
  if (!Zr(e) || !Zr(t)) return !0;
  const a = r.get(di(e));
  if (!a) return !0;
  if (n) {
    const s = n.get(e);
    if (s && s.n === t) return s.g;
    n.set(e, { n: t, g: !1 });
  }
  let i = null;
  try {
    for (const s of a.h || []) if (i = Reflect.has(e, s) !== Reflect.has(t, s), i) return i;
    if (a[ar] === !0) {
      if (i = ((s, l) => {
        const c = Reflect.ownKeys(s), u = Reflect.ownKeys(l);
        return c.length !== u.length || c.some((d, p) => d !== u[p]);
      })(e, t), i) return i;
    } else for (const s of a.o || []) if (i = !!Reflect.getOwnPropertyDescriptor(e, s) != !!Reflect.getOwnPropertyDescriptor(t, s), i) return i;
    for (const s of a.k || []) if (i = ja(e[s], t[s], r, n, o), i) return i;
    return i === null && (i = !0), i;
  } finally {
    n && n.set(e, { n: t, g: i });
  }
}, Fy = (e, t, r) => {
  const n = [], o = /* @__PURE__ */ new WeakSet(), a = (i, s) => {
    if (o.has(i)) return;
    Zr(i) && o.add(i);
    const l = Zr(i) && t.get(di(i));
    if (l) {
      var c, u;
      if ((c = l.h) == null || c.forEach((p) => {
        const f = `:has(${String(p)})`;
        n.push(s ? [...s, f] : [f]);
      }), l[ar] === !0) {
        const p = ":ownKeys";
        n.push(s ? [...s, p] : [p]);
      } else {
        var d;
        (d = l.o) == null || d.forEach((p) => {
          const f = `:hasOwn(${String(p)})`;
          n.push(s ? [...s, f] : [f]);
        });
      }
      (u = l.k) == null || u.forEach((p) => {
        a(i[p], s ? [...s, p] : [p]);
      });
    } else s && n.push(s);
  };
  return a(e), n;
}, $y = (e, t) => {
  const r = ue();
  he(() => {
    r.current = Fy(e, t);
  }), kc(e);
}, By = (e) => () => {
  const [, r] = Ac((u) => u + 1, 0), n = /* @__PURE__ */ new WeakMap(), o = ue(), a = ue(), i = ue();
  he(() => {
    o.current = n, a.current !== i.current && ja(a.current, i.current, n, /* @__PURE__ */ new WeakMap()) && (a.current = i.current, r());
  });
  const s = Pc((u) => (i.current = u, a.current && a.current !== u && o.current && !ja(a.current, u, o.current, /* @__PURE__ */ new WeakMap()) ? a.current : (a.current = u, u)), []), l = e(s);
  typeof process == "object" && process.env.NODE_ENV !== "production" && $y(l, n);
  const c = kt(() => /* @__PURE__ */ new WeakMap(), []);
  return nf(l, n, c);
}, Hy = (e, t) => {
  var r, n;
  typeof t == "boolean" && (console.warn("boolean option is deprecated, please specify { concurrentMode: true }"), t = {
    concurrentMode: t
  });
  const {
    stateContextName: o = "StateContainer",
    updateContextName: a = "UpdateContainer",
    concurrentMode: i
  } = t || {}, s = My((r = t) == null ? void 0 : r.defaultState), l = Ba((n = t) == null ? void 0 : n.defaultUpdate);
  s.displayName = o, l.displayName = a;
  const c = (m) => {
    const [h, y] = e(m);
    return Ca(l.Provider, {
      value: y
    }, Ca(s.Provider, {
      value: h
    }, m.children));
  }, u = (m) => {
    if (typeof process == "object" && process.env.NODE_ENV !== "production") {
      const y = m;
      m = (b) => {
        if (b === void 0)
          throw new Error("Please use <Provider>");
        return y(b);
      };
    }
    const h = Dy(s, m);
    return kc(h), h;
  }, d = By(u), p = i ? () => {
    if (typeof process == "object" && process.env.NODE_ENV !== "production" && ut(l) === void 0)
      throw new Error("Please use <Provider>");
    const m = Ly(s), h = ut(l);
    return Pc((...y) => {
      let b;
      return m(() => {
        b = h(...y);
      }), b;
    }, [m, h]);
  } : () => {
    if (typeof process == "object" && process.env.NODE_ENV !== "production" && ut(l) === void 0)
      throw new Error("Please use <Provider>");
    return ut(l);
  };
  return {
    Provider: c,
    useTrackedState: d,
    useTracked: () => [d(), p()],
    useUpdate: p,
    useSelector: u
  };
};
var of = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(o, a) {
      return o[0] === r ? (n = a, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), o = this.__entries__[n];
        return o && o[1];
      }, t.prototype.set = function(r, n) {
        var o = e(this.__entries__, r);
        ~o ? this.__entries__[o][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, o = e(n, r);
        ~o && n.splice(o, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var o = 0, a = this.__entries__; o < a.length; o++) {
          var i = a[o];
          r.call(n, i[1], i[0]);
        }
      }, t;
    }()
  );
}(), Fa = typeof window < "u" && typeof document < "u" && window.document === document, Qr = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Wy = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Qr) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), Uy = 2;
function Vy(e, t) {
  var r = !1, n = !1, o = 0;
  function a() {
    r && (r = !1, e()), n && s();
  }
  function i() {
    Wy(a);
  }
  function s() {
    var l = Date.now();
    if (r) {
      if (l - o < Uy)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(i, t);
    o = l;
  }
  return s;
}
var Yy = 20, zy = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Ky = typeof MutationObserver < "u", Gy = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Vy(this.refresh.bind(this), Yy);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Fa || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Ky ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Fa || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, o = zy.some(function(a) {
        return !!~n.indexOf(a);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), af = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var o = n[r];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, jt = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Qr;
}, sf = mn(0, 0, 0, 0);
function en(e) {
  return parseFloat(e) || 0;
}
function wc(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, o) {
    var a = e["border-" + o + "-width"];
    return n + en(a);
  }, 0);
}
function Xy(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, o = t; n < o.length; n++) {
    var a = o[n], i = e["padding-" + a];
    r[a] = en(i);
  }
  return r;
}
function Jy(e) {
  var t = e.getBBox();
  return mn(0, 0, t.width, t.height);
}
function Zy(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return sf;
  var n = jt(e).getComputedStyle(e), o = Xy(n), a = o.left + o.right, i = o.top + o.bottom, s = en(n.width), l = en(n.height);
  if (n.boxSizing === "border-box" && (Math.round(s + a) !== t && (s -= wc(n, "left", "right") + a), Math.round(l + i) !== r && (l -= wc(n, "top", "bottom") + i)), !eb(e)) {
    var c = Math.round(s + a) - t, u = Math.round(l + i) - r;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return mn(o.left, o.top, s, l);
}
var Qy = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof jt(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof jt(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function eb(e) {
  return e === jt(e).document.documentElement;
}
function tb(e) {
  return Fa ? Qy(e) ? Jy(e) : Zy(e) : sf;
}
function rb(e) {
  var t = e.x, r = e.y, n = e.width, o = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(a.prototype);
  return af(i, {
    x: t,
    y: r,
    width: n,
    height: o,
    top: r,
    right: t + n,
    bottom: o + r,
    left: t
  }), i;
}
function mn(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var nb = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = mn(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = tb(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), ob = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var n = rb(r);
      af(this, { target: t, contentRect: n });
    }
    return e;
  }()
), ab = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new of(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jt(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new nb(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jt(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new ob(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), lf = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new of(), cf = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = Gy.getInstance(), n = new ab(t, r, this);
      lf.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  cf.prototype[e] = function() {
    var t;
    return (t = lf.get(this))[e].apply(t, arguments);
  };
});
var ib = function() {
  return typeof Qr.ResizeObserver < "u" ? Qr.ResizeObserver : cf;
}(), ma, _c;
function sb() {
  if (_c) return ma;
  _c = 1;
  var e = We(), t = function() {
    return e.Date.now();
  };
  return ma = t, ma;
}
var ga, Ec;
function lb() {
  if (Ec) return ga;
  Ec = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return ga = t, ga;
}
var ya, Cc;
function cb() {
  if (Cc) return ya;
  Cc = 1;
  var e = lb(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return ya = r, ya;
}
var ba, xc;
function ub() {
  if (xc) return ba;
  xc = 1;
  var e = _r(), t = Cr(), r = "[object Symbol]";
  function n(o) {
    return typeof o == "symbol" || t(o) && e(o) == r;
  }
  return ba = n, ba;
}
var wa, Tc;
function fb() {
  if (Tc) return wa;
  Tc = 1;
  var e = cb(), t = Er(), r = ub(), n = NaN, o = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, i = /^0o[0-7]+$/i, s = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (r(c))
      return n;
    if (t(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = t(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = e(c);
    var d = a.test(c);
    return d || i.test(c) ? s(c.slice(2), d ? 2 : 8) : o.test(c) ? n : +c;
  }
  return wa = l, wa;
}
var _a, Oc;
function uf() {
  if (Oc) return _a;
  Oc = 1;
  var e = Er(), t = sb(), r = fb(), n = "Expected a function", o = Math.max, a = Math.min;
  function i(s, l, c) {
    var u, d, p, f, m, h, y = 0, b = !1, w = !1, O = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    l = r(l) || 0, e(c) && (b = !!c.leading, w = "maxWait" in c, p = w ? o(r(c.maxWait) || 0, l) : p, O = "trailing" in c ? !!c.trailing : O);
    function _(D) {
      var T = u, R = d;
      return u = d = void 0, y = D, f = s.apply(R, T), f;
    }
    function S(D) {
      return y = D, m = setTimeout(N, l), b ? _(D) : f;
    }
    function A(D) {
      var T = D - h, R = D - y, g = l - T;
      return w ? a(g, p - R) : g;
    }
    function P(D) {
      var T = D - h, R = D - y;
      return h === void 0 || T >= l || T < 0 || w && R >= p;
    }
    function N() {
      var D = t();
      if (P(D))
        return j(D);
      m = setTimeout(N, A(D));
    }
    function j(D) {
      return m = void 0, O && u ? _(D) : (u = d = void 0, f);
    }
    function F() {
      m !== void 0 && clearTimeout(m), y = 0, u = h = d = m = void 0;
    }
    function M() {
      return m === void 0 ? f : j(t());
    }
    function I() {
      var D = t(), T = P(D);
      if (u = arguments, d = this, h = D, T) {
        if (m === void 0)
          return S(h);
        if (w)
          return clearTimeout(m), m = setTimeout(N, l), _(h);
      }
      return m === void 0 && (m = setTimeout(N, l)), f;
    }
    return I.cancel = F, I.flush = M, I;
  }
  return _a = i, _a;
}
var Ea, Rc;
function db() {
  if (Rc) return Ea;
  Rc = 1;
  var e = uf(), t = Er(), r = "Expected a function";
  function n(o, a, i) {
    var s = !0, l = !0;
    if (typeof o != "function")
      throw new TypeError(r);
    return t(i) && (s = "leading" in i ? !!i.leading : s, l = "trailing" in i ? !!i.trailing : l), e(o, a, {
      leading: s,
      maxWait: a,
      trailing: l
    });
  }
  return Ea = n, Ea;
}
var pb = db();
const hb = /* @__PURE__ */ Ft(pb);
var vb = uf();
const ff = /* @__PURE__ */ Ft(vb), $a = (e, t, r) => ({
  // keeping layout fixed on mobile devices because on landscape mobile devices turns in tablet layout,
  // Moreover, exiting from fullscreen or changing back to portrait it makes it slow and jerky.. as it goes from tablet to mobile view
  mobile: e < r.tablet || Vu,
  smallMobile: e <= r.phone,
  smallHeightMobile: t <= 600,
  tabletAndAbove: e >= r.tablet,
  betweenTabletAndDesktop: e >= r.tablet && e < r.desktop,
  desktopAndAbove: e >= r.desktop,
  largeDesktop: e >= r.largeDesktop
}), { Provider: mb, useTrackedState: E0, useUpdate: gb } = Hy(
  ({ width: e, height: t, viewPorts: r = {} }) => xe($a(e, t, r)),
  { concurrentMode: !0 }
), df = ({ children: e, isWindowResizeEnable: t, container: r, viewPorts: n }) => {
  const o = ue(), a = gb();
  return he(() => {
    const i = hb((l) => {
      if (!(l != null && l.length)) return;
      const c = l[0], { width: u, height: d } = c.contentRect;
      a($a(u, d, n));
    }, 100), s = ff(() => {
      a($a(window.innerWidth, window.innerHeight, n));
    }, 200);
    return r ? (o.current = new ib(i), o.current.observe(r)) : t && window.addEventListener("resize", s), () => {
      r ? (i.cancel && i.cancel(), o.current.unobserve(r)) : t && (s.cancel && s.cancel(), window.removeEventListener("resize", s));
    };
  }, [r, t, a]), e;
};
df.propTypes = {
  children: W.node,
  isWindowResizeEnable: W.bool,
  container: W.any,
  viewPorts: W.object
};
const yb = {
  phone: 361,
  tablet: 673,
  desktop: 1025,
  largeDesktop: 1408
}, bb = ({
  isWindowResizeEnable: e = !0,
  container: t,
  customViewportBreakpoints: r,
  children: n
}) => {
  const o = kt(() => t ? t.offsetWidth : window.innerWidth, [t]), a = kt(
    () => t ? t.offsetHeight : window.innerHeight,
    [t]
  ), i = kt(
    () => ({ ...yb, ...r || {} }),
    [r]
  );
  return /* @__PURE__ */ x.createElement(mb, { container: t, width: o, height: a, viewPorts: i }, /* @__PURE__ */ x.createElement(
    df,
    {
      isWindowResizeEnable: e,
      viewPorts: i,
      container: t
    },
    n
  ));
};
bb.propTypes = {
  isWindowResizeEnable: W.bool,
  container: W.instanceOf(Element),
  customViewportBreakpoints: W.shape({
    phone: W.number,
    tablet: W.number,
    desktop: W.number,
    largeDesktop: W.number
  }),
  children: W.node
};
const C0 = () => {
  he(() => {
    const e = () => {
      const t = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--webrms-vh", `${t}px`);
    };
    return e(), window.addEventListener("resize", ff(e, 400)), () => window.removeEventListener("resize", e);
  }, []);
};
function x0({
  element: e = document.documentElement,
  isEnabled: t = !0,
  recordQuerySelector: r = "",
  removeNodeCheck: n = () => !1
}) {
  const o = (s) => s.preventDefault(), a = (s) => {
    (s.keyCode === 123 || s.shiftKey && s.ctrlKey && (s.keyCode === 73 || s.keyCode === 67 || s.keyCode === 74 || s.keyCode === 75 || s.keyCode === 83 || s.keyCode === 69 || s.keyCode === 77) || s.shiftKey && (s.keyCode === 118 || s.keyCode === 116) || s.ctrlKey && s.keyCode === 85) && s.preventDefault();
  }, i = kt(
    () => new MutationObserver((s) => {
      let l = !1;
      s.forEach((c) => {
        var u;
        // If someone tries to update any styles attributes...
        // then we can check if its attribute is updated for the record that matches
        // for the elements we want for blocked-access modal, overlay, content, then reload if it matches.
        c.type === "attributes" && ((u = c == null ? void 0 : c.target) != null && u.matches) && c.target.matches(r) && c.attributeName === "style" && (l = !0), c.removedNodes.forEach((d) => {
          n(d) && (l = !0);
        }), l && window.location.reload(!0);
      });
    }),
    [r, n]
  );
  he(() => (t && i && (document.addEventListener("contextmenu", o, !1), document.addEventListener("keydown", a, !1), i.observe(e, {
    attributes: !0,
    childList: !0,
    subtree: !0,
    attributeOldValue: !0,
    characterData: !0
  })), () => {
    t && i && (document.removeEventListener("contextmenu", o, !1), document.removeEventListener("keydown", a, !1), i.disconnect());
  }), [e, t, i]);
}
export {
  pg as ALLOWED_FILE_TYPES,
  vc as ASYNC_ACTION_STATES,
  Zb as AlertContainer,
  p0 as CHARGIFY_STORAGE_KEY,
  o0 as COUNTRY_LANGUAGE,
  Za as Checkbox,
  Rb as CheckboxButtonGroup,
  Ob as CheckboxMenu,
  Wb as CropImage,
  w0 as DATE_FORMAT,
  _0 as DAY_START_OFFSET,
  c0 as DEFAULT_COUNTRY,
  l0 as DEFAULT_CURRENCY,
  i0 as DEFAULT_LANGUAGE,
  s0 as DEFAULT_TIMEZONE,
  d0 as ENVIRONMENT,
  zu as FILE_SIZE_LIMIT,
  a0 as FINAL_ASYNC_ACTION_STATUS,
  f0 as HELP_CENTER_URL,
  u0 as HELP_CHAT_INTERCOM_ID,
  jv as ImageFallback,
  h0 as LOCALE_DATE_FORMAT,
  nu as ModalPopup,
  by as OpenNewWindow,
  Rv as PopoverContainer,
  Av as PopoverContent,
  Sv as PopoverTrigger,
  Ub as PremiumModal,
  Vb as ProIcon,
  Uf as ReleaseIcon,
  y0 as SERVER_DATE_TIME,
  b0 as SERVER_TIME,
  Cb as SkeletonLoader,
  m0 as TIME_FORMAT_12,
  v0 as TIME_FORMAT_24,
  hy as ToastContainer,
  Ji as Toggle,
  xb as Tooltip,
  bb as ViewportContextProvider,
  g0 as WEEKDAYS,
  wy as createReferralLink,
  B as device,
  $b as downloadFile,
  hg as fileReader,
  _y as formatAmountWithCurrencySymbol,
  Ab as getDataFromSessionStorage,
  ug as getDataFromStorage,
  r0 as getErrorMessage,
  t0 as getReferralRewardAndLink,
  n0 as hasError,
  Fb as isAndroidNative,
  vg as isFileOverSizeLimit,
  Ib as isIE,
  Yu as isIOSWebView,
  jb as isIphone,
  Vu as isMobileDevice,
  Lb as isMobileOrTablet,
  Nb as isSafari,
  Mb as isSmallMobileDevice,
  fi as isWebview,
  Db as largeDesktop,
  e0 as limitString,
  pc as offlineNetworkToastId,
  vy as onlineNetworkToastId,
  Bb as openDocumentOnNativeApp,
  dg as reloadNativeApp,
  Pb as removeDataFromSessionStorage,
  Sb as removeDataFromStorage,
  Qb as replaceAll,
  kb as setDataToSessionStorage,
  lc as setDataToStorage,
  qb as setWebView,
  Yb as showErrorMessage,
  Kb as showInformation,
  Jb as showOffline,
  Xb as showOnline,
  zb as showSuccessMessage,
  Gb as showWarning,
  G as toast,
  Ht as toasterConfig,
  x0 as useBlockDevTools,
  C0 as useSetViewportHeightCSS,
  E0 as useViewPortContext,
  Hb as validateImage,
  yb as viewportBreakpoints,
  Tb as withContextProvider
};
